<script setup>
// import Header from "./Header.vue"
// import MemberInformationBox from "./MemberInformationBox.vue"
// import axios from "axios"
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import BaseButton from "./UI/BaseButton.vue";
import BaseInput from "./UI/BaseInput.vue";
import ButtonSubmit from "./ButtonSubmit.vue";
import ButtonCancel from "./ButtonCancel.vue";
import BaseTooltip from "./UI/BaseTooltip.vue";
import api from "../api/api.js";
import { flashMessage } from "../functions.js";
import Swal from "sweetalert2"
import moment from "moment";
import countryCodesData from "../data/country-codes.json";
import nanpAreaCodes from "../data/nanp-area-codes.json";
import ClientApp from 'purecloud-client-app-sdk';
/* eslint-disable no-undef */
const platformClient = window.platformClient; // eslint-disable-line no-unused-vars

</script>

<template>
  <div class="flex-child">
    <div class="body-container">
      <!-- Sidebar -->
      <div class="sidebar" :class="{ 'active': isSidebarOpen }">
        <button @click="toggleSidebar" class="open-btn">
          <div v-if="isSidebarOpen">
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </div>
          <div v-else>
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </div>
        </button>
        <!-- Start of 2FA Feature Code -->
        <div class="flex-container">
          <div class="two-fa-container">
            <h4 class="two-fa-label">2FA</h4>
            <div class="flex">
              <div class="send-message-group">
                <select class="select-categories form-control-select" name="phoneSendOTP" v-model="phoneSendOTP" style="font-size: 16px;">
                  <option v-for="(phone, index) in optInCellPhones" :key="index" :value="phone" :style="{ color: '#48b02c' }">
                    {{ formatPhoneNumber(phone) }}
                  </option>
                </select>

                <!-- Button to Send SMS -->
                <ButtonSubmit @click="sendSMS" label="Send SMS with OTP"
                  style="align-self: flex-start; margin-bottom: 4px; margin-right: 10px;"
                  :disabled="!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === ''" />
              </div>
              <!-- OTP Validation Section -->
              <div class="otp-container">
                <BaseInput v-model="otpInput" placeholder="OTP" style="font-size: 16px; width: 140px" />
                <div v-if="verificationAttempted" class="verification-status">
                  <img v-if="isValid" :src="logocheck" alt="check" class="status-icon" />
                  <img v-else :src="logoclose" alt="invalid" class="status-icon" />
                </div>
              </div>
              <ButtonSubmit @click="verifyOTP" label="Validate"
                style="align-self: flex-start; margin-top: 12px; width:140px"
                :disabled="!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === ''" />
            </div>
          </div>
        </div>
        <!-- End of 2FA Feature Section -->
      </div>

      <!-- Sidebar end-->
      <header>
        <h2>Member Information</h2>
        <div>
          <div style="display: flex; justify-content: center;  gap: 10px; margin-top: -8px;" class="form">
            <a style="text-decoration: none;" id="screen-pop" class="btn-submit" @click="openDemoImage"
              :disabled="false" v-if="authStatus_num === '1' || authStatus_num === '3' || authStatus_num === '5'">
              <span class="screen-pop-lg">Go to Account </span> <font-awesome-icon class="screen-pop-sm"
                :icon="['fas', 'arrow-up-right-from-square']" />
            </a>
            <BaseButton v-else class="btn-submit" @click="mnetapplicationpop" :disabled="true">Go to Account
            </BaseButton>
            <a v-if="crmView === 'synapsys'" style="text-decoration: none;" class="btn-submit" @click.prevent="openSynapsys()">
              <span class="screen-pop-lg">Go to Synapsys </span> <font-awesome-icon class="screen-pop-sm"
                :icon="['fas', 'arrow-up-right-from-square']" />
            </a>
            <a v-if="crmView === 'servicenow'" style="text-decoration: none;" class="btn-submit" @click.prevent="openServiceNow()">
              <span class="screen-pop-lg">Go to ServiceNow </span> <font-awesome-icon class="screen-pop-sm"
                :icon="['fas', 'arrow-up-right-from-square']" />
            </a>
            <a v-if="crmView === 'dl4'" style="text-decoration: none;" class="btn-submit" @click.prevent="openDl4Screen()">
              <span class="screen-pop-lg">Go to DL4 </span> <font-awesome-icon class="screen-pop-sm"
                :icon="['fas', 'arrow-up-right-from-square']" />
            </a>
            <h2 style="display: inline-block">M01</h2>
          </div>

        </div>
      </header>

      <div id="subheader" v-if="callerInfo && callerInfo.result" class="member-info">
        <span id="subheader1">
          <div v-if="!isDealerUser">
            <span>Member Number: </span>
            <span id="label_member_number">{{
              callerInfo.result.MemberNumber || ""
            }} </span>

            <span id="logocontainer"
              v-if="callerInfo.result.MemberName && callerInfo.result.MemberNumber && callerInfo.result.MemberNumber.trim() !== ''">
              <img class="membernumber-icon" title="Valid Member Number" :src="logocheck" alt="check" />
              <button id='copymemberbtn' ref="copyMemberButton" style="cursor:pointer" @click="copyMemberToClipboard">
                <div class="ttcopymembtn">Copy to Clipboard</div><img src="../assets/clipboard_icon.png">
              </button>
              <div v-if="callerID && callerID !== 'chat' && !(callerID && callerID.includes('@'))" style="visibility: visible; display: inline-flex; align-items: center; margin-left: 8px; border-radius: 8px; overflow: hidden; border: 1px solid #0285fe; vertical-align: middle;">
                <div style="width: 40px; height: 32px; background: transparent; display: flex; align-items: center; justify-content: center;">
                  <img src="../assets/illuma.png" alt="Illuma" style="max-width: 100%; max-height: 30px; object-fit: contain;" />
                </div>
                <button id='startbtn'
                  @click="startIllumaVerification"
                  :disabled="!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === '' || !illumaShield"
                  :style="{
                    backgroundColor: (!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === '' || !illumaShield) ? '#cccccc' : '#0285fe',
                    color: (!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === '' || !illumaShield) ? '#666666' : '#ffffff',
                    cursor: (!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === '' || !illumaShield) ? 'not-allowed' : 'pointer'
                  }"
                  style="border: none; padding: 6px 12px 6px 8px; font-size: 14px; height: 32px; width: 120px; font-weight: 500; white-space: nowrap; text-align: left;">
                  Start Verification
                </button>
              </div>
              <BaseTooltip :isVisible="showTooltipMemberNumber">
                Member Number Copied
              </BaseTooltip>
            </span>

            <!-- Callback button: chat/email + member only #20260827LJR -->
            <span v-if="interactionSource && (interactionSource.toLowerCase() === 'chat' || interactionSource.toLowerCase() === 'email')"
              style="display:inline-flex; align-items:center; gap:6px; margin-left:10px; vertical-align:middle;">
              <a class="btn-submit" style="text-decoration:none; cursor:pointer; white-space:nowrap; padding:3px 10px; font-size:12px;"
                @click="openCallbackModal"
                :style="{ opacity: isCallbackLoading ? 0.5 : 1, pointerEvents: isCallbackLoading ? 'none' : 'auto' }">
                Start Callback
              </a>
              <span v-if="callbackStatus" style="font-size:11px; white-space:nowrap;"
                :style="{ color: callbackStatus === 'success' ? '#16a34a' : '#dc2626' }">
                {{ callbackStatus === 'success' ? 'Callback created' : callbackStatus }}
              </span>
            </span>

            <img
              v-if="!callerInfo.result.MemberName && callerInfo.result.MemberNumber && callerInfo.result.MemberNumber.trim() !== ''"
              class="membernumber-icon" title="Invalid Member Number" :src="logoclose" alt="invalid" />

            <div style="display: inline-block; margin-right: 20px" class="form">
            </div>
          </div>
          <div v-if="callerInfo.result && callerInfo.result.Accounts && callerInfo.result.Accounts.length">
            <span>SSN: </span>
            <span id="label_ssn">{{ activeAccount.SSN }}</span>
          </div>
          <div v-if="!isDealerUser">
            <span>Name: </span>
            <span id="label_member_name">{{ callerInfo.result.MemberName || (dl4NonMemberApplicant && dl4NonMemberApplicant.name) || "" }}</span>
            <span v-if="!callerInfo.result.MemberName && dl4NonMemberApplicant" style="font-size:12px; color:#0e5071; margin-left:6px; font-weight:600;">(DL4 Applicant)</span>
          </div>
          <!-- Dealer header fields #20260827LJR -->
          <template v-if="isDealerUser">
            <div v-if="callerInfo.result.OrganizationNumber">
              <span>Dealer Id: </span>
              <span style="font-weight:600;">{{ callerInfo.result.OrganizationNumber }}</span>
              <span v-if="isDealerVip" style="margin-left:8px; vertical-align:middle;">
                <b style="background:#0e5071; color:#fff; padding:2px 10px; border-radius:4px; font-size:13px;">Dealer VIP</b>
              </span>
            </div>
            <div v-if="callerInfo.result.OrganizationName">
              <span>Dealer Name: </span>
              <span style="font-weight:600; color:#0e5071;">{{ callerInfo.result.OrganizationName }}</span>
            </div>
            <div v-if="dealerAccountsObj && dealerAccountsObj.sms_number">
              <span>Dealer SMS Number: </span>
              <span>{{ formatPhoneNumber(dealerAccountsObj.sms_number) }}</span>
            </div>
          </template>
          <!-- Regular member header fields -->
          <template v-else>
            <div v-if="callerInfo.result.OrganizationName">
              <span>Organization: </span>
              <span style="font-weight:600; color:#0e5071;">{{ callerInfo.result.OrganizationName }}</span>
            </div>
          </template>
          <div v-if="callerInfo.result.MemberSince">
            <span>Member Since: </span>
            <span>{{ new Date(callerInfo.result.MemberSince).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }) }}</span>
          </div>
          <!-- Dealer address from Accounts payload -->
          <div v-if="isDealerUser && dealerAccountsObj && dealerAccountsObj.address" style="white-space: nowrap;">
            <span>Address: </span>
            <span style="white-space: nowrap;">{{ dealerAccountsObj.address }}</span>
          </div>
          <!-- Regular member address -->
          <div style="display:inline; white-space: nowrap;" v-if="!isDealerUser && callerInfo.result && callerInfo.result.Accounts && callerInfo.result.Accounts.length">
            <span>Address: </span>
            <span id="label_address" style="white-space: nowrap;">{{ activeAccount.Address }}</span>
          </div>
          <!-- Email hidden for dealers -->
          <div v-if="!isDealerUser && callerInfo.result && callerInfo.result.Accounts && callerInfo.result.Accounts.length">
            <span>Email: </span>
            <span id="label_email">{{ activeAccount.Email }}</span>
          </div>
          <div v-if="callerID && callerID !== 'chat' && !(callerID && callerID.includes('@'))" id="illuma-shield" style="padding: 10px 0;"></div>
        </span>
        <span id="subheader2" ref="second_subheaderHeight">
          <div>
            <span>Status: </span>
            <b><span id="authstatus_value" :style="{ color: authStatusColor }">{{
              authStatus
                }}</span></b>

            <span v-if="authStatus_num === '0'" title="Not Yet Authenticated">
              <img class="membernumber-icon" :src="logoclose" alt="invalid" />
            </span>

            <span v-if="authStatus_num === '1'" title="Authenticated Valid Credential">
              <img class="membernumber-icon" :src="logocheck" alt="check" />
            </span>

            <span v-if="authStatus_num === '2' && !callerInfo.result.FailureReason" title="Invalid Credential">
              <img class="membernumber-icon" :src="logominus" alt="invalid" />
            </span>

            <span v-show="authStatus_num === '2' && callerInfo.result.FailureReason"
              :title="callerInfo.result.FailureReason">
              <img class="membernumber-icon" :src="blackminus" alt="invalid" />
            </span>

            <span v-if="authStatus_num === '3'" title="Manually Authenticated">
              <img class="membernumber-icon" :src="logocheck" alt="check" />
            </span>

            <span v-if="authStatus_num === '4'" title="Manually Failed">
              <img class="membernumber-icon" :src="logoclose" alt="invalid" />
            </span>

            <span v-if="authStatus_num === '5'" title="Manually Authenticated by Illuma Labs">
              <img class="membernumber-icon" :src="logocheck" alt="check" />
            </span>

            <span v-if="authStatus_num === '6'" title="Manually Unauthenticated by Illuma Labs">
              <img class="membernumber-icon" :src="logoclose" alt="invalid" />
            </span>
          </div>
          <div>
            <span>Reason: </span>
            <span id="label_attempttype">{{ attemptType }}</span>
          </div>
          <div style="align-items: start;">
            <div style="padding: 8px 8px 0px 0px; margin-bottom: -5px;">
              <span v-if="callerID">Interaction source:&nbsp;&nbsp;<span v-if="callerID && callerID.includes('@')">Email</span><span v-else>{{ formattedInteractionSource }}</span></span>
              <div v-if="callerID && callerID.includes('@')" style="margin-top: 2px; padding: 8px;">Email:&nbsp;&nbsp;<span style="color: blue;">{{ callerID }}</span></div>
            </div>
            <div style="padding: 0px 8px 0px; display: flex; align-items: center; gap: 6px;" v-if="callerID === 'chat'">
              Chat session IP:
              <img v-if="flag" :src="`https://flagcdn.com/w40/${flag.toLowerCase()}.png`" :alt="flag" style="width: 20px; height: 15px;" />
              <span v-if="IPAddress">{{ IPAddress }}</span>
            </div>
            <div style="padding: 6px 8px 0px" id="phonenum_list" v-html="phonenumList"></div>
            <!-- <button v-if="callerIdFlag" id='copyidbtn' ref="copyIdToOptInButton" style="cursor:pointer"
              @click="copyIdToOptIn">
              <div style="display:flex;align-items: center;">
                <svg style="display: block;" class="arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  viewBox="0 0 24 24">
                  <path d="M13 7v-6l11 11-11 11v-6h-13v-10z" fill="grey" />
                </svg>
                <button class="copyidbtn_class">
                  Opt In</button>
                <div class="ttcopyidbtn">Copy To Opt In Field</div>
              </div>
            </button>
            <BaseTooltip :isVisible="showTooltipCallerID">
              Copied Caller ID and Pasted to Opt-In
            </BaseTooltip> -->
          </div>

          <!-- <div :style="{ padding: '10px 0', height: phonenumList ? 'auto' : '50px', width: '77%' } "> -->
        </span>
        <span id="subheader3">
          <!-- Start of Chat Bot History #20240906DM -->
          <!-- <div id="chat-bot-history" style="font-family: 'Open Sans'; min-width: 450px; min-height: 500px; max-height: 700px; overflow-y: auto;">
			<h2>Chat History</h2>
			<div v-for="message in chatBoxMessages" :key="message.id"
				:class="['message', message.user.toLowerCase()]"
				style="display: flex; flex-direction: column; justify-content: space-between;">
				<div>
				<div :class="message.user.toLowerCase()" style="font-weight: 800;">
					{{ message.user.toUpperCase() }}:
				</div>
				<div class="text">{{ message.text }}</div>
				</div>
				<div class="timestamp" style="width: 100%; display: flex; justify-content: flex-end;">{{ moment(message.timestamp).format("YYYY-MM-DD, kk:mm:ss") }}</div>
			</div>
			</div> -->
          <!-- End of Chat Bot History #20240906DM -->
          <!-- 2FA Section - MS05162024 -->
          <!-- Start of 2FA Feature Code -->

          <div class="flex-container">
            <div class="two-fa-container">
              <h4 class="two-fa-label">2FA</h4>
              <div class="flex">
                <div class="send-message-group">
                  <!-- TODO: select field should be empty if member not found -->
                  <select class="select-categories form-control-select" name="phoneSendOTP" v-model="phoneSendOTP" style="font-size: 16px;">
                    <option v-for="(phone, index) in optInCellPhones" :key="index" :value="phone" :style="{ color: '#48b02c' }">
                      {{ formatPhoneNumber(phone) }}
                    </option>
                  </select>

                  <!-- Button to Send SMS -->
                  <ButtonSubmit @click="sendSMS" label="Send SMS with OTP"
                    style="align-self: flex-start; margin-bottom: 4px; margin-right: 10px;"
                    :disabled="!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === ''" />
                </div>
                <!-- OTP Validation Section -->
                <div class="otp-container">
                  <BaseInput v-model="otpInput" placeholder="OTP" style="font-size: 16px; width: 140px" />
                  <div v-if="verificationAttempted" class="verification-status">
                    <img v-if="isValid" :src="logocheck" alt="check" class="status-icon" />
                    <img v-else :src="logoclose" alt="invalid" class="status-icon" />
                  </div>
                </div>
                <ButtonSubmit @click="verifyOTP" label="Validate"
                  style="align-self: flex-start; margin-top: 12px; width:140px"
                  :disabled="!callerInfo.result.MemberNumber || callerInfo.result.MemberNumber.trim() === ''" />
              </div>
            </div>
          </div>
          <!-- End of 2FA Feature Section -->




        </span>
      </div>

      <div id="centerdiv">

        <div class="containerdiv" id="containerdiv1">
          <div>
            <form @submit.prevent="handleSendRadio()" method="post">
              <div class="radiolist">
                <div style="display: flex;  margin-top: 13px;">
                  <input type="radio" id="account_number" name="member_type" value="account_number"
                    v-model="selectedMemberType">
                  <label for="account_number">Account Number</label>
                </div>
                <!-- TODO: update this ui. it should have a pop up that shows the list of account numbers when radio button is clicked -->
                <div style="display: flex;  margin-top: 13px;">
                  <input type="radio" id="ssn" name="member_type" value="ssn" v-model="selectedMemberType">
                  <label for="ssn">SSN</label>
                </div>
              </div>
              <div>
                <BaseInput type="text" id="member_number_or_credit_card" name="member_number_or_credit_card"
                  v-model="inputNo" class="form-control"
                  style="padding-left: 10px; font-size: 16px; margin-top: 3px; max-width: 280px"
                  :disabled="!selectedMemberType" />
              </div>
              <ButtonSubmit style="margin-top: 13.5px" label="Send" :disabled="isSendButtonDisabled" />
              <ButtonCancel style="margin-top: 10px" type="button" label="Cancel" @click="handleCancel('membernumber')"
                :disabled="!inputNo" />
            </form>
            <!-- End of Radio Button -->

            <div>
              <div>
                <!-- Dealer Users table replaces Member Information for dealers #20260827LJR -->
                <div v-if="isDealerUser" style="overflow-x:auto; max-width:100%;">
                  <br>
                  <h4>Dealer Users</h4>
                  <table id="table" class="warning-code-table" style="font-size:14px; min-width:0; width:100%;">
                    <thead>
                      <tr>
                        <th style="white-space:nowrap;">Name</th>
                        <th style="white-space:nowrap;">Email</th>
                        <th style="white-space:nowrap;">Phone Numbers</th>
                        <th style="text-align:center; width:40px;">Auth</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, idx) in dealerUsers" :key="idx">
                        <td style="white-space:nowrap;">{{ user.name }}</td>
                        <td style="word-break:break-all; max-width:120px;">{{ user.email }}</td>
                        <td style="white-space:nowrap;">
                          <div v-for="(phone, pi) in (user.ani || [])" :key="pi">{{ formatPhoneNumber(phone) }}</div>
                        </td>
                        <td style="text-align:center; width:40px;">
                          <button
                            v-if="user.secretQuestions && user.secretQuestions.length"
                            @click="openDealerSecretQuestions(user)"
                            title="View Secret Questions"
                            style="background:none; border:none; cursor:pointer; padding:0; line-height:0;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 64 64">
                              <rect x="10" y="4" width="36" height="48" rx="5" ry="5" fill="#2d3f55"/>
                              <rect x="14" y="9" width="28" height="36" rx="2" ry="2" fill="#f0f4f8"/>
                              <circle cx="28" cy="52" r="2.2" fill="#f0f4f8"/>
                              <text x="28" y="33" text-anchor="middle" font-size="22" font-weight="bold" fill="#9aafc5" font-family="serif">?</text>
                              <circle cx="46" cy="44" r="11" fill="#7a8fa6"/>
                              <polyline points="40,44 44,48 52,40" stroke="#fff" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Regular member accounts table -->
                <table v-else id="table" class="member-info-table">
                  <caption>
                    Member Information
                  </caption>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Relationship</th>
                    </tr>
                  </thead>
                  <tbody style="display: block; max-height: calc(5 * 2.5em); overflow-y: auto;">
                    <template v-if="callerInfo && callerInfo.result && callerInfo.result.Accounts && currentAccount">
                      <tr
                        v-for="(account, index) in sortedAccounts"
                        :key="index"
                        @click="account.Account !== currentAccount && handleAccountClick(account)"
                        :class="{
                          'clickable-row': account.Account !== currentAccount,
                          'disabled-row': account.Account === currentAccount
                        }"
                      >
                        <td v-if="account.Name && account.Name.trim() !== ''">
                          <span :class="{ 'account-link': account.Account !== currentAccount }">
                            {{ account.Name.toUpperCase() }}
                          </span>
                        </td>
                        <td v-if="account.Name && account.Name.trim() !== ''">
                          {{ account.type }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>

              <!-- <div style="margin-top: 30px">
            <table id="table" class="member-info-table">
              <caption>
                Security Notes
              <router-link to="/notes" style="text-decoration: none; color: #0e5071;">
                <font-awesome-icon :icon="['fas', 'circle-info']" />
              </router-link>
              </caption>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(fraudNote, index) in fraudNotes">
                  <td>{{fraudNote.NoteCategory}}</td>
                  <td>{{fraudNote.NoteText}} </td>
                </tr>
              </tbody>
            </table>
          </div> -->

            </div>
            <!-- <div v-if="isDemo" style="margin-top: 20px;"> -->
            <div style="margin-top: 20px">
            <h4>Threshold Warning</h4>

            <!-- Caller ID Usage & Flags -->
            <div>
              <div class="form-control-textarea" style="min-height: 360px; max-height: 360px; min-width: 97%; max-width: 97%; font-size: 13px; padding: 10px; box-sizing: border-box; overflow-y: auto;">

                <!-- Anomaly Flags -->
                <div v-if="callerID && callerID !== 'chat' && !callerID.includes('@') && callerIdFlags && callerIdFlags.failedAuthThisMember > 0"
                  style="display:flex; align-items:flex-start; gap:6px; padding:5px 8px; margin-bottom:10px; background:#fff5f5; border-left:3px solid #e74c3c; border-radius:3px;">
                  <span style="color:#e74c3c; flex-shrink:0;">🚩</span>
                  <span style="color:#c0392b; font-size:12px;">This caller ID has <b>{{ callerIdFlags.failedAuthThisMember }}</b> failed authentication attempt{{ callerIdFlags.failedAuthThisMember !== 1 ? 's' : '' }} on this account.</span>
                </div>

                <!-- Caller ID Usage -->
                <div v-if="callerID && callerID !== 'chat' && !callerID.includes('@') && callerIdUsage && callerIdUsage.length" style="margin-bottom: 10px;">
                  <div style="font-weight: 600; color: #333; margin-bottom: 6px;">
                    Caller ID <span style="color: #0e5071;">{{ callerID }}</span> accessed the following member numbers:
                  </div>
                  <div v-for="(row, i) in callerIdUsage" :key="i"
                    :style="{ display: 'flex', alignItems: 'center', gap: '8px', padding: '3px 8px', borderRadius: '4px', marginBottom: '2px', background: String(row.MemberNumber) === String(callerInfo && callerInfo.result && callerInfo.result.MemberNumber) ? '#e8f4fd' : '#f5f5f5' }">
                    <span style="font-weight: 600; color: #333;">{{ row.MemberNumber }}</span>
                    <span style="color: #666; font-size: 14px;">- {{ row.callCount }} {{ row.callCount === 1 ? 'time' : 'times' }}</span>
                  </div>
                </div>

                <!-- Threshold Warnings -->
                <div v-if="isGetThreshold">
                  <div v-for="(line, i) in threshold.trim().split('\n\n').filter(l => l.trim())" :key="i"
                    style="display: flex; align-items: flex-start; gap: 6px; margin-bottom: 6px; padding: 6px 8px; background: #fff5f5; border-left: 3px solid #e74c3c; border-radius: 3px;">
                    <span style="color: #c0392b; line-height: 1.4;">{{ line.trim() }}</span>
                  </div>
                </div>

                <!-- Empty state -->
                <div v-if="!isGetThreshold && !(callerID && callerID !== 'chat' && !callerID.includes('@') && callerIdUsage && callerIdUsage.length)"
                  style="color: #aaa; font-style: italic; font-size: 13px;">No warnings.</div>

              </div>
            </div>

            <!-- Old threshold textarea (hidden) -->
            <div v-if="false">
              <textarea
                v-if="isGetThreshold"
                disabled
                class="form-control-textarea"
                style="font-size: 16px; min-height: 168px; min-width: 97%; max-width: 97%; color: red"
                v-model="threshold"
                cols="15"
                rows="30"
              ></textarea>
              <textarea
                v-else
                disabled
                class="form-control-textarea"
                style="font-size: 16px; min-width: 97%; max-width: 97%;"
                cols="15"
                rows="10"
              ></textarea>
            </div>
          </div>

          </div>
        </div>

        <div class="containerdiv member-info" id="containerdiv2" v-if="callerInfo && callerInfo.result">
          <div class="member-info-content">
            <form method="post">
              <div>
                <h4>Authentication Status</h4>
                <div class="btn-auth-group" style="margin-top: 10px">
                  <button class="btn-manually-auth" :class="{ 'btn-clicked-green': AuthclickedButton === 3 }"
                    @click.prevent="passValueAuth(3,'status', $event)" :disabled="!callerInfo.result.MemberNumber ||
                      Object.keys(callerInfo.result).length === 0
                      ">
                    <span class="btn-text-large">Manually Authenticate</span>
                  </button>
                  <button class="btn-manually-failed" :class="{ 'btn-clicked-red': AuthclickedButton === 4 }"
                    @click.prevent="passValueAuth(4, 'status', $event)" :disabled="!callerInfo.result.MemberNumber ||
                      Object.keys(callerInfo.result).length === 0">
                    <span class="btn-text-large">Manually Fail</span>
                  </button>
                </div>
              </div>

              <div v-if="isLoadingAuth" style="margin-top: 10px;">
                <clip-loader :loading="true" :color="setColor" :size="setSize"></clip-loader>
              </div>
              <ButtonCancel style="margin-top: 10px" v-if="!isLoadingAuth" label="Cancel" type="button"
                @click="handleCancel('authstatus')" />
            </form>
          </div>
          <div>

          </div>
          
          <!-- CRM System Selector + panels #20260824LJR -->
          <div style="margin-top: 10px;">
            <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:8px;">
              <span class="activity-timeline-title" style="margin:0;">Activity</span>
              <!-- Custom logo dropdown — native <select> can't render images #20260824LJR -->
              <div style="position:relative; flex-shrink:0;">
                <div @click="crmDropdownOpen = !crmDropdownOpen"
                  style="display:flex; align-items:center; gap:6px; height:26px; padding:0 8px; border:1px solid #d1d5db; border-radius:4px; background:#fff; cursor:pointer; min-width:148px; font-size:12px; user-select:none;">
                  <template v-if="crmView === 'synapsys'">
                    <img :src="logoJH" style="height:16px; width:auto; object-fit:contain;" />
                    <span style="font-weight:600; color:#0e2b6b;">Synapsys</span>
                  </template>
                  <template v-else-if="crmView === 'servicenow'">
                    <img :src="logoSN" style="height:16px; width:auto; object-fit:contain;" />
                    <span style="font-weight:600; color:#3cb043;">ServiceNow</span>
                  </template>
                  <template v-else-if="crmView === 'dl4'">
                    <img :src="logoMDL" style="height:16px; width:auto; object-fit:contain;" />
                    <span style="font-weight:600; color:#0e5071;">MeridianLink DL4</span>
                  </template>
                  <span style="margin-left:auto; color:#9ca3af; font-size:10px;">▾</span>
                </div>
                <!-- Transparent backdrop so clicking outside closes the dropdown -->
                <div v-if="crmDropdownOpen" @click="crmDropdownOpen=false"
                  style="position:fixed; inset:0; z-index:199;"></div>
                <div v-show="crmDropdownOpen"
                  style="position:absolute; right:0; top:29px; background:#fff; border:1px solid #d1d5db; border-radius:6px; box-shadow:0 4px 12px rgba(0,0,0,0.12); z-index:200; min-width:160px; overflow:hidden;">
                  <div @click="crmView='synapsys'; crmDropdownOpen=false"
                    style="display:flex; align-items:center; gap:8px; padding:7px 12px; cursor:pointer; font-size:12px;"
                    :style="crmView==='synapsys' ? 'background:#f0f4ff;' : ''"
                    @mouseenter="$event.currentTarget.style.background='#f0f4ff'" @mouseleave="$event.currentTarget.style.background=crmView==='synapsys'?'#f0f4ff':''">
                    <img :src="logoJH" style="height:18px; width:auto; object-fit:contain;" />
                    <span style="font-weight:600; color:#0e2b6b;">Synapsys</span>
                  </div>
                  <div @click="crmView='servicenow'; crmDropdownOpen=false"
                    style="display:flex; align-items:center; gap:8px; padding:7px 12px; cursor:pointer; font-size:12px; border-top:1px solid #f3f4f6;"
                    :style="crmView==='servicenow' ? 'background:#f0fff0;' : ''"
                    @mouseenter="$event.currentTarget.style.background='#f0fff0'" @mouseleave="$event.currentTarget.style.background=crmView==='servicenow'?'#f0fff0':''">
                    <img :src="logoSN" style="height:18px; width:auto; object-fit:contain;" />
                    <span style="font-weight:600; color:#3cb043;">ServiceNow</span>
                  </div>
                  <div @click="crmView='dl4'; crmDropdownOpen=false"
                    style="display:flex; align-items:center; gap:8px; padding:7px 12px; cursor:pointer; font-size:12px; border-top:1px solid #f3f4f6;"
                    :style="crmView==='dl4' ? 'background:#e8f4fb;' : ''"
                    @mouseenter="$event.currentTarget.style.background='#e8f4fb'" @mouseleave="$event.currentTarget.style.background=crmView==='dl4'?'#e8f4fb':''">
                    <img :src="logoMDL" style="height:18px; width:auto; object-fit:contain;" />
                    <span style="font-weight:600; color:#0e5071;">MeridianLink DL4</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Synapsys panel -->
            <div v-if="crmView === 'synapsys'">
              <div class="activity-timeline">
                <div class="activity-timeline-header">
                  <div style="display:flex; align-items:center; gap:5px; white-space:nowrap;">
                    <span class="activity-timeline-title" style="font-size:13px; margin:0;">
                      Activity Timeline
                      <span class="activity-timeline-source">Source: <span class="activity-timeline-source-name">Synapsys</span></span>
                    </span>
                    <span title="View all" style="cursor:pointer; color:#0e5071; font-size:13px;" @click="openCrmActivity(null)">
                      <i class="fa fa-external-link-alt" aria-hidden="true"></i>
                    </span>
                  </div>
                  <select v-model="crmChannelFilter" class="select-categories form-control-select"
                    style="font-size:12px; height:26px; padding:0 4px; width:90px; flex-shrink:0;">
                    <option value="">All</option>
                    <option value="voice">Voice</option>
                    <option value="sms">SMS</option>
                    <option value="chat">Chat</option>
                  </select>
                </div>
                <div class="activity-timeline-list">
                  <div v-if="crmLoading" style="padding:12px; color:#888; font-size:13px;">Loading...</div>
                  <div v-else-if="!crmFilteredRecords.length" style="padding:12px; color:#aaa; font-size:13px;">No records found.</div>
                  <div v-for="rec in crmFilteredRecords.slice(0,5)" :key="rec.activityId"
                    class="activity-timeline-item at-clickable" @click="openCrmActivity(rec)">
                    <div class="activity-timeline-item-left">
                      <i :class="['fa', rec.channel && rec.channel.toLowerCase().includes('chat') ? 'fa-comment' : rec.channel && rec.channel.toLowerCase().includes('sms') ? 'fa-sms' : rec.channel && rec.channel.toLowerCase().includes('email') ? 'fa-envelope' : 'fa-phone']" aria-hidden="true"></i>
                      <div>
                        <div class="activity-timeline-item-title">{{ rec.activitySubject }}</div>
                        <div class="activity-timeline-item-meta">
                          {{ rec.direction }} &nbsp; agent: {{ rec.agentName || '—' }}
                          &nbsp; {{ rec.channel }}
                          <span v-if="rec.wrapupCode">&nbsp; {{ rec.wrapupCode }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="activity-timeline-item-time">
                      <i class="fa fa-clock" aria-hidden="true"></i>
                      {{ crmTimeAgo(rec.interactionDatetime) }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="parsedCrmSummary" style="margin-top: 16px; padding: 12px 14px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px;">
                <div style="font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 8px;">Recent Interactions Summary</div>
                <div v-if="parsedCrmSummary.themes && parsedCrmSummary.themes.length" style="display:flex; flex-wrap:wrap; gap:4px; margin-bottom:8px;">
                  <span class="crm-tag" v-for="(theme, i) in parsedCrmSummary.themes" :key="i">{{ theme }}</span>
                </div>
                <div style="font-size: 13px; color: #374151; white-space: pre-wrap; line-height: 1.5;">{{ parsedCrmSummary.summary }}</div>
              </div>

              <!-- Session notes -->
              <div style="margin-top: 16px;">
                <h4>Notes</h4>
                <textarea class="form-control-textarea" style="font-size: 16px; min-width: 97%; max-width: 97%;"
                  v-model="synapsysNote" cols="15" rows="5"></textarea>
                <div style="margin-top: 8px; display: flex; gap: 8px;">
                  <ButtonSubmit label="Save" :disabled="!synapsysNote.trim()" @click="saveSynapsysNote" />
                  <ButtonCancel type="button" label="Cancel" @click="synapsysNote = ''" :disabled="!synapsysNote.trim()" />
                </div>
              </div>
            </div>

            <!-- ServiceNow panel -->
            <div v-if="crmView === 'servicenow'" class="sn-incidents-wrap">
              <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:6px;">
                <div style="display:flex; align-items:center; gap:5px; white-space:nowrap;">
                  <span class="activity-timeline-title" style="font-size:13px; margin:0;">ServiceNow Incidents</span>
                  <span title="View all" style="cursor:pointer; color:#0e5071; font-size:13px;" @click="openSnListModal">
                    <i class="fa fa-external-link-alt" aria-hidden="true"></i>
                  </span>
                </div>
                <select v-model="snStateFilter" class="select-categories form-control-select"
                  style="font-size:12px; height:26px; padding:0 4px; width:100px; flex-shrink:0;">
                  <option value="">All</option>
                  <option v-for="c in snChoices.state" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
              <div v-if="snLoading" style="padding:12px; color:#888; font-size:13px;">Loading...</div>
              <div v-else-if="snError" style="padding:6px 8px; color:#c0392b; font-size:13px;">{{ snError }}</div>
              <div v-else-if="!snFilteredIncidents.length" style="padding:6px 8px; color:#aaa; font-size:13px;">No incidents found.</div>
              <div class="activity-timeline-list">
                <div v-for="inc in snFilteredIncidents.slice(0, 5)" :key="inc.sysId"
                  class="activity-timeline-item at-clickable" @click="openSnIncident(inc)">
                  <div class="activity-timeline-item-left">
                    <i class="fa fa-ticket-alt" aria-hidden="true"></i>
                    <div>
                      <div class="activity-timeline-item-title">{{ inc.number }} &mdash; {{ inc.shortDescription }}</div>
                      <div class="activity-timeline-item-meta">
                        {{ inc.state && inc.state.label }}
                        &nbsp; {{ inc.priority && inc.priority.label }}
                        &nbsp; {{ inc.contactType && inc.contactType.label }}
                      </div>
                    </div>
                  </div>
                  <div class="activity-timeline-item-time">
                    <i class="fa fa-clock" aria-hidden="true"></i>
                    {{ snTimeAgo(inc.openedAt + 'Z') }}
                  </div>
                </div>
              </div>

              <div style="margin-top:10px;">
                <ButtonSubmit label="New Incident" @click="openSnNewIncident" />
              </div>

              <div v-if="parsedSnSummary" style="margin-top: 16px; padding: 12px 14px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px;">
                <div style="font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 8px;">Recent Incidents Summary</div>
                <div v-if="parsedSnSummary.themes && parsedSnSummary.themes.length" style="display:flex; flex-wrap:wrap; gap:4px; margin-bottom:8px;">
                  <span class="crm-tag" v-for="(theme, i) in parsedSnSummary.themes" :key="i">{{ theme }}</span>
                </div>
                <div style="font-size: 13px; color: #374151; white-space: pre-wrap; line-height: 1.5;">{{ parsedSnSummary.summary }}</div>
              </div>
            </div>

            <!-- MeridianLink DL4 panel #20260824LJR -->
            <div v-if="crmView === 'dl4'">
              <div class="activity-timeline">
                <div class="activity-timeline-header">
                  <div style="display:flex; align-items:center; gap:5px; white-space:nowrap;">
                    <span class="activity-timeline-title" style="font-size:13px; margin:0;">
                      Loan Applications
                      <span class="activity-timeline-source">Source: <span class="activity-timeline-source-name">MeridianLink DL4</span></span>
                    </span>
                    <span title="View all" style="cursor:pointer; color:#0e5071; font-size:13px;" @click="openDl4Modal(null)">
                      <i class="fa fa-external-link-alt" aria-hidden="true"></i>
                    </span>
                  </div>
                  <select v-model="dl4StatusFilter" class="select-categories form-control-select"
                    style="font-size:12px; height:26px; padding:0 4px; width:120px; flex-shrink:0;">
                    <option value="">All</option>
                    <option value="Under Review">Under Review</option>
                    <option value="Approved">Approved</option>
                    <option value="Counter Offered">Counter Offered</option>
                  </select>
                </div>
                <div class="activity-timeline-list">
                  <div v-if="dl4Loading" style="padding:12px; color:#888; font-size:13px;">Loading...</div>
                  <div v-else-if="!dl4FilteredApplications.length" style="padding:12px; color:#aaa; font-size:13px;">No loan applications found.</div>
                  <div v-for="app in dl4FilteredApplications.slice(0, 5)" :key="app.id"
                    class="activity-timeline-item at-clickable" @click="openDl4Modal(app)">
                    <div class="activity-timeline-item-left">
                      <i class="fa fa-file-alt" aria-hidden="true"></i>
                      <div>
                        <div class="activity-timeline-item-title">{{ app.application_number }} &mdash; {{ app.loan_type }}</div>
                        <div class="activity-timeline-item-meta">
                          {{ app.decision_status || app.loan_status }}
                          <span v-if="isDealerUser && (app.applicant_first_name || app.applicant_last_name)">&nbsp; · &nbsp;{{ app.applicant_first_name }} {{ app.applicant_last_name }}</span>
                          <span v-else-if="!isDealerUser && app.dealer_name">&nbsp; · &nbsp;{{ app.dealer_name }}</span>
                        </div>
                        <div v-if="app.stipulations && app.stipulations.length > 0" style="margin-top:2px;">
                          <span style="background:#f3f0ff;color:#5b21b6;border:1px solid #ddd6fe;border-radius:10px;padding:1px 7px;font-size:11px;">
                            {{ app.stipulations.length }} stipulation{{ app.stipulations.length > 1 ? 's' : '' }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="activity-timeline-item-time">
                      <i class="fa fa-calendar" aria-hidden="true"></i>
                      {{ app.application_date ? app.application_date.substring(0,10) : '' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


          <!-- Member Verification Questions (Track84) - hidden for dealer callers #20260827LJR -->
          <div v-if="!isDealerUser && allQuestion.length">
            <h4>{{ questionTitle }}</h4>
            <div class="form-control-textarea" style="padding:10px; box-sizing:border-box; height:auto; min-width:97%; max-width:97%;">
              <div v-for="question in allQuestion" :key="question.QuestionId"
                @click="onClickQuestion(question, false)"
                style="display:flex; align-items:flex-start; gap:10px; padding:7px 6px; cursor:pointer; border-radius:4px; border-bottom:1px solid #f3f4f6;"
                @mouseenter="$event.currentTarget.style.background='#f5f5f5'"
                @mouseleave="$event.currentTarget.style.background=''">
                <span :style="{ color: getQuestionTextColor(question.QuestionState), fontWeight:700, fontSize:'15px', minWidth:'16px', flexShrink:0, lineHeight:'1.5', textAlign:'center' }">
                  {{ getQuestionSymbol(question.QuestionState) }}
                </span>
                <div style="font-size:13px; line-height:1.5;">
                  <div>{{ question.QuestionText }}</div>
                  <div style="color:#6b7280; font-size:12px;">Answer: {{ question.QuestionAnswer }}</div>
                </div>
              </div>

              <!-- Backup only shown when at least one main question is wrong #20260826LJR -->
              <div v-if="backupQuestion && allQuestion.some(q => q.QuestionState === 2)"
                @click="onClickQuestion(backupQuestion, true)"
                style="display:flex; align-items:flex-start; gap:10px; padding:7px 6px; cursor:pointer; border-radius:4px; margin-top:6px; border-top:1px dashed #ccc;"
                @mouseenter="$event.currentTarget.style.background='#f5f5f5'"
                @mouseleave="$event.currentTarget.style.background=''">
                <span :style="{ color: getQuestionTextColor(backupQuestion.QuestionState), fontWeight:700, fontSize:'15px', minWidth:'16px', flexShrink:0, lineHeight:'1.5', textAlign:'center' }">
                  {{ getQuestionSymbol(backupQuestion.QuestionState) }}
                </span>
                <div style="font-size:13px; line-height:1.5;">
                  <div style="font-size:11px; color:#9ca3af; margin-bottom:2px;">Backup question</div>
                  <div>{{ backupQuestion.QuestionText }}</div>
                  <div style="color:#6b7280; font-size:12px;">Answer: {{ backupQuestion.QuestionAnswer }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Dealer Secret Questions Modal #20260827LJR -->
        <div v-if="dealerSecretQModal.show"
          style="position:fixed; top:0; left:0; width:100%; height:100%; z-index:9999; display:flex; align-items:center; justify-content:center;">
          <div @click="dealerSecretQModal.show = false"
            style="position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.4);"></div>
          <div style="position:relative; background:#fff; border-radius:8px; overflow:hidden; min-width:360px; max-width:480px; z-index:1; box-shadow:0 8px 32px rgba(0,0,0,0.24);">
            <!-- Modal header -->
            <div style="background:#0e5071; padding:14px 20px; display:flex; align-items:center; justify-content:space-between;">
              <h4 style="margin:0; font-size:15px; color:#fff; font-weight:600;">Security Questions — {{ dealerSecretQModal.userName }}</h4>
              <button @click="dealerSecretQModal.show = false"
                style="background:none; border:none; cursor:pointer; font-size:20px; color:#fff; line-height:1; opacity:0.8;">×</button>
            </div>
            <!-- Modal body -->
            <div style="padding:16px 20px;">
              <div v-for="(sq, i) in dealerSecretQModal.questions" :key="i"
                style="padding:10px 12px; margin-bottom:8px; background:#f8fafc; border-left:3px solid #0e5071; border-radius:0 4px 4px 0;">
                <div style="font-size:13px; color:#6b7280; margin-bottom:3px;">Q: {{ sq.secretQuestion }}</div>
                <div style="font-size:14px; font-weight:600; color:#0e5071;">A: {{ sq.secretAnswer }}</div>
              </div>
            </div>
          </div>
        </div>


        <!-- Start Callback phone modal #20260828LJR -->
        <div v-if="callbackModal.show"
          style="position:fixed; top:0; left:0; width:100%; height:100%; z-index:9999; display:flex; align-items:center; justify-content:center;">
          <div @click="callbackModal.show = false"
            style="position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.4);"></div>
          <div style="position:relative; background:#fff; border-radius:8px; overflow:hidden; min-width:320px; max-width:400px; z-index:1; box-shadow:0 8px 32px rgba(0,0,0,0.24);">
            <div style="background:#0e5071; padding:14px 20px; display:flex; align-items:center; justify-content:space-between;">
              <h4 style="margin:0; font-size:15px; color:#fff; font-weight:600;">Start Callback</h4>
              <button @click="callbackModal.show = false"
                style="background:none; border:none; cursor:pointer; font-size:20px; color:#fff; line-height:1; opacity:0.8;">×</button>
            </div>
            <div style="padding:20px;">
              <label style="display:block; font-size:13px; font-weight:600; margin-bottom:6px; color:#374151;">Phone Number</label>
              <input
                v-model="callbackModal.phone"
                type="tel"
                placeholder="e.g. +1 312 210 0837"
                style="width:100%; box-sizing:border-box; padding:8px 10px; border:2px solid #767676; border-radius:4px; font-size:14px; box-shadow:2px 4px #ccc;"
                @keydown.enter="submitCallbackModal"
              />
              <div style="display:flex; justify-content:flex-end; gap:10px; margin-top:16px;">
                <button @click="callbackModal.show = false"
                  style="padding:6px 16px; border:1px solid #ccc; border-radius:4px; background:#fff; cursor:pointer; font-size:13px;">Cancel</button>
                <button @click="submitCallbackModal"
                  :disabled="!callbackModal.phone.trim() || isCallbackLoading"
                  style="padding:6px 16px; border:none; border-radius:4px; background:#0e5071; color:#fff; cursor:pointer; font-size:13px;"
                  :style="{ opacity: (!callbackModal.phone.trim() || isCallbackLoading) ? 0.5 : 1 }">
                  {{ isCallbackLoading ? 'Creating...' : 'Start Callback' }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="containerdiv member-info" id="containerdiv3" :style="{ marginTop: secondSubheaderheight }">

          <div id="chat-bot-history" 
            style="display: none; font-family: 'Open Sans'; min-width: 470px; min-height: 500px; max-height: 700px; overflow-y: auto;">
            <h2>Chat History</h2>
            <div v-for="message in chatBoxMessages" :key="message.id" :class="['message', message.user.toLowerCase()]"
              style="display: flex; flex-direction: column; justify-content: space-between;">
              <div>
                <!-- <div :class="message.user.toLowerCase()" style="font-weight: 800;">
					{{ message.user.toUpperCase() }}:
				</div> -->
                <div class="text">{{ message.text }}</div>
              </div>
              <div class="timestamp" style="width: 100%; display: flex; justify-content: flex-end;">{{ message.user ===
                'bot' ?
                'MNET Bot' : message.user.toUpperCase() }} {{ moment(message.timestamp).format("YYYY-MM-DD, kk:mm:ss")
                }}</div>
            </div>
          </div>

          <div class="navigation-path-container" style="margin-top: 24px">
            <h4 style="display:flex; align-items: center">Intent History</h4>
            <textarea readonly class="form-control-textarea" style="font-size: 16px; min-width: 7%; max-width: 97%"
              cols="15" rows="3" :value="Array.isArray(navigationPath) ? navigationPath.join(' → ') : ''"></textarea>
          </div>

            <div>
              <form @submit.prevent="handleNote()" style="margin-top: 0px" id="security-notes">
                <h4 style="display:flex; align-items: center">Security Notes
                  <router-link to="/notes" style="text-decoration:none">
                    <span class="numberbadge" v-if="fraudNotes.length">{{ fraudNotes.length }}</span>
                  </router-link>
                </h4>
                <div v-if="isLoadingNotes">
                  <clip-loader :loading="true" :color="setColor" :size="setSize"></clip-loader>
                </div>
                <div style="margin: 10px 0 15px" v-if="!isLoadingNotes">
                  <select class="select-categories form-control-select" name="category" v-model="category">
                    <option value="" disabled selected hidden>Note Category</option>
                    <option v-for="category in noteCategories" :key="category" :value="category">
                      {{ category }}
                    </option>
                  </select>
                </div>
                <div>
                  <label for="">Notes</label>
                  <textarea class="form-control-textarea" style="font-size: 16px; min-width: 97%; max-width: 97%"
                    v-model="notes" cols="15" rows="5"></textarea>
                </div>
                <!-- <BaseButton style="margin-top: 5px" class="btn-submit" :isDisabled="isSaveEnabled">Save</BaseButton> -->
                <ButtonSubmit style="margin-top: 10px" label="Save" :disabled="isSaveEnabled" />
                <ButtonCancel type="button" style="margin-top: 10px" label="Cancel"
                  @click="handleCancel('notecategory')" :disabled="isSaveEnabled" />
              </form>
          </div>

          <div id="warning-code-container">
            <div class="warning-code-col">
              <table id="table" class="warning-code-table">
                <caption>
                  Warning Code
                </caption>
                <thead>
                  <tr>
                    <th style="min-width: 110px">Warning Code</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <div v-if="isLoadingWarningCode">
                  <clip-loader :loading="true" :color="setColor" :size="setSize"></clip-loader>
                </div>
                <tbody v-if="
                  symitarWarningCodes &&
                  symitarWarningCodes.length &&
                  !isLoadingWarningCode
                ">
                  <tr v-for="(item, index) in symitarWarningCodes" :key="index">
                    <td style="text-align: right; width: 40px" v-if="symitarWarningCodes && symitarWarningCodes.length">
                      {{ item.WarningNumber }}
                    </td>
                    <td v-if="symitarWarningCodes && symitarWarningCodes.length">
                      {{ item.WarnDescription }}
                    </td>
                  </tr>
                </tbody>
                <!-- <tbody>
                <tr>
                  <td style="text-align: right; width: 40px">
                    001
                  </td>
                  <td>
                    Hello world
                  </td>
                </tr>
              </tbody> -->
              </table>
            </div>

          </div>

        </div>
      </div>


      <div v-if="callerInfo && callerInfo.result" class="member-info">

      </div>

      <div class="member-info-content">
        <!-- Changed the label to Radio Button - MS05212024 -->
      </div>

      <!-- CRM Activity Modal (Synapsys) -->
      <div v-if="crmView === 'synapsys'">
      <div class="crm-modal-backdrop" v-show="crmModalOpen" @click.self="closeCrmActivity">
        <div class="crm-modal">
          <!-- Header -->
          <div class="crm-modal-header">
            <div class="crm-modal-header-left">
              <i class="fa fa-phone" aria-hidden="true" style="font-size:18px;"></i>
              <div>
                <div style="font-size:12px; color:rgba(255,255,255,0.7); margin-bottom:2px;">
                  {{ crmSelected ? moment(crmSelected.interactionDatetime).format('MMM D, YYYY · h:mm A') : '' }}
                </div>
                <div style="font-size:16px; font-weight:700;">{{ crmSelected ? crmSelected.activitySubject : 'CRM Activity' }}</div>
              </div>
            </div>
            <button class="crm-modal-close" @click="closeCrmActivity">✕</button>
          </div>

          <!-- Loading -->
          <div v-if="crmLoading" style="padding:40px; text-align:center; color:#888;">
            <clip-loader :loading="true" color="#0e5071" size="36px"></clip-loader>
          </div>

          <!-- List view (no record selected) -->
          <div v-else-if="!crmSelected" class="crm-modal-body">
            <div style="display:flex; justify-content:flex-end; padding:10px 16px 4px;">
              <select v-model="crmModalChannelFilter" class="select-categories form-control-select"
                style="font-size:12px; height:26px; padding:0 4px; width:100px; flex-shrink:0;">
                <option value="">All</option>
                <option value="voice">Voice</option>
                <option value="sms">SMS</option>
                <option value="chat">Chat</option>
              </select>
            </div>
            <div v-if="!crmModalFilteredRecords.length" style="padding:24px; color:#888; text-align:center;">No activity records found.</div>
            <div v-for="rec in crmModalFilteredRecords" :key="rec.activityId"
              class="crm-list-item" @click="crmSelected = rec">
              <div class="crm-list-item-left">
                <i :class="['fa', rec.channel && rec.channel.toLowerCase().includes('chat') ? 'fa-comment' : rec.channel && rec.channel.toLowerCase().includes('sms') ? 'fa-sms' : rec.channel && rec.channel.toLowerCase().includes('email') ? 'fa-envelope' : 'fa-phone']" aria-hidden="true"></i>
                <div>
                  <div class="crm-list-title">{{ rec.activitySubject }}</div>
                  <div class="crm-list-meta">
                    {{ moment(rec.interactionDatetime).format('MMM D, YYYY · h:mm A') }}
                    &nbsp;·&nbsp; {{ rec.channel }}
                    <span class="crm-badge-inbound" v-if="rec.direction === 'Inbound'">INBOUND</span>
                    <span class="crm-badge-outbound" v-else>OUTBOUND</span>
                    &nbsp;·&nbsp; {{ rec.agentName || '—' }}
                    <span v-if="rec.wrapupCode">&nbsp;·&nbsp; <strong>{{ rec.wrapupCode }}</strong></span>
                  </div>
                  <div v-if="rec.intents && rec.intents.length" class="crm-list-intents">
                    <span class="crm-tag" v-for="(intent, i) in rec.intents" :key="i">{{ intent }}</span>
                  </div>
                </div>
              </div>
              <i class="fa fa-chevron-right" style="color:#ccc; font-size:12px; flex-shrink:0;"></i>
            </div>
          </div>

          <!-- Detail view -->
          <div v-else class="crm-modal-body">
            <button class="crm-back-btn" @click="crmSelected = null">← Back</button>
            <div class="crm-detail-grid">
              <div>
                <div class="crm-detail-label">DATE &amp; TIME</div>
                <div class="crm-detail-value">{{ moment(crmSelected.interactionDatetime).format('MMM D, YYYY · h:mm A') }}</div>
              </div>
              <div>
                <div class="crm-detail-label">QUEUE</div>
                <div class="crm-detail-value">{{ crmSelected.queueName || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">AGENT</div>
                <div class="crm-detail-value">{{ crmSelected.agentName || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">ANI</div>
                <div class="crm-detail-value">{{ crmSelected.callerId || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">DIRECTION / CHANNEL</div>
                <div class="crm-detail-value">
                  {{ crmSelected.channel }}
                  <span class="crm-badge-inbound" v-if="crmSelected.direction === 'Inbound'">INBOUND</span>
                  <span class="crm-badge-outbound" v-else>OUTBOUND</span>
                </div>
              </div>
              <div>
                <div class="crm-detail-label">DURATION</div>
                <div class="crm-detail-value">{{ crmSelected.durationSec ? Math.floor(crmSelected.durationSec/60) + ':' + String(crmSelected.durationSec%60).padStart(2,'0') : '—' }}</div>
              </div>
              <div v-if="crmSelected.sourceIp">
                <div class="crm-detail-label">IP ADDRESS</div>
                <div class="crm-detail-value">{{ crmSelected.sourceIp }}</div>
              </div>
              <div v-if="crmSelected.interactionId">
                <div class="crm-detail-label">INTERACTION ID</div>
                <div class="crm-detail-value" style="font-size:11px; word-break:break-all;">{{ crmSelected.interactionId }}</div>
              </div>
            </div>

            <div class="crm-detail-section" v-if="crmSelected.wrapupCode">
              <div class="crm-detail-label">WRAP-UP / DISPOSITION</div>
              <span class="crm-tag">{{ crmSelected.wrapupCode }}</span>
            </div>

            <div class="crm-detail-section" v-if="crmSelected.intents && crmSelected.intents.length">
              <div class="crm-detail-label">INTENT</div>
              <span class="crm-tag" v-for="(intent, i) in crmSelected.intents" :key="i">{{ intent }}</span>
            </div>

            <div class="crm-detail-section">
              <div class="crm-detail-label">SUBJECT</div>
              <div class="crm-detail-box">{{ crmSelected.activitySubject }}</div>
            </div>

            <div class="crm-detail-section" v-if="crmSelected.aiSummary">
              <div class="crm-detail-label">AI SUMMARY</div>
              <div class="crm-detail-box" style="white-space: pre-wrap;">{{ crmSelected.aiSummary }}</div>
            </div>

            <div class="crm-detail-section">
              <div class="crm-detail-label">NOTES</div>
              <div class="crm-detail-box" style="white-space: pre-wrap;">{{ parsedCrmNotes }}</div>
            </div>

            <div class="crm-modal-footer">
              <button class="crm-btn-close" @click="closeCrmActivity">Close</button>
              <!-- <button class="crm-btn-open">Open Full Record</button> -->
            </div>
          </div>
        </div>
      </div>
      </div><!-- end OLD CRM modal hidden wrapper -->

      <!-- ServiceNow Incident Detail Modal -->
      <div class="crm-modal-backdrop" v-show="snModalOpen" @click.self="closeSnIncident">
        <div class="crm-modal">
          <div class="crm-modal-header" style="background:#063248;">
            <div class="crm-modal-header-left">
              <i class="fa fa-ticket-alt" aria-hidden="true" style="font-size:18px;"></i>
              <div>
                <div style="font-size:12px; color:rgba(255,255,255,0.7); margin-bottom:2px;">{{ snSelected ? snSelected.number : 'ServiceNow Incidents' }}</div>
                <div style="font-size:16px; font-weight:700;">{{ snSelected ? snSelected.shortDescription : '' }}</div>
              </div>
            </div>
            <button class="crm-modal-close" @click="closeSnIncident">✕</button>
          </div>

          <!-- List view (no record selected) -->
          <div v-if="!snSelected" class="crm-modal-body" style="padding:16px 20px;">
            <div style="display:flex; justify-content:flex-end; margin-bottom:12px;">
              <select v-model="snModalStateFilter" class="select-categories form-control-select"
                style="font-size:12px; height:28px; padding:0 6px; width:130px;">
                <option value="">All States</option>
                <option v-for="c in snChoices.state" :key="c.value" :value="c.value">{{ c.label }}</option>
              </select>
            </div>
            <div v-if="!snModalFilteredIncidents.length" style="padding:24px; color:#888; text-align:center;">No incidents found.</div>
            <div v-for="inc in snModalFilteredIncidents" :key="inc.sysId"
              class="crm-list-item" @click="snSelected = inc">
              <div class="crm-list-item-left">
                <i class="fa fa-ticket-alt" aria-hidden="true"></i>
                <div>
                  <div class="crm-list-title">{{ inc.number }} &mdash; {{ inc.shortDescription }}</div>
                  <div class="crm-list-meta">
                    {{ inc.openedAt }}
                    &nbsp;·&nbsp; {{ inc.state && inc.state.label }}
                    &nbsp;·&nbsp; {{ inc.priority && inc.priority.label }}
                    &nbsp;·&nbsp; {{ inc.contactType && inc.contactType.label }}
                  </div>
                </div>
              </div>
              <i class="fa fa-chevron-right" style="color:#ccc; font-size:12px; flex-shrink:0;"></i>
            </div>
          </div>

          <!-- Detail view -->
          <div v-else class="crm-modal-body">
            <button class="crm-back-btn" @click="snSelected = null">← Back</button>
            <div class="crm-detail-grid">
              <div>
                <div class="crm-detail-label">STATE</div>
                <div class="crm-detail-value">{{ snSelected.state && snSelected.state.label }}</div>
              </div>
              <div>
                <div class="crm-detail-label">PRIORITY</div>
                <div class="crm-detail-value">{{ snSelected.priority && snSelected.priority.label }}</div>
              </div>
              <div>
                <div class="crm-detail-label">CATEGORY</div>
                <div class="crm-detail-value">{{ (snSelected.category && snSelected.category.label) || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">SUBCATEGORY</div>
                <div class="crm-detail-value">{{ (snSelected.subcategory && snSelected.subcategory.label) || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">CONTACT TYPE</div>
                <div class="crm-detail-value">{{ (snSelected.contactType && snSelected.contactType.label) || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">CALLER</div>
                <div class="crm-detail-value">{{ (snSelected.caller && snSelected.caller.label) || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">ASSIGNMENT GROUP</div>
                <div class="crm-detail-value">{{ (snSelected.assignmentGroup && snSelected.assignmentGroup.label) || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">ASSIGNED TO</div>
                <div class="crm-detail-value">{{ (snSelected.assignedTo && snSelected.assignedTo.label) || '—' }}</div>
              </div>
              <div>
                <div class="crm-detail-label">OPENED</div>
                <div class="crm-detail-value">{{ snSelected.openedAt }}</div>
              </div>
              <div>
                <div class="crm-detail-label">RESOLVED</div>
                <div class="crm-detail-value">{{ snSelected.resolvedAt || '—' }}</div>
              </div>
            </div>
            <div class="crm-detail-section" v-if="snSelected.shortDescription">
              <div class="crm-detail-label">SHORT DESCRIPTION</div>
              <div class="crm-detail-box">{{ snSelected.shortDescription }}</div>
            </div>
            <div class="crm-detail-section" v-if="snSelected.description">
              <div class="crm-detail-label">DESCRIPTION</div>
              <div class="crm-detail-box" style="white-space:pre-wrap;">{{ snSelected.description }}</div>
            </div>
            <div class="crm-detail-section" v-if="snParsedNotes(snSelected.comments).length">
              <div class="crm-detail-label">COMMENTS</div>
              <div v-for="(n, i) in snParsedNotes(snSelected.comments)" :key="i"
                style="border:1px solid #e0e0e0; border-radius:4px; padding:8px 10px; margin-bottom:6px; background:#fafafa;">
                <div style="font-size:11px; color:#888; margin-bottom:3px;">{{ n.header }}</div>
                <div style="font-size:13px; white-space:pre-wrap;">{{ n.body }}</div>
              </div>
            </div>
            <div class="crm-detail-section" v-if="snParsedNotes(snSelected.workNotes).length">
              <div class="crm-detail-label">WORK NOTES</div>
              <div v-for="(n, i) in snParsedNotes(snSelected.workNotes)" :key="i"
                style="border:1px solid #e0e0e0; border-radius:4px; padding:8px 10px; margin-bottom:6px; background:#fafafa;">
                <div style="font-size:11px; color:#888; margin-bottom:3px;">{{ n.header }}</div>
                <div style="font-size:13px; white-space:pre-wrap;">{{ n.body }}</div>
              </div>
            </div>
            <div class="crm-modal-footer">
              <ButtonCancel type="button" label="Close" @click="closeSnIncident" />
              <ButtonSubmit label="Edit" @click="openSnEdit" />
              <ButtonSubmit label="Add Note" @click="openSnNoteModal" />
              <ButtonSubmit label="Assign" @click="openSnAssignModal" />
              <ButtonSubmit v-if="snSelected.state && snSelected.state.value !== '6' && snSelected.state.value !== '7'" :label="snResolving ? 'Resolving…' : 'Resolve'" @click="quickResolveSnIncident" :disabled="snResolving" />
            </div>
          </div>
        </div>
      </div>

      <!-- ServiceNow New / Edit Incident Modal -->
      <div class="crm-modal-backdrop" v-show="snFormOpen" @click.self="closeSnForm">
        <div class="crm-modal" style="max-width:520px;">
          <div class="crm-modal-header" style="background:#063248;">
            <div class="crm-modal-header-left">
              <i class="fa fa-ticket-alt" aria-hidden="true" style="font-size:18px;"></i>
              <div style="font-size:16px; font-weight:700;">{{ snFormMode === 'edit' ? 'Edit Incident' : 'New Incident' }}</div>
            </div>
            <button class="crm-modal-close" @click="closeSnForm">✕</button>
          </div>
          <div class="crm-modal-body" style="padding:20px;">
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Short Description *</label>
              <input type="text" class="form-control-textarea" style="width:100%; box-sizing:border-box; font-size:14px; padding:6px 8px; min-height:unset; height:36px;"
                v-model="snForm.shortDescription" placeholder="Brief summary of the issue" />
            </div>
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Description</label>
              <textarea class="form-control-textarea" style="font-size:14px; width:100%; box-sizing:border-box; min-height:60px;"
                v-model="snForm.description" rows="3" placeholder="Detailed description"></textarea>
            </div>
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:12px;">
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Category</label>
                <select class="select-categories form-control-select" v-model="snForm.category" @change="snForm.subcategory = ''">
                  <option value=""></option>
                  <option v-for="c in snChoices.category" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Subcategory</label>
                <select class="select-categories form-control-select" v-model="snForm.subcategory">
                  <option value=""></option>
                  <option v-for="c in snSubcategoriesFiltered" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Impact</label>
                <select class="select-categories form-control-select" v-model="snForm.impact">
                  <option value=""></option>
                  <option v-for="c in snChoices.impact" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Urgency</label>
                <select class="select-categories form-control-select" v-model="snForm.urgency">
                  <option value=""></option>
                  <option v-for="c in snChoices.urgency" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
              <div v-if="snFormMode === 'edit'">
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">State</label>
                <select class="select-categories form-control-select" v-model="snForm.state">
                  <option value=""></option>
                  <option v-for="c in snChoices.state" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
            </div>
            <!-- Assignment Group dropdown -->
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:12px;">
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Assignment Group</label>
                <select class="select-categories form-control-select" v-model="snForm.assignmentGroup" @change="onSnGroupChange">
                  <option value=""></option>
                  <option v-for="g in snChoices.groups" :key="g.value" :value="g.value">{{ g.label }}</option>
                </select>
              </div>
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Assigned To</label>
                <select class="select-categories form-control-select" v-model="snForm.assignedTo" :disabled="!snForm.assignmentGroup || snAssigneeLoading">
                  <option value=""></option>
                  <option v-for="u in snChoices.assignees" :key="u.value" :value="u.value">{{ u.label }}</option>
                </select>
              </div>
            </div>
            <div v-if="snFormMode === 'edit'" style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Comments</label>
              <textarea class="form-control-textarea" style="font-size:14px; width:100%; box-sizing:border-box;"
                v-model="snForm.comments" rows="2" placeholder="Add a comment (appended)"></textarea>
            </div>
            <div v-if="snFormMode === 'edit'" style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Work Notes</label>
              <textarea class="form-control-textarea" style="font-size:14px; width:100%; box-sizing:border-box;"
                v-model="snForm.workNotes" rows="2" placeholder="Add a work note (appended)"></textarea>
            </div>
            <div v-if="snFormMode === 'edit' && (snForm.state === '6' || snForm.state === '7')" style="display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:12px;">
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Resolution Code *</label>
                <select class="select-categories form-control-select" v-model="snForm.closeCode">
                  <option value=""></option>
                  <option v-for="c in snChoices.closeCode" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
              <div>
                <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Close Notes *</label>
                <textarea class="form-control-textarea" style="font-size:14px; width:100%; box-sizing:border-box;"
                  v-model="snForm.closeNotes" rows="2" placeholder="Resolution details"></textarea>
              </div>
            </div>
            <div v-if="snFormError" style="color:#c0392b; font-size:13px; margin-bottom:10px;">{{ snFormError }}</div>
            <div class="crm-modal-footer">
              <ButtonCancel type="button" label="Cancel" :disabled="snFormSaving" @click="closeSnForm" />
              <ButtonSubmit :label="snFormSaving ? 'Saving…' : snFormMode === 'edit' ? 'Save Changes' : 'Create'"
                :disabled="snFormSaving || !snForm.shortDescription.trim()" @click="submitSnForm" />
            </div>
          </div>
        </div>
      </div>

      <!-- ServiceNow Resolve Modal -->
      <div class="crm-modal-backdrop" v-show="snResolveOpen" @click.self="closeSnResolve">
        <div class="crm-modal" style="max-width:420px;">
          <div class="crm-modal-header" style="background:#063248;">
            <div class="crm-modal-header-left">
              <i class="fa fa-check-circle" aria-hidden="true" style="font-size:18px;"></i>
              <div style="font-size:16px; font-weight:700;">Resolve Incident</div>
            </div>
            <button class="crm-modal-close" @click="closeSnResolve">✕</button>
          </div>
          <div class="crm-modal-body" style="padding:20px;">
            <div v-if="snSelected" style="margin-bottom:16px; font-size:13px; color:#555;">
              <strong>{{ snSelected.number }}</strong> — {{ snSelected.shortDescription }}
            </div>
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Resolution Code *</label>
              <select class="select-categories form-control-select" v-model="snResolveCode">
                <option value=""></option>
                <option v-for="c in snChoices.closeCode" :key="c.value" :value="c.value">{{ c.label }}</option>
              </select>
            </div>
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Close Notes *</label>
              <textarea class="form-control-textarea" style="font-size:14px; width:100%; box-sizing:border-box;"
                v-model="snResolveNotes" rows="3" placeholder="Describe how the issue was resolved"></textarea>
            </div>
            <div v-if="snResolveError" style="color:#c0392b; font-size:13px; margin-bottom:10px;">{{ snResolveError }}</div>
            <div class="crm-modal-footer">
              <ButtonCancel type="button" label="Cancel" :disabled="snResolving" @click="closeSnResolve" />
              <ButtonSubmit :label="snResolving ? 'Resolving…' : 'Resolve'" :disabled="snResolving" @click="submitSnResolve" />
            </div>
          </div>
        </div>
      </div>

      <!-- ServiceNow Add Note Modal -->
      <div class="crm-modal-backdrop" v-show="snNoteOpen" @click.self="closeSnNote">
        <div class="crm-modal" style="max-width:460px;">
          <div class="crm-modal-header" style="background:#063248;">
            <div class="crm-modal-header-left">
              <i class="fa fa-sticky-note" aria-hidden="true" style="font-size:18px;"></i>
              <div style="font-size:16px; font-weight:700;">Add Note</div>
            </div>
            <button class="crm-modal-close" @click="closeSnNote">✕</button>
          </div>
          <div class="crm-modal-body" style="padding:20px;">
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Comment</label>
              <textarea class="form-control-textarea" style="font-size:14px; width:100%; box-sizing:border-box;"
                v-model="snNoteComment" rows="3" placeholder="Visible to caller (appended)"></textarea>
            </div>
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Work Note</label>
              <textarea class="form-control-textarea" style="font-size:14px; width:100%; box-sizing:border-box;"
                v-model="snNoteWorkNote" rows="3" placeholder="Internal only (appended)"></textarea>
            </div>
            <div v-if="snNoteError" style="color:#c0392b; font-size:13px; margin-bottom:10px;">{{ snNoteError }}</div>
            <div class="crm-modal-footer">
              <ButtonCancel type="button" label="Cancel" :disabled="snNoteSaving" @click="closeSnNote" />
              <ButtonSubmit :label="snNoteSaving ? 'Saving…' : 'Save Note'" :disabled="snNoteSaving || (!snNoteComment.trim() && !snNoteWorkNote.trim())" @click="submitSnNote" />
            </div>
          </div>
        </div>
      </div>

      <!-- ServiceNow Assign Modal -->
      <div class="crm-modal-backdrop" v-show="snAssignOpen" @click.self="closeSnAssign">
        <div class="crm-modal" style="max-width:420px;">
          <div class="crm-modal-header" style="background:#063248;">
            <div class="crm-modal-header-left">
              <i class="fa fa-user" aria-hidden="true" style="font-size:18px;"></i>
              <div style="font-size:16px; font-weight:700;">Assign Incident</div>
            </div>
            <button class="crm-modal-close" @click="closeSnAssign">✕</button>
          </div>
          <div class="crm-modal-body" style="padding:20px;">
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Assignment Group</label>
              <select class="select-categories form-control-select" v-model="snAssignGroup" @change="onSnAssignGroupChange">
                <option value=""></option>
                <option v-for="g in snChoices.groups" :key="g.value" :value="g.value">{{ g.label }}</option>
              </select>
            </div>
            <div style="margin-bottom:12px;">
              <label style="font-size:13px; font-weight:600; display:block; margin-bottom:4px;">Assigned To</label>
              <select class="select-categories form-control-select" v-model="snAssignTo" :disabled="!snAssignGroup || snAssigneeLoading">
                <option value=""></option>
                <option v-for="u in snChoices.assignees" :key="u.value" :value="u.value">{{ u.label }}</option>
              </select>
            </div>
            <div v-if="snAssignError" style="color:#c0392b; font-size:13px; margin-bottom:10px;">{{ snAssignError }}</div>
            <div class="crm-modal-footer">
              <ButtonCancel type="button" label="Cancel" :disabled="snAssignSaving" @click="closeSnAssign" />
              <ButtonSubmit :label="snAssignSaving ? 'Saving…' : 'Assign'" :disabled="snAssignSaving || !snAssignGroup" @click="submitSnAssign" />
            </div>
          </div>
        </div>
      </div>

      <!-- MeridianLink DL4 Application Modal #20260824LJR -->
      <div class="crm-modal-backdrop" v-show="dl4ModalOpen" @click.self="closeDl4Modal">
        <div class="crm-modal">
          <div class="crm-modal-header" style="background:#063248;">
            <div class="crm-modal-header-left">
              <i class="fa fa-file-alt" aria-hidden="true" style="font-size:18px;"></i>
              <div>
                <div style="font-size:12px; color:rgba(255,255,255,0.7); margin-bottom:2px;">MeridianLink DL4</div>
                <div style="font-size:16px; font-weight:700;">{{ dl4Selected ? dl4Selected.application_number + ' — ' + dl4Selected.loan_type : 'Loan Applications' }}</div>
              </div>
            </div>
            <button class="crm-modal-close" @click="closeDl4Modal">✕</button>
          </div>

          <!-- List view -->
          <div v-if="!dl4Selected" class="crm-modal-body">
            <div style="display:flex; justify-content:flex-end; padding:10px 16px 4px;">
              <select v-model="dl4StatusFilter" class="select-categories form-control-select"
                style="font-size:12px; height:26px; padding:0 4px; width:130px; flex-shrink:0;">
                <option value="">All</option>
                <option value="Under Review">Under Review</option>
                <option value="Approved">Approved</option>
                <option value="Counter Offered">Counter Offered</option>
              </select>
            </div>
            <div v-if="dl4Loading" style="padding:40px; text-align:center; color:#888;">Loading...</div>
            <div v-else-if="!dl4FilteredApplications.length" style="padding:24px; color:#888; text-align:center;">No loan applications found.</div>
            <div v-for="app in dl4FilteredApplications" :key="app.id"
              class="crm-list-item" @click="dl4Selected = app">
              <div class="crm-list-item-left">
                <i class="fa fa-file-alt" aria-hidden="true"></i>
                <div>
                  <div class="crm-list-title">{{ app.application_number }} — {{ app.loan_type }}</div>
                  <div class="crm-list-meta">
                    {{ app.application_date ? app.application_date.substring(0,10) : '' }}
                    &nbsp;·&nbsp; {{ app.decision_status || app.application_status }}
                    <span v-if="isDealerUser && (app.applicant_first_name || app.applicant_last_name)">&nbsp;·&nbsp; {{ app.applicant_first_name }} {{ app.applicant_last_name }}</span>
                    <span v-else-if="!isDealerUser && app.dealer_name">&nbsp;·&nbsp; {{ app.dealer_name }}</span>
                  </div>
                  <div v-if="app.stipulations && app.stipulations.length > 0" style="margin-top:3px;">
                    <span style="background:#f3f0ff;color:#5b21b6;border:1px solid #ddd6fe;border-radius:10px;padding:1px 8px;font-size:11px;">
                      {{ app.stipulations.length }} stipulation{{ app.stipulations.length > 1 ? 's' : '' }}
                    </span>
                  </div>
                </div>
              </div>
              <i class="fa fa-chevron-right" style="color:#ccc; font-size:12px; flex-shrink:0;"></i>
            </div>
          </div>

          <!-- Detail view -->
          <div v-else class="crm-modal-body">
            <button class="crm-back-btn" @click="dl4Selected = null">← Back</button>
            <div class="crm-detail-grid">
              <div>
                <div class="crm-detail-label">Application Number</div>
                <div class="crm-detail-value">{{ dl4Selected.application_number }}</div>
              </div>
              <div>
                <div class="crm-detail-label">Loan Type</div>
                <div class="crm-detail-value">{{ dl4Selected.loan_type }}</div>
              </div>
              <div v-if="dl4Selected.vehicle">
                <div class="crm-detail-label">Vehicle</div>
                <div class="crm-detail-value">{{ dl4Selected.vehicle }}</div>
              </div>
              <div v-if="dl4Selected.application_status">
                <div class="crm-detail-label">Status</div>
                <div class="crm-detail-value">{{ dl4Selected.application_status }}</div>
              </div>
              <div v-if="dl4Selected.funding_status">
                <div class="crm-detail-label">Funding Status</div>
                <div class="crm-detail-value">{{ dl4Selected.funding_status }}</div>
              </div>
              <div>
                <div class="crm-detail-label">Decision</div>
                <div class="crm-detail-value" :style="dl4Selected.decision_status === 'Approved' ? 'color:#16a34a; font-weight:700;' : ''">
                  <i v-if="dl4Selected.decision_status === 'Approved'" class="fa fa-check-circle" style="margin-right:5px;"></i>{{ dl4Selected.decision_status }}
                </div>
              </div>
              <div v-if="dl4Selected.approved_amount">
                <div class="crm-detail-label">Amount</div>
                <div class="crm-detail-value">${{ Number(dl4Selected.approved_amount).toLocaleString() }}</div>
              </div>
              <div v-if="dl4Selected.approved_apr">
                <div class="crm-detail-label">APR</div>
                <div class="crm-detail-value">{{ dl4Selected.approved_apr }}%</div>
              </div>
              <div v-if="dl4Selected.approved_term">
                <div class="crm-detail-label">Term</div>
                <div class="crm-detail-value">{{ dl4Selected.approved_term }} months</div>
              </div>
              <div v-if="dl4Selected.dealer_name">
                <div class="crm-detail-label">Dealer</div>
                <div class="crm-detail-value">{{ dl4Selected.dealer_name }}</div>
              </div>
              <div v-if="dl4Selected.loan_officer">
                <div class="crm-detail-label">Loan Officer</div>
                <div class="crm-detail-value">{{ dl4Selected.loan_officer }}</div>
              </div>
              <div v-if="dl4Selected.decision_status === 'Approved' && dl4Selected.decisioned_by">
                <div class="crm-detail-label">Decisioned By</div>
                <div class="crm-detail-value">{{ dl4Selected.decisioned_by }}</div>
              </div>
              <div v-if="dl4Selected.application_date">
                <div class="crm-detail-label">Application Date</div>
                <div class="crm-detail-value">{{ dl4Selected.application_date.substring(0,10) }}</div>
              </div>
              <div v-if="dl4Selected.last_activity">
                <div class="crm-detail-label">Last Activity</div>
                <div class="crm-detail-value">{{ dl4Selected.last_activity.substring(0,10) }}</div>
              </div>
            </div>
            <div v-if="dl4Selected.is_counter_offer" class="crm-detail-section">
              <div class="crm-detail-label">Counter Offer</div>
              <div class="crm-detail-box">Required down payment: ${{ Number(dl4Selected.required_down_payment).toLocaleString() }}</div>
            </div>
            <div class="crm-detail-section">
              <div class="crm-detail-label">Applicant</div>
              <div class="crm-detail-value">{{ dl4Selected.applicant_first_name }} {{ dl4Selected.applicant_last_name }}</div>
            </div>
            <!-- Required Documents (stipulations) #20260904LJR -->
            <div class="crm-detail-section">
              <div class="crm-detail-label">Required Stipulations</div>
              <div v-if="dl4Selected.stipulations && dl4Selected.stipulations.length > 0" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:8px;">
                <span v-for="(doc, i) in dl4Selected.stipulations" :key="i"
                  style="background:#f3f0ff;color:#5b21b6;border:1px solid #ddd6fe;border-radius:12px;padding:2px 10px;font-size:12px;display:flex;align-items:center;gap:6px;">
                  {{ typeof doc === 'string' ? doc : doc.name ?? doc.document }}
                  <span @click="removeDl4Stipulation(i)" style="cursor:pointer;color:#7c3aed;font-weight:700;line-height:1;" title="Remove">×</span>
                </span>
              </div>
              <div v-else style="font-size:12px;color:#888;margin-bottom:8px;">No documents required yet.</div>
              <div style="display:flex;gap:6px;align-items:center;">
                <input v-model="dl4StipulationInput" @keyup.enter="addDl4Stipulation"
                  placeholder="e.g. Most recent pay stub"
                  style="flex:1;border:1px solid #ccc;border-radius:6px;padding:4px 8px;font-size:13px;" />
                <button @click="addDl4Stipulation"
                  :disabled="!dl4StipulationInput || dl4StipulationInput.trim() === '' || dl4StipulationAddLoading"
                  style="background:#7c3aed;color:#fff;border:none;border-radius:6px;padding:4px 12px;font-size:13px;cursor:pointer;white-space:nowrap;"
                  :style="{ opacity: (!dl4StipulationInput || dl4StipulationAddLoading) ? 0.5 : 1 }">
                  {{ dl4StipulationAddLoading ? '...' : 'Add' }}
                </button>
              </div>
              <div v-if="dl4StipulationAddError" style="font-size:12px;color:#dc2626;margin-top:4px;">{{ dl4StipulationAddError }}</div>
            </div>
            <div class="crm-modal-footer" style="flex-wrap:wrap; gap:8px;">
              <button class="crm-btn-close" @click="closeDl4Modal">Close</button>
              <button class="crm-btn-open" @click="openDl4Screen">Open in DL4</button>
              <!-- Approve button: only when not already approved #20260902LJR -->
              <button v-if="dl4Selected && dl4Selected.decision_status !== 'Approved'"
                class="crm-btn-open"
                style="background:#16a34a; border-color:#16a34a;"
                :style="{ opacity: dl4ApproveLoading ? 0.6 : 1, cursor: dl4ApproveLoading ? 'default' : 'pointer' }"
                :disabled="dl4ApproveLoading"
                @click="approveDl4Application">
                {{ dl4ApproveLoading ? 'Approving...' : 'Approve' }}
              </button>
              <span v-if="dl4ApproveStatus" style="font-size:12px; align-self:center;"
                :style="{ color: dl4ApproveStatus === 'success' ? '#16a34a' : '#dc2626' }">
                {{ dl4ApproveStatus === 'success' ? 'Approved & SMS sent to dealer' : dl4ApproveStatus }}
              </span>
              <!-- Send Stipulation Link button: only when application has stipulations #20260904LJR -->
              <button v-if="dl4Selected && dl4Selected.stipulations && dl4Selected.stipulations.length > 0"
                class="crm-btn-open"
                style="background:#7c3aed; border-color:#7c3aed;"
                :style="{ opacity: dl4StipulationLoading ? 0.6 : 1, cursor: dl4StipulationLoading ? 'default' : 'pointer' }"
                :disabled="dl4StipulationLoading"
                @click="sendDl4Stipulation">
                {{ dl4StipulationLoading ? 'Sending...' : 'Send Stipulation Link' }}
              </button>
              <span v-if="dl4StipulationStatus" style="font-size:12px; align-self:center;"
                :style="{ color: dl4StipulationStatus.startsWith('success') ? '#7c3aed' : '#dc2626' }">
                {{ dl4StipulationStatus.startsWith('success') ? 'Stipulation link sent to ' + (dl4StipulationStatus.split(':')[1] || 'loan officer') : dl4StipulationStatus }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- modal mnet core client  -->
      <div class="modal" v-show="isOpenMnet" @click="closeModal">
        <div class="modal-content" @click.stop>
          <img class="modal-image" :src="logoPath" alt="MNET Core Access" />
        </div>
      </div>

      <dialog :open="modalOpen">
        <div class="dialog-backdrop"></div>
        <div class="dialog-body">
          <form method="dialog">
            <h4>Select an account number below then click Send</h4>
            <form @submit.prevent="handleSendRadio()">
              <select :disabled="!accountNumbers.length" class="select-categories form-control-select"
                name="accountNumbers" v-model="accountNumberSelected">
                <option value="" disabled selected hidden></option>
                <option v-for="accountNumber in accountNumbers" :key="accountNumber" :value="accountNumber">
                  {{ accountNumber }}
                </option>
              </select>
              <!-- <BaseButton style="margin-top: 5px" class="btn-submit" :isDisabled="isSaveEnabled">Save</BaseButton> -->
              <ButtonSubmit style="margin-top: 10px" label="Send" :disabled="isAccountNumberSendButtonDisabled" />
              <ButtonCancel type="button" style="margin-top: 10px" label="Cancel" @click="handleCancel('accountnumber')"
                :disabled="isAccountNumberSendButtonDisabled" />
            </form>
            <div class="button-group" style="margin-top: 20px">
              <ButtonSubmit label="Close" @click="modalOpen = false" />
            </div>
          </form>
        </div>
      </dialog>

    </div>
  </div>

</template>

<script>
export default {
  name: "MemberInformation",

  data: () => ({
    chatBoxMessages: [],
    company: localStorage.getItem("companyID"),
    queueId: '',
    crmView: 'synapsys',
    crmDropdownOpen: false,
    // Track84 knowledge-based auth questions #20260826LJR
    questionType: { track84: 'track84' },
    allQuestion: [],
    backupQuestion: null,
    // Dealer secret questions modal #20260827LJR
    dealerSecretQModal: { show: false, userName: '', questions: [] },
    // Callback #20260827LJR
    isCallbackLoading: false,
    callbackStatus: null,
    callbackModal: { show: false, phone: '' },
    // DL4 approval #20260902LJR
    dl4ApproveLoading: false,
    dl4ApproveStatus: null,
    // DL4 stipulation SMS #20260904LJR
    dl4StipulationLoading: false,
    dl4StipulationStatus: null,
    // DL4 add stipulation #20260904LJR
    dl4StipulationInput: '',
    dl4StipulationAddLoading: false,
    dl4StipulationAddError: null,
    setColor: "#007bff",
    setSize: "50px",
    isLoading: true,
    isLoadingWarningCode: true,
    isLoadingNotes: false,
    isLoadingAuth: false,
    isSidebarOpen: false,
    phonenumList: "",
    category: "",
    notes: "",
    inputNo: "",
    authToken: localStorage.getItem("authToken"),
    companyID: "",
    authResult: "",
    AuthclickedButton: null,
    prevAuthclickedButton: null,
    authRevertTo: null,
    userWarningCodes: [],
    symitarWarningCodes: [],
    noteCategories: [], // Store the note categories
    authStatus: "",
    authStatusColor: "",
    attemptType: "",
    authStatus_num: "",
    callerInfo: {
      status: "",
      message: "",
      result: {},
    },
    authCall: {
      status: "",
      message: "",
      result: {},
    },
    updateCall: {
      status: "",
      message: "",
      field_updated: "",
      result: {},
    },
    updateCallerInfo: {
      status: "",
      message: "",
      field_updated: "",
      result: {},
    },
    warningCodes: {
      status: "",
      num_rows: "",
      result: [],
    },
    accountNumbers: [],
    accountNumberSelected: '',
    isOpenMnet: false,
    logoPath: require("@/assets/mnetCoreClient.jpg"),
    logoJH: require("@/assets/JH.png"),
    logoMDL: require("@/assets/MDL.png"),
    logoSN: require("@/assets/SN.png"),
    logocheck: require("@/assets/check.png"),
    logoclose: require("@/assets/close.png"),
    logominus: require("@/assets/minus.png"),
    blackminus: require("@/assets/blackminus.png"),
    modalOpen: false,
    MaxNumCallsCaller: null,
    NumHoursCaller: null,
    isGetThreshold: false,
    isDemo: false,
    callerID: null,
    threshold: "",
    // Adding the data for sending SMS with OTP - MS05142024
    phoneSendOTP: "",
    otpInput: "",
    verificationAttempted: false,
    isValid: false,
    enrolledNumbers: [],
    formatNumber: "",
    // Adding the Radio Function
    selectedMemberType: null,
    // Add Country Codes
    countryCodes: [],
    selectedCountryCode: '+1',
    manualInputOptInNumber: '',
    cellPhones: [],
    optInCellPhones: [],
    optInPhoneNumberSelected: '',
    fraudNotes: [],
    callerIdFlag: false,
    showTooltipCallerID: false,
    showTooltipMemberNumber: false,
    second_subheaderHeight: '',
    SOURCETYPE_CHAT: 'chat',
    thresholdCounterData : [],
    illumaShield: null,
    coreSystemType: "Demo",
    IPAddress: "",
    flag: "",
    callerIdCountryFlag: "",
    interactionSource: "",
    navigationPath: [],
    currentAccount: "",
    synapsysNote: "",
    crmModalOpen: false,
    crmLoading: false,
    crmRecords: [],
    crmSelected: null,
    crmChannelFilter: '',
    crmModalChannelFilter: '',
    // MeridianLink DL4 #20260824LJR
    dl4Applications: [],
    dl4Loading: false,
    dl4Selected: null,
    dl4ModalOpen: false,
    dl4StatusFilter: '',
    dl4NonMemberApplicant: null,
    callerIdUsage: [],
    callerIdFlags: null,
    // ServiceNow
    snIncidents: [],
    snLoading: false,
    snError: null,
    snModalOpen: false,
    snSelected: null,
    snChoices: { category: [], subcategory: [], impact: [], urgency: [], state: [], closeCode: [], groups: [], assignees: [] },
    snFormOpen: false,
    snFormMode: 'new',
    snForm: { shortDescription: '', description: '', category: '', subcategory: '', impact: '', urgency: '', state: '', comments: '', workNotes: '', closeCode: '', closeNotes: '', assignmentGroup: '', assignedTo: '' },
    snStateFilter: '',
    snModalStateFilter: '',
    snAssigneeLoading: false,
    snFormSaving: false,
    snNoteOpen: false,
    snNoteComment: '',
    snNoteWorkNote: '',
    snNoteSaving: false,
    snNoteError: null,
    snAssignOpen: false,
    snAssignGroup: '',
    snAssignTo: '',
    snAssignSaving: false,
    snAssignError: null,
    snResolving: false,
    snResolveOpen: false,
    snResolveCode: '',
    snResolveNotes: '',
    snResolveError: null,
    snFormError: null,
  }),
  props: {
    userData: Object,
    brandData: Object,
  },
  async mounted() {
    /* console.log("Callerinfo", this.callerInfo.result.data); */
    // console.log("joint", this.JointOwnersData)

    this.setColor = this.brandData.accent_color1;
    // /* console.log("brandData", this.brandData.main_color1); */

    /* console.log(this.company); */
    if (this.$route.query.AuthToken) {
      this.authToken = this.$route.query.AuthToken;
    } else {
      this.authToken = localStorage.getItem("authToken");
    }
    this.queueId = this.$route.query.QueueId || '';
    this.crmView = this.useServiceNow ? 'servicenow' : 'synapsys';
    // this.getCountryCode()
    // await this.isDemoURL()
    const interactionID = await this.GetCallerInfoUsingAuthToken();
    await this.getChatBoxMessages(interactionID);
    await this.getThreshold();
    await Promise.all([
        this.getCoreSystemType(),
        this.getThresholdCounter(),
        this.getThresholdCounterMember(),
        this.getThresholdCounterIPAddress(),
        this.fetchNotesCategory(),
        this.loadCrmRecords(),
        this.loadCallerIdUsage(),
        this.loadCallerIdFlags(),
        this.loadSnIncidents(),
        this.loadSnChoices(),
        this.loadDl4Applications(),
        this.generateCrmSummary(),
        this.generateSnSummary(),
    ]);

    // Initialize Illuma Shield
    let queryString = '';
    if (window.location.search.length !== 0) {
      queryString = window.location.search.substring(1);
    } else if (window.location.hash.length !== 0) {
      const hashParts = window.location.hash.split('?');
      if (hashParts.length > 1) {
        queryString = hashParts[1];
      }
    }

    const searchParams = new URLSearchParams(queryString);
    const finalPcEnvironment = searchParams.get('pcEnvironment') || this.$route.query.pcEnvironment;
    const finalPcConversationId = searchParams.get('pcConversationId') || this.$route.query.pcConversationId;

    if (!finalPcEnvironment || !finalPcConversationId) {

      return;
    }

    try {
      const user = await this.illumaAuth();
      if (user) {
        const sdk = await window.illumaShield.genesys({
          user: {
            operatorId: process.env.VUE_APP_GENESYS_USER_ID,
            agentName: process.env.VUE_APP_GENESYS_USER_NAME,
            department: process.env.VUE_APP_GENESYS_USER_DEPARTMENT,
            conversationId: user.conversationId,
            organizationId: process.env.VUE_APP_GENESYS_USER_ORGANIZATION_ID,
            organizationName: process.env.VUE_APP_GENESYS_USER_ORGANIZATION_NAME,
            thirdPartyOrgName: process.env.VUE_APP_GENESYS_USER_ORGANIZATION_THIRDPARTY,
          },
          domSelector: '#illuma-shield',
          apiKey: "flubxCm2IJ9iAUcFMCdEt542r2rQdIhD2lZWkB5g",
          log: true,
          loading: ({ state }) => console.log(state),
        });
        this.illumaShield = sdk;

        // Wire the SDK's form submit to pass the member number and handle results
        if (sdk?.startVerificationStream) {
          const shieldEl = document.querySelector('#illuma-shield');
          if (shieldEl) {
            shieldEl.addEventListener('submit', (e) => {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.startIllumaVerification();
            }, true);
          }
        }

        // Subscribe to event stream for noActive state
        if (sdk?.eventStream) {
          sdk.eventStream().subscribe(({ state }) => {
            console.log('Illuma event:', state);
          });
        }
      }
    } catch (error) {
      console.error('Authentication error:', error);
    }
  },
  watch: {
    // Re-randomize questions when Track84 data arrives or changes (new caller) #20260826LJR
    'callerInfo.result.Track84'(newVal) {
      if (!newVal) {
        // Caller cleared — reset so next caller gets a fresh random set
        this.allQuestion = [];
        this.backupQuestion = null;
      } else {
        this.loadTrack84Questions();
      }
    },
  },

  computed: {
    /* filteredWarningCodes() {
      return this.warningCodes.result.filter((code) => this.userWarningCodes.includes(code.WarningCode))
    },*/
    // getJointOwners() {
    //   return this.callerInfo.result.Accounts.JointOwnership.map(owner => ({
    //     Name: owner.Name
    //   }))
    // },

    // Adding the Radio Function Mark May 21, 2024
    sortedAccounts() {
      if (!this.callerInfo || !this.callerInfo.result || !this.callerInfo.result.Accounts) {
        return [];
      }
      
      return this.uniqueAccounts.sort((a, b) => {
        const order = ['PRIMARY', 'JOINT OR'];
        return order.indexOf(a.type) - order.indexOf(b.type);
      });
    },
    isSendButtonDisabled() {
      return !this.inputNo || !this.selectedMemberType;
    },
    isAccountNumberSendButtonDisabled() {
      return !this.accountNumbers || !this.accountNumberSelected;
    },

    //get second subheader height
    secondSubheaderheight() {
      if(this.second_subheaderHeight){
        return `${265 + -this.second_subheaderHeight}px`
      }

      return '190px';
    },

    // Until Here Mark May 21, 2024

    isSendVerified() {
      return (
        !this.inputNo.trim() || Object.keys(this.callerInfo.result).length === 0
      );
    },
    isAuthVerifed() {
      return this.AuthclickedButton === 3 || this.AuthclickedButton === 4 || this.AuthclickedButton === 5 || this.AuthclickedButton === 6;
    },
    isSaveEnabled() {
      if (Object.keys(this.callerInfo.result).length <= 0) {
        return true;
      } else {
        if (this.category || this.notes) {
          return false;
        }
      }
      return true;
    },

    formattedInteractionSource() {
      if (!this.interactionSource) return '';
      return (
        this.interactionSource.charAt(0).toUpperCase() +
        this.interactionSource.slice(1)
      );
    },

    isDealerVip() {
      const codes = this.callerInfo?.result?.WarningCodes;
      if (!codes) return false;
      return String(codes).split(',').map(c => c.trim()).includes('194');
    },

    isDealerUser() {
      return !!this.callerInfo?.result?.OrganizationNumber;
    },

    // Parsed dealer Accounts object {users, address, sms_number} #20260827LJR
    dealerAccountsObj() {
      if (!this.isDealerUser) return null;
      const accounts = this.callerInfo?.result?.Accounts;
      if (!accounts) return null;
      const parsed = typeof accounts === 'string' ? (() => { try { return JSON.parse(accounts); } catch { return null; } })() : accounts;
      return parsed && parsed.users ? parsed : null;
    },

    // Parsed list of users from the dealer Accounts payload #20260827LJR
    dealerUsers() {
      return this.dealerAccountsObj?.users || [];
    },

    // Title for the Track84 questions panel #20260826LJR
    questionTitle() {
      return 'Member Verification Questions';
    },

    parsedCrmSummary() {
      const raw = this.callerInfo?.result?.CRMSummary;
      if (!raw) return null;
      if (typeof raw === 'object') return raw;
      try { return JSON.parse(raw); } catch (e) { return null; }
    },

    parsedSnSummary() {
      const raw = this.callerInfo?.result?.ServiceNowSummary;
      if (!raw) return null;
      if (typeof raw === 'object') return raw;
      try { return JSON.parse(raw); } catch (e) { return null; }
    },

    parsedSessionNotes() {
      const raw = this.callerInfo?.result?.CRMNotes;
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) { /* not JSON */ }
      return [raw];
    },

    parsedCrmNotes() {
      if (!this.crmSelected) return 'No account notes on file for this interaction.';
      const raw = this.crmSelected.notes;
      if (!raw) return 'No account notes on file for this interaction.';
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed.join('\n') || 'No account notes on file for this interaction.';
      } catch (e) { /* not JSON, display as-is */ }
      return raw;
    },

    snSubcategoriesFiltered() {
      if (!this.snForm.category) return this.snChoices.subcategory || [];
      return (this.snChoices.subcategory || []).filter(
        c => !c.dependentValue || c.dependentValue === this.snForm.category
      );
    },

    useServiceNow() {
      const ids = (process.env.VUE_APP_SERVICENOW_QUEUE_IDS || '').split(',').map(s => s.trim()).filter(Boolean);
      if (!ids.length) return false;
      return ids.includes(this.queueId);
    },

    snAgentPrefix() {
      const name = this.callerInfo?.result?.AgentName;
      return name ? `[${name}] ` : '';
    },

    crmFilteredRecords() {
      return this._filterCrmByChannel(this.crmRecords, this.crmChannelFilter);
    },

    crmModalFilteredRecords() {
      return this._filterCrmByChannel(this.crmRecords, this.crmModalChannelFilter);
    },

    snFilteredIncidents() {
      if (!this.snStateFilter) return this.snIncidents;
      return this.snIncidents.filter(inc => inc.state?.value === this.snStateFilter);
    },

    dl4FilteredApplications() {
      if (!this.dl4StatusFilter) return this.dl4Applications;
      return this.dl4Applications.filter(app =>
        (app.decision_status || '').toLowerCase() === this.dl4StatusFilter.toLowerCase()
      );
    },

    snModalFilteredIncidents() {
      if (!this.snModalStateFilter) return this.snIncidents;
      return this.snIncidents.filter(inc => inc.state?.value === this.snModalStateFilter);
    },


  activeAccount() {
    if (!this.callerInfo.result?.Accounts?.length) return {};
    const memberNumber = this.callerInfo.result.MemberNumber;
    return this.callerInfo.result.Accounts.find(
      a => String(a.Account) === String(memberNumber) || String(a.Name) === String(this.callerInfo.result.MemberName)
    ) || this.callerInfo.result.Accounts[0];
  }

  },
  methods: {
    openSynapsys() {
      // window.open('https://demo38web.core-access.com/crm-mockup.html', 'synapsys', 'noopener,noreferrer,width=1200,height=800');
      window.open('https://demo38web.core-access.com/crm-mockup.html', '_blank', 'width=auto,height=auto');
    },
    openServiceNow() {
      const memberName = (this.callerInfo?.result?.MemberName || '').toLowerCase().replace(/ /g, '%20');
      const url = memberName
        ? `https://dev443110.service-now.com/now/nav/ui/classic/params/target/incident_list.do%3Fsysparm_query%3Dcaller_id.nameSTARTSWITH${memberName}%26sysparm_first_row%3D1%26sysparm_view%3D%26sysparm_choice_query_raw%3D%26sysparm_list_header_search%3Dtrue`
        : 'https://dev443110.service-now.com/incident_list.do';
      if (window._snWindow && !window._snWindow.closed) {
        window._snWindow.location.href = url;
        window._snWindow.focus();
      } else {
        window._snWindow = window.open(url, 'servicenow', 'width=1200,height=800');
      }
    },
    async saveSynapsysNote() {
      if (!this.synapsysNote.trim()) return;
      try {
        await api.put('/CRMNotes', {
          company: this.company,
          indexNum: this.authToken,
          note: this.synapsysNote.trim(),
        });
        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
          this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
          "Note saved."
        );
        this.synapsysNote = "";
      } catch (e) {
        console.error('CRMNotes save error', e);
      }
    },
    async loadCrmRecords() {
      this.crmLoading = true;
      try {
        const memberNumber = this.callerInfo?.result?.MemberNumber;
        const callerID = (this.callerID || '').replace(/^tel:/, '');
        if (!memberNumber && !callerID) { this.crmLoading = false; return; }
        const params = memberNumber
          ? `company=${this.company}&memberNumber=${memberNumber}`
          : `company=${this.company}&callerId=${encodeURIComponent(callerID)}`;
        const res = await api.get(`/get-crm-activity?${params}`);
        this.crmRecords = res.data?.Activities || [];
      } catch (e) {
        console.error('CRM activity fetch error', e);
      } finally {
        this.crmLoading = false;
      }
    },
    // MeridianLink DL4 #20260824LJR
    async loadDl4Applications() {
      this.dl4Loading = true;
      this.dl4NonMemberApplicant = null;
      try {
        // Dealer/org users see the full pipeline — all applications #20260824LJR
        const isDealer = !!this.callerInfo?.result?.OrganizationNumber;
        if (isDealer) {
          const dealerId = this.callerInfo.result.OrganizationNumber;
          const res = await api.get(`/get-dl4-applications?dealer=true&dealerId=${encodeURIComponent(dealerId)}`);
          this.dl4Applications = res.data?.Applications || [];
          this.dl4Loading = false;
          return;
        }

        const memberNumber = this.callerInfo?.result?.MemberNumber;
        const callerID = (this.callerID || '').replace(/^tel:/, '');
        if (!memberNumber && !callerID) { this.dl4Loading = false; return; }
        const params = memberNumber
          ? `memberNumber=${encodeURIComponent(memberNumber)}`
          : `phone=${encodeURIComponent(callerID)}`;
        const res = await api.get(`/get-dl4-applications?${params}`);
        this.dl4Applications = res.data?.Applications || [];
        // if matched by phone only (non-member), surface applicant name from DL4 #20260824LJR
        if (res.data?.Source === 'phone' && this.dl4Applications.length) {
          const app = this.dl4Applications[0];
          this.dl4NonMemberApplicant = {
            name: `${app.applicant_first_name} ${app.applicant_last_name}`.trim(),
            phone: app.phone,
          };
        }
      } catch (e) {
        if (e.response?.status !== 404) console.error('DL4 fetch error', e);
        this.dl4Applications = [];
      } finally {
        this.dl4Loading = false;
      }
    },
    openDl4Modal(app) {
      this.dl4Selected = app || null;
      this.dl4ModalOpen = true;
    },
    closeDl4Modal() {
      this.dl4ModalOpen = false;
      this.dl4Selected = null;
      this.dl4StatusFilter = '';
    },
    openDl4Screen() {
      // window.open('/dl4-mockup.html', 'dl4', 'width=1200,height=800');
      const imagePath = require(`@/assets/DL4.png`);
      window.open(imagePath, '_blank', 'width=auto,height=auto');
    },

    // Approve a DL4 application and notify the dealer via SMS #20260902LJR
    async approveDl4Application() {
      if (!this.dl4Selected) return;
      this.dl4ApproveLoading = true;
      this.dl4ApproveStatus = null;
      try {
        const res = await api.post('/v2/ApproveDl4Application', {
          Company: this.company,
          AuthToken: this.authToken,
          applicationNumber: this.dl4Selected.application_number,
        });
        if (res.data?.Response) {
          this.dl4ApproveStatus = 'success';
          // Update local record so the button disappears and statuses reflect
          const appNum = this.dl4Selected.application_number;
          this.dl4Selected = { ...this.dl4Selected, decision_status: 'Approved', application_status: 'Active' };
          // Also update in the applications list
          const idx = this.dl4Applications.findIndex(a => a.application_number === appNum);
          if (idx !== -1) this.dl4Applications.splice(idx, 1, { ...this.dl4Applications[idx], decision_status: 'Approved', application_status: 'Active' });
          setTimeout(() => { this.dl4ApproveStatus = null; }, 5000);
        } else {
          this.dl4ApproveStatus = res.data?.Error || 'Failed';
        }
      } catch (e) {
        this.dl4ApproveStatus = e.response?.data?.Error || 'Failed to approve';
      } finally {
        this.dl4ApproveLoading = false;
      }
    },

    async sendDl4Stipulation(channel = 'email') {
      if (!this.dl4Selected) return;
      this.dl4StipulationLoading = true;
      this.dl4StipulationStatus = null;
      try {
        const res = await api.post('/v2/SendDl4Stipulation', {
          Company: this.company,
          AuthToken: this.authToken,
          applicationNumber: this.dl4Selected.application_number,
          channel,
        });
        if (res.data?.Response && res.data?.Sent) {
          this.dl4StipulationStatus = `success:${res.data.To || ''}`;
          setTimeout(() => { this.dl4StipulationStatus = null; }, 7000);
        } else {
          this.dl4StipulationStatus = res.data?.Warning || res.data?.Error || 'Failed';
        }
      } catch (e) {
        this.dl4StipulationStatus = e.response?.data?.Error || 'Failed to send';
      } finally {
        this.dl4StipulationLoading = false;
      }
    },

    async addDl4Stipulation() {
      if (!this.dl4StipulationInput || !this.dl4StipulationInput.trim()) return;
      this.dl4StipulationAddLoading = true;
      this.dl4StipulationAddError = null;
      try {
        const res = await api.post('/v2/AddDl4Stipulation', {
          Company: this.company,
          AuthToken: this.authToken,
          applicationNumber: this.dl4Selected.application_number,
          document: this.dl4StipulationInput.trim(),
        });
        if (res.data?.Response) {
          this.dl4Selected = { ...this.dl4Selected, stipulations: res.data.Stipulations };
          const idx = this.dl4Applications.findIndex(a => a.application_number === this.dl4Selected.application_number);
          if (idx !== -1) this.dl4Applications.splice(idx, 1, { ...this.dl4Applications[idx], stipulations: res.data.Stipulations });
          this.dl4StipulationInput = '';
        } else {
          this.dl4StipulationAddError = res.data?.Error || 'Failed to add';
        }
      } catch (e) {
        this.dl4StipulationAddError = e.response?.data?.Error || 'Failed to add';
      } finally {
        this.dl4StipulationAddLoading = false;
      }
    },

    removeDl4Stipulation(index) {
      const updated = [...this.dl4Selected.stipulations];
      updated.splice(index, 1);
      // Optimistic local update — persist via AddDl4Stipulation by rebuilding the whole array
      // For now just update locally; a dedicated remove endpoint can be added if needed
      this.dl4Selected = { ...this.dl4Selected, stipulations: updated };
      const idx = this.dl4Applications.findIndex(a => a.application_number === this.dl4Selected.application_number);
      if (idx !== -1) this.dl4Applications.splice(idx, 1, { ...this.dl4Applications[idx], stipulations: updated });
      // Persist to DB
      api.post('/v2/SetDl4Stipulations', {
        Company: this.company,
        AuthToken: this.authToken,
        applicationNumber: this.dl4Selected.application_number,
        stipulations: updated,
      }).catch(() => {});
    },

    // Authenticated fires directly; unauthenticated opens the phone modal #20260828LJR
    openCallbackModal() {
      const isAuth = this.authStatus_num === '1' || this.authStatus_num === '3';
      if (isAuth) {
        this.startCallback(this.phoneSendOTP);
      } else {
        this.callbackModal.phone = '';
        this.callbackModal.show = true;
        this.callbackStatus = null;
      }
    },

    // Submit callback from the modal #20260828LJR
    async submitCallbackModal() {
      const phone = this.callbackModal.phone.trim();
      if (!phone) return;
      this.callbackModal.show = false;
      await this.startCallback(phone);
    },

    // Create a voice callback from the current chat interaction #20260827LJR
    async startCallback(phoneOverride) {
      const phone = phoneOverride || this.phoneSendOTP;
      if (!phone) return;
      this.isCallbackLoading = true;
      this.callbackStatus = null;
      try {
        const res = await api.post('/v2/CreateCallback', {
          Company: this.company,
          AuthToken: this.authToken,
          PhoneNumber: phone,
        });
        this.callbackStatus = res.data?.Response ? 'success' : (res.data?.Error || 'Failed');
      } catch (e) {
        this.callbackStatus = e.response?.data?.Error || 'Failed to create callback';
      } finally {
        this.isCallbackLoading = false;
        if (this.callbackStatus === 'success') {
          setTimeout(() => { this.callbackStatus = null; }, 4000);
        }
      }
    },

    // Open modal showing a dealer user's secret questions #20260827LJR
    openDealerSecretQuestions(user) {
      this.dealerSecretQModal.userName = user.name || '';
      this.dealerSecretQModal.questions = user.secretQuestions || [];
      this.dealerSecretQModal.show = true;
    },

    // Track84 — randomly pick 3 active + 1 backup on load; never reshuffles on state changes #20260826LJR
    loadTrack84Questions() {
      // Don't re-randomize if questions are already loaded (state-only click)
      if (this.allQuestion.length) return;
      const raw = this.callerInfo?.result?.Track84;
      if (!raw) { this.backupQuestion = null; return; }
      let parsed;
      try { parsed = typeof raw === 'string' ? JSON.parse(raw) : raw; } catch { return; }
      if (!Array.isArray(parsed) || !parsed.length) return;
      // Fisher-Yates shuffle
      const pool = parsed.map((q, i) => ({
        QuestionId: i,
        QuestionText: q.Question,
        QuestionAnswer: q.Answer,
        QuestionType: 'track84',
        QuestionState: 0,
      }));
      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      this.allQuestion = pool.slice(0, 3);
      this.backupQuestion = pool.length > 3 ? pool[3] : null;
    },

    // Cycle: unanswered → correct → wrong → unanswered
    onClickQuestion(question, isBackup) {
      const next = { 0: 1, 1: 2, 2: 0 };
      if (isBackup) {
        this.backupQuestion = { ...this.backupQuestion, QuestionState: next[this.backupQuestion.QuestionState] };
      } else {
        const idx = this.allQuestion.findIndex(q => q.QuestionId === question.QuestionId);
        if (idx !== -1) {
          const updated = [...this.allQuestion];
          updated[idx] = { ...updated[idx], QuestionState: next[updated[idx].QuestionState] };
          this.allQuestion = updated;
        }
      }
    },

    getQuestionSymbol(state) {
      if (state === 1) return '✓';
      if (state === 2) return '✗';
      return '?';
    },

    getQuestionTextColor(state) {
      if (state === 1) return '#16a34a';
      if (state === 2) return '#dc2626';
      return '#9ca3af';
    },

    async loadCallerIdFlags() {
      const isChat = this.callerInfo?.result?.CallerID === 'chat';
      if (isChat) return;
      const callerID = (this.callerID || '').replace(/^tel:/, '');
      const memberNumber = this.callerInfo?.result?.MemberNumber;
      if (!callerID || !memberNumber) return;
      try {
        const res = await api.get(`/get-caller-id-flags?company=${this.company}&callerID=${encodeURIComponent(callerID)}&memberNumber=${encodeURIComponent(memberNumber)}`);
        this.callerIdFlags = res.data || null;
      } catch (e) {
        console.error('Caller ID flags fetch error', e);
      }
    },
    async loadCallerIdUsage() {
      const isChat = this.callerInfo?.result?.CallerID === 'chat';
      if (isChat) return;
      const callerID = (this.callerID || '').replace(/^tel:/, '');
      if (!callerID) return;
      try {
        const res = await api.get(`/caller-id-usage?company=${this.company}&callerID=${encodeURIComponent(callerID)}`);
        this.callerIdUsage = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error('Caller ID usage fetch error', e);
      }
    },
    openCrmActivity(record) {
      this.crmModalOpen = true;
      this.crmSelected = record || null;
    },
    closeCrmActivity() {
      this.crmModalOpen = false;
      this.crmSelected = null;
      this.crmModalChannelFilter = '';
    },
    crmTimeAgo(datetime) {
      if (!datetime) return '';
      const diff = Date.now() - new Date(datetime).getTime();
      const mins  = Math.floor(diff / 60000);
      const hours = Math.floor(diff / 3600000);
      const days  = Math.floor(diff / 86400000);
      if (mins  < 60)  return mins  + 'm ago';
      if (hours < 24)  return hours + 'h ago';
      return days + 'd ago';
    },

    _filterCrmByChannel(records, filter) {
      if (!filter) return records;
      return records.filter(rec => {
        const ch = (rec.channel || '').toLowerCase();
        if (filter === 'voice') return !ch.includes('chat') && !ch.includes('sms') && !ch.includes('email');
        if (filter === 'sms')   return ch.includes('sms');
        if (filter === 'chat')  return ch.includes('chat') || ch.includes('email');
        return true;
      });
    },

    // ── ServiceNow ──────────────────────────────────────────────────────────
    async loadSnIncidents() {
      const authToken = this.authToken;
      if (!authToken) return;
      this.snLoading = true;
      this.snError = null;
      try {
        const res = await api.get(`/v2/GetServiceNowIncidents?company=${this.company}&authToken=${authToken}`);
        this.snIncidents = res.data?.Incidents || [];
      } catch (e) {
        const msg = e.response?.data?.Error;
        if (msg && msg.includes('not authenticated')) {
          this.snError = null; // silently skip — caller not authenticated yet
        } else if (msg && msg.includes('No ServiceNow mapping')) {
          this.snError = null; // member not in ServiceNow — show nothing
        } else {
          console.error('ServiceNow incidents fetch error', e);
        }
      } finally {
        this.snLoading = false;
      }
    },

    async generateCrmSummary() {
      const authStatus = String(this.callerInfo?.result?.AuthStatus || '');
      if (authStatus !== '1' && authStatus !== '3') return;
      try {
        const res = await api.post('/v2/CreateCrmActivitySummary', {
          Company: this.company,
          AuthToken: this.authToken,
        });
        if (res.data?.Response && this.callerInfo?.result) {
          this.callerInfo.result.CRMSummary = JSON.stringify({
            summary: res.data.Summary,
            themes: res.data.Themes,
          });
        }
      } catch (e) {
        // silently skip — summary is non-critical
      }
    },

    async generateSnSummary() {
      const authStatus = String(this.callerInfo?.result?.AuthStatus || '');
      if (authStatus !== '1' && authStatus !== '3') return;
      try {
        const res = await api.post('/v2/CreateServiceNowIncidentSummary', {
          Company: this.company,
          AuthToken: this.authToken,
        });
        if (res.data?.Response && this.callerInfo?.result) {
          this.callerInfo.result.ServiceNowSummary = JSON.stringify({
            summary: res.data.Summary,
            themes: res.data.Themes,
          });
        }
      } catch (e) {
        // silently skip — summary is non-critical
      }
    },

    async loadSnChoices() {
      try {
        const [choicesRes, groupsRes] = await Promise.all([
          this.snChoices.category.length ? null : api.get('/v2/GetServiceNowIncidentChoices'),
          this.snChoices.groups.length ? null : api.get('/v2/SearchServiceNowReference?type=assignment_group&q=&limit=50'),
        ]);
        if (choicesRes?.data?.Response) {
          this.snChoices.category = choicesRes.data.category || [];
          this.snChoices.subcategory = choicesRes.data.subcategory || [];
          this.snChoices.impact = choicesRes.data.impact || [];
          this.snChoices.urgency = choicesRes.data.urgency || [];
          this.snChoices.state = choicesRes.data.state || [];
          this.snChoices.closeCode = choicesRes.data.closeCode || [];
        }
        if (groupsRes?.data?.Response) {
          this.snChoices.groups = groupsRes.data.Results || [];
        }
        // If editing an incident that already has a group, pre-load its members
        if (this.snForm.assignmentGroup) {
          await this.loadSnAssignees(this.snForm.assignmentGroup);
        }
      } catch (e) {
        console.error('ServiceNow choices fetch error', e);
      }
    },

    async loadSnAssignees(groupSysId) {
      this.snAssigneeLoading = true;
      this.snChoices.assignees = [];
      try {
        const res = await api.get(`/v2/SearchServiceNowReference?type=assigned_to&q=&group=${groupSysId}&limit=50`);
        this.snChoices.assignees = res.data?.Results || [];
      } catch (e) {
        this.snChoices.assignees = [];
      } finally {
        this.snAssigneeLoading = false;
      }
    },

    async onSnGroupChange() {
      this.snForm.assignedTo = '';
      this.snChoices.assignees = [];
      if (this.snForm.assignmentGroup) {
        await this.loadSnAssignees(this.snForm.assignmentGroup);
      }
    },

    openSnIncident(inc) {
      this.snSelected = inc;
      this.snModalOpen = true;
    },

    openSnListModal() {
      this.snSelected = null;
      this.snModalStateFilter = '';
      this.snModalOpen = true;
    },

    closeSnIncident() {
      this.snModalOpen = false;
      this.snSelected = null;
    },

    openSnEdit() {
      const inc = this.snSelected;
      if (!inc) return;
      this.snFormMode = 'edit';
      this.snForm = {
        shortDescription: inc.shortDescription || '',
        description: inc.description || '',
        category: inc.category?.value || '',
        subcategory: inc.subcategory?.value || '',
        impact: inc.impact?.value || '',
        urgency: inc.urgency?.value || '',
        state: inc.state?.value || '',
        comments: '',
        workNotes: '',
        closeCode: '',
        closeNotes: '',
        assignmentGroup: inc.assignmentGroup?.value || '',
        assignedTo: inc.assignedTo?.value || '',
      };
      this.snFormError = null;
      this.snModalOpen = false;
      this.snFormOpen = true;
      this.loadSnChoices();
    },

    openSnNewIncident() {
      this.snFormMode = 'new';
      this.snForm = { shortDescription: '', description: '', category: '', subcategory: '', impact: '', urgency: '', state: '', comments: '', workNotes: '', closeCode: '', closeNotes: '', assignmentGroup: '', assignedTo: '' };
      this.snFormError = null;
      this.snFormOpen = true;
      this.loadSnChoices();
    },

    quickResolveSnIncident() {
      this.snResolveCode = '';
      this.snResolveNotes = '';
      this.snResolveError = null;
      this.snResolveOpen = true;
      this.loadSnChoices();
    },

    closeSnResolve() {
      this.snResolveOpen = false;
      this.snResolveError = null;
    },

    async submitSnResolve() {
      if (!this.snResolveCode) {
        this.snResolveError = 'Resolution Code is required.';
        return;
      }
      if (!this.snResolveNotes.trim()) {
        this.snResolveError = 'Close Notes are required.';
        return;
      }
      this.snResolving = true;
      this.snResolveError = null;
      try {
        await api.patch('/v2/UpdateServiceNowIncident', {
          Company: this.company,
          AuthToken: this.authToken,
          SysId: this.snSelected.sysId,
          State: '6',
          CloseCode: this.snResolveCode,
          CloseNotes: this.snAgentPrefix + this.snResolveNotes,
        });
        this.snResolveOpen = false;
        this.snModalOpen = false;
        this.snSelected = null;
        await this.loadSnIncidents();
      } catch (e) {
        this.snResolveError = e.response?.data?.Error || 'Failed to resolve incident.';
      } finally {
        this.snResolving = false;
      }
    },

    closeSnForm() {
      this.snFormOpen = false;
      this.snFormError = null;
    },

    async submitSnForm() {
      this.snFormSaving = true;
      this.snFormError = null;

      // Resolution Code + Close Notes required when resolving or closing
      if (this.snFormMode === 'edit' && (this.snForm.state === '6' || this.snForm.state === '7')) {
        if (!this.snForm.closeCode) {
          this.snFormError = 'Resolution Code is required when resolving or closing.';
          this.snFormSaving = false;
          return;
        }
        if (!this.snForm.closeNotes?.trim()) {
          this.snFormError = 'Close Notes are required when resolving or closing.';
          this.snFormSaving = false;
          return;
        }
      }

      // Exact short description duplicate check on create
      if (this.snFormMode === 'new') {
        const openStates = ['1', '2', '3'];
        const match = this.snIncidents.find(inc =>
          openStates.includes(inc.state?.value) &&
          (inc.shortDescription || '').trim().toLowerCase() === this.snForm.shortDescription.trim().toLowerCase()
        );
        if (match) {
          this.snFormError = `An open incident with the same description already exists: ${match.number} — ${match.shortDescription}. Update it instead?`;
          this.snFormSaving = false;
          return;
        }
      }

      try {
        if (this.snFormMode === 'new') {
          await api.post('/v2/CreateServiceNowIncident', {
            Company: this.company,
            AuthToken: this.authToken,
            ShortDescription: this.snForm.shortDescription,
            Description: this.snForm.description || undefined,
            Category: this.snForm.category || undefined,
            Subcategory: this.snForm.subcategory || undefined,
            Impact: this.snForm.impact || undefined,
            Urgency: this.snForm.urgency || undefined,
            AssignmentGroup: this.snForm.assignmentGroup || undefined,
            AssignedTo: this.snForm.assignedTo || undefined,
          });
        } else {
          await api.patch('/v2/UpdateServiceNowIncident', {
            Company: this.company,
            AuthToken: this.authToken,
            SysId: this.snSelected.sysId,
            Category: this.snForm.category || undefined,
            Subcategory: this.snForm.subcategory || undefined,
            Impact: this.snForm.impact || undefined,
            Urgency: this.snForm.urgency || undefined,
            State: this.snForm.state || undefined,
            Comments: this.snForm.comments ? this.snAgentPrefix + this.snForm.comments : undefined,
            WorkNotes: this.snForm.workNotes ? this.snAgentPrefix + this.snForm.workNotes : undefined,
            CloseNotes: this.snForm.closeNotes ? this.snAgentPrefix + this.snForm.closeNotes : undefined,
            CloseCode: this.snForm.closeCode || undefined,
            AssignmentGroup: this.snForm.assignmentGroup || undefined,
            AssignedTo: this.snForm.assignedTo || undefined,
          });
        }
        this.snFormOpen = false;
        this.snSelected = null;
        await this.loadSnIncidents();
      } catch (e) {
        this.snFormError = e.response?.data?.Error || 'Failed to save incident.';
      } finally {
        this.snFormSaving = false;
      }
    },

    openSnNoteModal() {
      this.snNoteComment = '';
      this.snNoteWorkNote = '';
      this.snNoteError = null;
      this.snNoteOpen = true;
    },

    closeSnNote() {
      this.snNoteOpen = false;
      this.snNoteError = null;
    },

    async submitSnNote() {
      this.snNoteSaving = true;
      this.snNoteError = null;
      try {
        await api.patch('/v2/UpdateServiceNowIncident', {
          Company: this.company,
          AuthToken: this.authToken,
          SysId: this.snSelected.sysId,
          Comments: this.snNoteComment.trim() ? this.snAgentPrefix + this.snNoteComment.trim() : undefined,
          WorkNotes: this.snNoteWorkNote.trim() ? this.snAgentPrefix + this.snNoteWorkNote.trim() : undefined,
        });
        this.snNoteOpen = false;
        await this.loadSnIncidents();
        // Refresh the selected incident so the detail view shows the new notes
        const updated = this.snIncidents.find(i => i.sysId === this.snSelected.sysId);
        if (updated) this.snSelected = updated;
      } catch (e) {
        this.snNoteError = e.response?.data?.Error || 'Failed to save note.';
      } finally {
        this.snNoteSaving = false;
      }
    },

    async openSnAssignModal() {
      this.snAssignGroup = this.snSelected?.assignmentGroup?.value || '';
      this.snAssignTo = this.snSelected?.assignedTo?.value || '';
      this.snAssignError = null;
      this.snChoices.assignees = [];
      await this.loadSnChoices();
      if (this.snAssignGroup) {
        await this.loadSnAssignees(this.snAssignGroup);
      }
      this.snAssignOpen = true;
    },

    closeSnAssign() {
      this.snAssignOpen = false;
      this.snAssignError = null;
    },

    async onSnAssignGroupChange() {
      this.snAssignTo = '';
      this.snChoices.assignees = [];
      if (this.snAssignGroup) {
        await this.loadSnAssignees(this.snAssignGroup);
      }
    },

    async submitSnAssign() {
      this.snAssignSaving = true;
      this.snAssignError = null;
      try {
        await api.patch('/v2/UpdateServiceNowIncident', {
          Company: this.company,
          AuthToken: this.authToken,
          SysId: this.snSelected.sysId,
          AssignmentGroup: this.snAssignGroup || undefined,
          AssignedTo: this.snAssignTo || undefined,
        });
        this.snAssignOpen = false;
        await this.loadSnIncidents();
        const updated = this.snIncidents.find(i => i.sysId === this.snSelected.sysId);
        if (updated) this.snSelected = updated;
      } catch (e) {
        this.snAssignError = e.response?.data?.Error || 'Failed to assign incident.';
      } finally {
        this.snAssignSaving = false;
      }
    },

    snParsedNotes(raw) {
      if (!raw || !raw.trim()) return [];
      // Each entry is separated by a blank line; header is the first line of each block
      return raw.trim().split(/\n\n+/).map(block => {
        const lines = block.trim().split('\n');
        const headerLine = lines[0] || '';
        const body = lines.slice(1).join('\n').trim();
        // Strip trailing " (Comments)" / " (Work notes)" / " (Work Notes)" from header
        const header = headerLine.replace(/\s*\((?:Comments|Work notes|Work Notes)\)\s*$/, '').trim();
        // Reformat date: "2026-08-18 01:10:46 - System Administrator" → "Aug 18, 2026 01:10 · System Administrator"
        const m = header.match(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}):\d{2} - (.+)$/);
        if (m) {
          const d = new Date(m[1] + 'T' + m[2] + ':00Z');
          const dateStr = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
          return { header: `${dateStr} ${m[2]} · ${m[3]}`, body };
        }
        return { header, body };
      }).filter(n => n.body);
    },

    snTimeAgo(datetime) {
      if (!datetime) return '';
      const diff = Date.now() - new Date(datetime).getTime();
      const mins  = Math.floor(diff / 60000);
      const hours = Math.floor(diff / 3600000);
      const days  = Math.floor(diff / 86400000);
      if (mins  < 60)  return mins  + 'm ago';
      if (hours < 24)  return hours + 'h ago';
      return days + 'd ago';
    },
    async displaySelectedAccount(account) {
      try {
        this.isLoading = true;
        
        const response = await api.get(`/update-display-account`, {
          params: {
            company: this.company,
            authToken: this.authToken,
            account: account,
            currentMemberName: this.callerInfo.result.MemberName,
            currentStatus: this.authStatus_num
          }
        });

        console.log('response: '+ JSON.stringify(response));
        
        if (response.status === 200) {
          await this.GetCallerInfoUsingAuthToken();
          this.currentAccount = account.Account;
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1 ? this.brandData.accent_color1 : "#4CAF50",
            this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
            `Selected account: ${account.Name} (${account.type})`
          );
        } else {
          flashMessage(
            this.$flashMessage,
            "#FF0000",
            "#ffffff",
            "Failed to update display account."
          );
        }
      } catch (error) {
        console.error("Error updating display account:", error);
        
        flashMessage(
          this.$flashMessage,
          "#FF0000", 
          "#ffffff",
          "Error updating display account. Please try again."
        );
      } finally {
        this.isLoading = false;
      }
    },

    handleAccountClick(account) {
      console.log('Account clicked:', account);
      console.log('sorted accounts: ', this.sortedAccounts);
      this.sortedAccounts.forEach(acc => {
        if (acc.selected) {
          acc.selected = false;
        }
      });

      account.selected = true;
      account.status = this.authStatus_num;
      this.displaySelectedAccount(account);
    },

    async parseAppParameters(queryString) {
      const params = new URLSearchParams(queryString);
      let searchParams = {
        environment: '',
        pcEnvironment: null,
        pcLangTag: null,
        conversationId: null,
        pcConversationId: null,
        hostOrigin: null,
        targetEnv: null,
        clientId: null,
        state: null,
        authToken: null,
      };

      searchParams.authToken = params.get('AuthToken');
      searchParams.hostOrigin = params.get('hostOrigin');
      searchParams.targetEnv = params.get('targetEnv');
      searchParams.pcEnvironment = params.get('pcEnvironment');
      searchParams.conversationId = params.get('conversationId');
      searchParams.pcConversationId = params.get('pcConversationId');
      searchParams.oauthClientId = params.get('oauthClientId');
      searchParams.state = params.get('state');

      if (searchParams.state != null) {
        return this.parseAppParameters(decodeURIComponent(searchParams.state));
      }

      if (searchParams.hostOrigin != null && searchParams.targetEnv != null) {
        try {
          const gcClientApp = new ClientApp({
            gcHostOrigin: searchParams.hostOrigin,
            gcTargetEnv: searchParams.targetEnv,
          });
          searchParams.environment = gcClientApp.gcEnvironment;
        } catch {
          searchParams.environment = searchParams.pcEnvironment
            ? searchParams.pcEnvironment
            : searchParams.hostOrigin.replace('https://apps.', '');
        }
      } else {
        searchParams.environment = searchParams.pcEnvironment;
      }

      return searchParams;
    },

    async illumaAuth() {
      const redirectUri = process.env.VUE_APP_REDIRECT_URI;
      const client = platformClient.ApiClient.instance;
      client.setPersistSettings(true, 'InteractionApp');

      let integrationQueryString = '';
      if (window.location.search.length !== 0) {
        integrationQueryString = window.location.search.substring(1);
      } else if (window.location.hash.length !== 0) {
        const hashParts = window.location.hash.split('?');
        if (hashParts.length > 1) {
          integrationQueryString = hashParts[1];
        }
      }
      const appParams = await this.parseAppParameters(integrationQueryString);
      client.setEnvironment(appParams.environment);

      const usersApi = new platformClient.UsersApi();
      const clientId = appParams.oauthClientId || process.env.VUE_APP_OAUTH_CLIENT_ID;

      return client.loginImplicitGrant(clientId, redirectUri, { state: integrationQueryString })
        .then(() => usersApi.getUsersMe({
          expand: ['presence', 'authorization', 'organization', 'name', 'department'],
        }))
        .then((user) => {
          const conversationId = appParams.conversationId || appParams.pcConversationId;
          return { ...user, conversationId };
        })
        .catch((err) => console.error(err));
    },

    startIllumaVerification() {
      if (!this.callerInfo.result.MemberNumber) {
        flashMessage(this.$flashMessage, "#FF0000", "#ffffff", "No member number available");
        return;
      }
      if (!this.illumaShield?.startVerificationStream) {
        console.warn('Illuma SDK not ready');
        return;
      }

      const memberNumber = this.callerInfo.result.MemberNumber;
      console.log('Starting Illuma verification for:', memberNumber);

      this.illumaShield.startVerificationStream(memberNumber).subscribe({
        next: (resp) => {
          console.log('Illuma verification state:', resp.state, resp.data);
          if (resp.state === 'verified') {
            this.passValueAuth(5, 'illuma');
            this.handleAuth();
          } else if (resp.state === 'notVerified') {
            this.passValueAuth(6, 'illuma');
            this.handleAuth();
          } else if (resp.state === 'noEnroll' || resp.state === 'No Previous Enrollments') {
            flashMessage(this.$flashMessage, "#FF7F50", "#ffffff", "No enrollment found for this member");
          }
        },
        error: (error) => {
          console.error('Illuma verification error:', error);
          flashMessage(this.$flashMessage, "#FF0000", "#ffffff", `Verification error: ${error?.message}`);
        },
        complete: () => {
          console.log('Illuma verification complete');
        },
      });
    },


    showTooltipAboveButton(btnname) {
      this.showTooltipMemberNumber = false;
      this.showTooltipCallerID = false;
      const button = btnname == "member" ? this.$refs.copyMemberButton : this.$refs.copyIdToOptInButton;
      if (btnname == "member")
        this.showTooltipMemberNumber = true;
      else if (btnname == "id")
        this.showTooltipCallerID = true;

      this.$nextTick(() => {
        const tooltip = this.$el.querySelector('.tooltip');
        const buttonRect = button.getBoundingClientRect();

        if (btnname == "member") {
          tooltip.style.top = `${buttonRect.top - tooltip.offsetHeight + 30}px`;
          tooltip.style.left = `${buttonRect.left + buttonRect.width / 2}px`;
        }

        else if (btnname == "id") {
          tooltip.style.top = `${buttonRect.top - tooltip.offsetHeight + 30}px`;
          tooltip.style.left = `${buttonRect.left + buttonRect.width / 2}px`;
        }

        tooltip.style.opacity = 1;
        // Hide the tooltip after a short delay

        setTimeout(() => {
          tooltip.style.opacity = 0;
        }, 1700);
        setTimeout(() => {
          if (btnname == "member")
            this.showTooltipMemberNumber = false;
          else if (btnname == "id")
            this.showTooltipCallerID = false;
        }, 2000);
      });
    },

    copyMemberToClipboard() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.callerInfo.result.MemberNumber).then(
          () => {
            this.showTooltipAboveButton("member");
          },
          (err) => {
            console.log(err)
          }
        );
      }
    },

    copyIdToOptIn() {
      const CallerID = this.callerInfo.result.CallerID.replace('+1', '');
      navigator.clipboard.writeText(CallerID)
      this.manualInputOptInNumber = CallerID;
      this.showTooltipAboveButton("id")
    },

    isMemberNameExist(memberName) {
      return (
        this.callerInfo.result &&
        this.callerInfo.result.MemberName &&
        this.callerInfo.result.MemberName.toUpperCase() === memberName
      );
    },

    async isDemoURL() {
      const currentURL = window.location.href;
      const baseURL = currentURL.split("#")[0].replace(/\/$/, ""); // Remove trailing slash

      if (this.authToken) {
        // if (baseURL == "http://localhost:8080") {
        if (
          baseURL == "https://demo38web.core-access.com" ||
          baseURL == "https://sikorskyweb.core-access.com"
        ) {
          this.isDemo = true;
        } else {
          this.isDemo = false;
        }
      }
    },
    sortMessagesByTimestamp(data) {		// Combine all messages into one array

      console.log('messages for sorting', data);

      const allMessages = [
        ...data.data.callerMessages.map(message => ({ text: message.message, timestamp: message.timestamp, user: 'caller' })),
        ...data.data.botMessages.map(message => ({ text: message.message, timestamp: message.timestamp, user: 'bot' })),
        ...data.data.agentMessages.map(message => ({ text: message.message, timestamp: message.timestamp, user: 'agent' }))
      ];

      // Sort messages by timestamp
      allMessages.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

      return allMessages;
    },
    // async getChatBoxMessages(conversationID) {
    // 	try {
    // 		//participants form { user: [{message: '', timestamp: ''}, ...]}D
    // 		const participants = await api.get('getChatBoxMessagesByConversationID/' + conversationID);
    // 		console.log('response from getChatBoxMessages', participants);
    // 		this.chatBoxMessages = this.sortMessagesByTimestamp(participants);
    // 	} catch(err) {
    // 		console.log(err);
    // 	}
    // },
    async getChatBoxMessages() {
      try {
        //participants form { user: [{message: '', timestamp: ''}, ...]}
        // const participants = await api.get('getChatBoxMessagesByConversationID/' + conversationID);
        this.chatBoxMessages = [
          {
            "text": "Welcome to XYZ Credit Union...",
            "timestamp": "2024-09-05T06:21:48.588Z",
            "user": "bot"
          },
          {
            "text": "hi",
            "timestamp": "2024-09-05T06:21:51.152Z",
            "user": "caller"
          },
          {
            "text": "How can I help you today?",
            "timestamp": "2024-09-05T06:21:51.507Z",
            "user": "bot"
          },
          {
            "text": "Can I get my account balances please",
            "timestamp": "2024-09-05T06:22:04.623Z",
            "user": "caller"
          }
        ];
      } catch (err) {
        console.log(err);
      }
    },
    async emailSendNotification(thresholdType, emailAddress, bccEmailAddress, ccEmailAddress, emailSubject ) {
      try{
        const data = {
          email: emailAddress,
          company:this.company,
          thresholdType: thresholdType,
          callerID: this.callerID,
          memberNumber: this.callerInfo.result.MemberNumber,
          bcc: bccEmailAddress,
          cc: ccEmailAddress, 
          subject: emailSubject
        }
        const result = await api.post(`/emails/threshold-email-notification`, data);
        console.log(result, "result")
      }catch(e){
        console.log(e)
      }
    },
    async getThreshold() {
      try {
        const result = await api.get(`update_threshold/${this.company}`);
        console.log(result.data[0], "check counter")
        if (result.data.length > 0) {
          this.thresholdCounterData = result.data[0]
        }
      } catch (error) {
        /* console.log(error); */
      }
    },
    async getThresholdCounter() {
      try {
        if (this.callerInfo.result.CallerID === "chat") return;
        if (this.callerInfo.result.CallerID && this.callerInfo.result.CallerID.includes('@')) return;
        if (this.thresholdCounterData.ThresholdActiveCaller === 0) return;

        const computedNumHoursCaller = this.thresholdCounterData.NumHoursCaller
        const phoneNumberWithoutTel = this.callerID.replace(/^tel:/, "");
        const thresholdType = "callerID";
        const emailAddressCaller = this.thresholdCounterData.EmailAddressCaller;
        const EmailAddressBCCCaller = this.thresholdCounterData.EmailAddressBCCCaller
        const EmailAddressCCCaller = this.thresholdCounterData.EmailAddressCCCaller
        const EmailSubjectCaller = this.thresholdCounterData.EmailSubjectCaller

        const data = {
          Company: this.company,
          CallerID: phoneNumberWithoutTel,
          NumHoursCaller: computedNumHoursCaller,
        };
        // const result = await api.post(`http://localhost:443/get-threshold-counter`, data)
        const result = await api.post(`get-threshold-counter`, data);

        if (result.data.length > 0) {
          // if (result.data[0].countIndex == 0) {
          if (result.data[0].countIndex >= this.thresholdCounterData.MaxNumCallsCaller) {
            if (this.authToken) {
              let warningMessage = this.thresholdCounterData.WarningMessageCaller
              warningMessage = warningMessage
                .replace(/%callerid_qty/g, this.thresholdCounterData.MaxNumCallsCaller)
                .replace(/%callerid_numhours/g, computedNumHoursCaller);
              this.threshold += `${warningMessage}\n\n`;
              this.isGetThreshold = true;
              if(this.thresholdCounterData.ThresholdActiveCaller === 0) return
              await this.emailSendNotification(thresholdType,emailAddressCaller,EmailAddressBCCCaller, EmailAddressCCCaller, EmailSubjectCaller)
            } else {
              this.isGetThreshold = false;
            }
          }
        }
      } catch (error) {
        /* console.log(error); */
      }
    },
    async getThresholdCounterMember () {
      try {
        if (this.thresholdCounterData.ThresholdActiveMember === 0) return;

        const computedNumHoursMember = this.thresholdCounterData.NumHoursMember;
        const thresholdType = "member";
        const emailAddressMember = this.thresholdCounterData.EmailAddressMember;
        const EmailAddressBCCMember = this.thresholdCounterData.EmailAddressBCCMember
        const EmailAddressCCMember = this.thresholdCounterData.EmailAddressCCMember
        const EmailSubjectMember = this.thresholdCounterData.EmailSubjectMember

        const query = new URLSearchParams({
          company: this.company,
          memberNumber: this.callerInfo.result.MemberNumber,
          numHoursMember: computedNumHoursMember
        }).toString();

        const result = await api.get(`/get-threshold-counter-member-number?${query}`);

        if (result.data.length > 0) {
          // if (result.data[0].countIndex == 0) {          
          if (result.data[0].countIndex >= this.thresholdCounterData.MaxNumCallsMember) {
            if (this.authToken) {
              let warningMessage = this.thresholdCounterData.WarningMessageMember
              warningMessage = warningMessage
                .replace(/%member_qty/g, this.thresholdCounterData.MaxNumCallsMember)
                .replace(/%member_numhours/g, computedNumHoursMember);
              this.threshold += `${warningMessage}\n\n`;
              this.isGetThreshold = true;
              if(this.thresholdCounterData.SendEmailMember === 0) return
              await this.emailSendNotification(thresholdType,emailAddressMember,EmailAddressBCCMember, EmailAddressCCMember, EmailSubjectMember)
            } else {
              this.isGetThreshold = false;
            }
          }
        }
      } catch (error) {
        /* console.log(error); */
      }
    },

    async getThresholdCounterIPAddress () {
      try {

        if (this.thresholdCounterData.ThresholdActiveIPAddress === 0) return;

        const computedNumHoursIPAddress = this.thresholdCounterData.NumHoursIPAddress;
        const thresholdType = "IPAddress";
        const emailAddressIPAddress = this.thresholdCounterData.EmailAddressIPAddress;
        const EmailAddressBCCIPAddress = this.thresholdCounterData.EmailAddressBCCIPAddress
        const EmailAddressCCIPAddress = this.thresholdCounterData.EmailAddressCCIPAddress
        const EmailSubjectIPAddress = this.thresholdCounterData.EmailSubjectIPAddress

        const query = new URLSearchParams({
          company: this.company,
          memberNumber: this.callerInfo.result?.MemberNumber,
          numHoursIPAddress: computedNumHoursIPAddress
        }).toString();

        const result = await api.get(`/get-threshold-counter-ip-address?${query}`);
        console.log("result", result); 
        if (result.data.length > 0) {

          if (result.data[0].countIndex >= this.thresholdCounterData.MaxNumCallsIPAddress) {
            if (this.authToken) {
              let warningMessage = this.thresholdCounterData.WarningMessageIPAddress
              warningMessage = warningMessage
                .replace(/%ip_qty/g, this.thresholdCounterData.MaxNumCallsIPAddress)
                .replace(/%ip_numhours/g, computedNumHoursIPAddress);
              this.threshold += `${warningMessage}\n\n`;
              this.isGetThreshold = true;
              if(this.thresholdCounterData.SendEmailIPAddress === 0) return
              await this.emailSendNotification(thresholdType,emailAddressIPAddress, EmailAddressBCCIPAddress, EmailAddressCCIPAddress, EmailSubjectIPAddress)
            } else {
              this.isGetThreshold = false;
            }
          }
        }
      } catch (error) {
        /* console.log(error); */
      }
    },

    closeModal() {
      this.isOpenMnet = false;
    },
    openDemoImage() {
      this.openImage();
    },
    openImage() {
      const imagePath = require(`@/assets/core_${this.callerInfo.result.MemberNumber}.png`);
      window.open(imagePath, '_blank', 'width=auto,height=auto');
    },
    async mnetapplicationpop() {
      const memberNumber = this.callerInfo.result.MemberNumber;
      document.getElementById("screen-pop").href = "mnetpop:" + memberNumber;
    },
    episyspop() {
      // const memberNumber = localStorage.getItem("MemberNumber") || "";
      const memberNumber = this.callerInfo.result.MemberNumber;
      window.location.href = `EpisysPop:${memberNumber}`;
    },
    //sidebar method
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },



    //  Copy the function for Radio Button from Sikorsky Project
    async handleSendRadio() {
      this.phoneSendOTP = '';
      this.optInCellPhones = [];
      try {
        if (this.selectedMemberType === 'ssn') {
          // const res = await api.get(`/get-account-ssn?company=${this.company}&authToken=${this.authToken}&taxId=${this.inputNo}`);
          /* console.log(`resp from get-account-ssn: ${JSON.stringify(res)}`); */
          // await this.GetCallerInfoUsingAuthToken();
          //       if (res.status === 200 && res.data.Response == true) {
          //         /* console.log("API Response:", res.data); */

          //           this.callerInfo.result.Accounts = res.data.Accounts;
          //           this.callerInfo.result.MemberNumber = res.data.MemberNumber;
          //           this.callerInfo.result.MemberName = res.data.MemberName;
          //           this.callerInfo.result.PhoneNumbers = res.data.PhoneNumbers;
          //           this.callerInfo.result.AttemptType = res.data.AttemptType;
          //           this.readCallerAuthData(
          //           this.authStatus_num,
          //           this.callerInfo.result.AttemptType,
          //           this.callerInfo.result.PhoneNumbers,
          //           this.callerInfo.result.CallerID
          //           );
          //           /* console.log('attemptNum after'); */
          //           flashMessage(
          //           this.$flashMessage,
          //           this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
          //           this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
          //           "Updating caller info based on Tax ID."
          //         )
          //         console.log("TaxId", this.callerInfo.result)
          //       }
          //       else{

          // 	this.callerInfo.result.Accounts = [];
          //           this.callerInfo.result.MemberNumber = '';
          //           this.callerInfo.result.MemberName = '';
          //           this.callerInfo.result.PhoneNumbers = { cellPhones: [], other: [] };
          //           this.readCallerAuthData(
          //             "0",
          //             "2",
          //           this.callerInfo.result.PhoneNumbers,
          //           this.callerInfo.result.CallerID
          //           );

          //         /* console.log(`resp from get-account-ssn: ${JSON.stringify(res)}`); */
          //           flashMessage(
          //           this.$flashMessage,
          //           this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
          //           this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
          //           "Member Not found"
          //           )
          //       }

          let res = await api.get(`/get-account-by-ssn?company=${this.company}&authToken=${this.authToken}&ssn=${this.inputNo}`);
          // const res = {
          //   "status": 200,
          //   "data": {
          //     "response": {
          //       "AccountNumber": [
          //         "0005117719",
          //         "0999333333",
          //         "0005132396"
          //       ]
          //     }
          //   }
          // };

          // Check if AccountNumber is a string or convert to array if necessary
          if (typeof res.data.Response.AccountNumber === 'string') {
            res.data.Response.AccountNumber = [res.data.Response.AccountNumber];
          } else if (!Array.isArray(res.data.Response.AccountNumber)) {
            res.data.Response.AccountNumber = [];
          }

          if (res.status === 200 && res.data.Response.AccountNumber.length !== 0) {
            /* console.log("API Response:", res.data); */
            res.data.Response.AccountNumber.sort((a, b) => Number(a) - Number(b));
            this.accountNumbers = res.data.Response.AccountNumber;
            this.accountNumberSelected = this.accountNumbers[0];
            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              "Account Numbers Found Select an account number below"
            )
            this.modalOpen = true
          }
          else {
            this.callerInfo.result.Accounts = [];
            this.callerInfo.result.MemberNumber = '';
            this.callerInfo.result.MemberName = '';
            this.callerInfo.result.PhoneNumbers = { cellPhones: [], other: [] };
            this.uniqueAccounts = [];
            this.intents = [];
            this.cellPhones = [];
            this.AuthclickedButton = 0;
            console.log('--went here c.3')
            this.readCallerAuthData(
              "0",
              "2",
              this.callerInfo.result.PhoneNumbers,
              this.callerInfo.result.CallerID
            );
            this.attemptType = ""; // remove this if causing an issue when filling up reason field
            
            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              "No Account Numbers Found"
            )
          }
        }
        if (this.selectedMemberType === 'account_number') {
          const res = await api.get(`/get-account-by-number?company=${this.company}&authToken=${this.authToken}&accountNumber=${this.inputNo}`);
          await this.GetCallerInfoUsingAuthToken();
          if (res.status === 200 && res.data.Response == true) {

            this.callerInfo.result.Accounts = res.data.Accounts;
            this.callerInfo.result.MemberNumber = res.data.MemberNumber;
            this.callerInfo.result.MemberName = res.data.MemberName;
            this.callerInfo.result.PhoneNumbers = JSON.stringify(res.data.PhoneNumbers);

            
            //this.callerInfo.result.AttemptType = res.data.AttemptType;
            this.readCallerAuthData(
              "0",
              "3",
              this.callerInfo.result.PhoneNumbers,
              this.callerInfo.result.CallerID
            );
            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              "Updating caller info based on Account Number."
            );

            // console.log("accountNumber", this.callerInfo.result)
          }
          else {

            this.callerInfo.result.Accounts = [];
            this.callerInfo.result.MemberNumber = '';
            this.callerInfo.result.MemberName = '';
            this.callerInfo.result.PhoneNumbers = { cellPhones: [], other: [] };
            this.readCallerAuthData(
              "0",
              "2",
              this.callerInfo.result.PhoneNumbers,
              this.callerInfo.result.CallerID
            );
            this.attemptType = ""; // remove this if causing an issue when filling up reason field

            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              "Member Not found"
            )
          }
        }

        if (!this.selectedMemberType && this.accountNumberSelected) {
          const res = await api.get(`/get-account-by-number?company=${this.company}&authToken=${this.authToken}&accountNumber=${this.accountNumberSelected}`);
          await this.GetCallerInfoUsingAuthToken();
          if (res.status === 200 && res.data.Response == true) {
            this.callerInfo.result.Accounts = res.data.Accounts;
            this.callerInfo.result.MemberNumber = res.data.MemberNumber;
            this.callerInfo.result.MemberName = res.data.MemberName;
            this.callerInfo.result.PhoneNumbers = JSON.stringify(res.data.PhoneNumbers);
            //this.callerInfo.result.AttemptType = res.data.AttemptType;
            this.readCallerAuthData(
              "0",
              "3",
              this.callerInfo.result.PhoneNumbers,
              this.callerInfo.result.CallerID
            );

            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              "Updating caller info based on Account Number."
            )
            // console.log("accountNumber", this.callerInfo.result)
          }
          else {
            this.callerInfo.result.Accounts = [];
            this.callerInfo.result.MemberNumber = '';
            this.callerInfo.result.MemberName = '';
            this.callerInfo.result.PhoneNumbers = { cellPhones: [], other: [] };
            this.readCallerAuthData(
              "0",
              "2",
              this.callerInfo.result.PhoneNumbers,
              this.callerInfo.result.CallerID
            );

            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              "Member Not found"
            )
          }
        }

        this.threshold = ``;

        await Promise.all([
          this.getThresholdCounter(),
          this.getThresholdCounterMember(),
          this.getThresholdCounterIPAddress(),
          this.loadCrmRecords(),
          this.loadCallerIdUsage(),
          this.loadCallerIdFlags(),
          this.loadSnIncidents(),
          this.loadDl4Applications(),
          this.generateCrmSummary(),
          this.generateSnSummary(),
        ]);

      } catch (error) {
        /* console.log(error); */
      }
      this.inputNo = '';
      this.selectedMemberType = null;

    },
    // End Copy the function for Radio Button from Sikorsky Project

    async handleSend() {
      this.isLoading = true;
      // this.isLoadingWarningCode = true;
      // const headers = {
      //   Authorization: "Bearer 34eb00e1f8fc1c47b577c0b25bfaabc4",
      //   "Content-Type": "application/json",
      // }
      try {
        // PHP START
        // const resCallerInfo = await axios.get(
        //   `https://genesys-api.gcm3.com/apiNODE/api.php?action=get_caller_info_by_id&IndexNum=${this.authToken}&company=1285`,
        //   { headers }
        // )
        // if (resCallerInfo.status === 200) {
        //   this.isLoading = false
        //   this.symitarWarningCodes.splice(0, this.symitarWarningCodes.length)
        //   console.log("callerInfo by ID API result = ", resCallerInfo.data)
        //   this.callerInfo.status = resCallerInfo.data.status
        //   this.callerInfo.message = resCallerInfo.data.message
        //   this.authResult = await this.authenticateMethod(
        //     this.inputNo.length,
        //     this.inputNo,
        //     resCallerInfo.data.result.CallerID,
        //     this.authToken,
        //     this.companyID
        //   )
        //   console.log("this.authResult.Response", this.authResult.Response)
        //   if (this.authResult.Response == "YES") {
        //     const resCallerInfoUpdated = await axios.get(
        //       `https://genesys-api.gcm3.com/apiNODE/api.php?action=get_caller_info_by_id&IndexNum=${this.authToken}&company=1285`,
        //       { headers }
        //     )
        //     this.callerInfo.result = resCallerInfoUpdated.data.result
        //     this.readCallerAuthData(
        //       this.callerInfo.result.AuthStatus,
        //       this.callerInfo.result.AttemptType,
        //       this.callerInfo.result.PhoneNumbers,
        //       this.callerInfo.result.CallerID
        //     )
        //     console.log("User Warning Codes : ", resCallerInfoUpdated.data.result.WarningCodes)
        //     console.log("User this.authToken : ", this.authToken)
        //     localStorage.setItem("MemberNumber", this.callerInfo.result.MemberNumber)
        //     console.log("MemberNumber MI HANDLE SEND", localStorage.getItem("MemberNumber"))
        //     this.userWarningCodes = resCallerInfo.data.result.WarningCodes
        //     this.inputNo = ""
        //     if (this.inputNo.length === 16) {
        //       flashMessage(
        //         this.$flashMessage,
        //         this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
        //         this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
        //         "Updating caller info based on debit card number."
        //       )
        //     } else if (this.inputNo.length !== 9) {
        //       flashMessage(
        //         this.$flashMessage,
        //         this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
        //         this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
        //         "Updating caller info based on member number."
        //       )
        //     }

        //     if (this.authResult.WarningCodes) {
        //       // Populate warning codes
        //       // Loop through WarningCodes and populate each one
        //       const warningCodesArray = this.callerInfo.result.WarningCodes.split(",")
        //       console.log("warningCodesArray : ", warningCodesArray)
        //       // Inside the loop, update the code to assign the result directly to this.symitarWarningCodes
        //       for (const code of warningCodesArray) {
        //         await this.populateWarningCodes(code)
        //         console.log("symitarWarningCodes : ", code)
        //       }
        //       this.isLoadingWarningCode = false
        //     }
        //   } else if (this.authResult.Response == "NO") {
        //     flashMessage(
        //       this.$flashMessage,
        //       this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
        //       this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
        //       "Member number not found."
        //     )

        //     this.isLoadingWarningCode = false
        //   } else {
        //     flashMessage(
        //       this.$flashMessage,
        //       this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
        //       this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
        //       "Member number not found."
        //     )
        //     this.isLoadingWarningCode = false
        //   }
        // } else {
        //   flashMessage(
        //     this.$flashMessage,
        //     this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
        //     this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
        //     "No response from Authenticate.php endpoint."
        //   )
        // }

        // NODE START
        const resCallerInfo = await api.get(
          `GetCallerInfo/${this.authToken}/${this.company}`
        );

        /* console.log(resCallerInfo); */

        if (resCallerInfo.status === 200) {
          this.callerID = resCallerInfo.data.CallerID;
          this.isLoading = false;
          this.symitarWarningCodes.splice(0, this.symitarWarningCodes.length);
          this.callerInfo.status = resCallerInfo.status;
          // this.callerInfo.message = resCallerInfo.data.message

          // NEED VPN to open
          this.authResult = await this.authenticateMethod(
            this.inputNo.length,
            this.inputNo,
            resCallerInfo.data.CallerID,
            this.authToken,
            this.companyID
          );
          /* console.log("this.  ", this.authResult.Response); */
          if (this.authResult.Response == "YES") {
            const resCallerInfoUpdated = await api.get(
              `GetCallerInfo/${this.authToken}/${this.company}`
            );

            /* console.log(resCallerInfoUpdated); */

            this.callerInfo.result = resCallerInfoUpdated.data;
            //CHECKPOINT

            this.readCallerAuthData(
              this.callerInfo.result.AuthStatus,
              this.callerInfo.result.AttemptType,
              this.callerInfo.result.PhoneNumbers,
              this.callerInfo.result.CallerID,

            );
            /* console.log(resCallerInfo.data.WarningCodes); */
            // console.log(
            //   "User Warning Codes : ",
            //   resCallerInfoUpdated.data.WarningCodes
            // );
            /* console.log("User this.authToken : ", this.authToken); */
            localStorage.setItem(
              "MemberNumber",
              this.callerInfo.result.MemberNumber
            );
            //  console.log(
            //   "MemberNumber MI HANDLE SEND",
            //   localStorage.getItem("MemberNumber")
            // );
            this.userWarningCodes = resCallerInfo.data.WarningCodes;
            this.inputNo = "";
            if (this.inputNo.length === 16) {
              flashMessage(
                this.$flashMessage,
                this.brandData.accent_color1
                  ? this.brandData.accent_color1
                  : "#FF7F50",
                this.brandData.flash_text_color
                  ? this.brandData.flash_text_color
                  : "#ffffff",
                "Updating caller info based on debit card number."
              );
            } else if (this.inputNo.length !== 9) {
              flashMessage(
                this.$flashMessage,
                this.brandData.accent_color1
                  ? this.brandData.accent_color1
                  : "#FF7F50",
                this.brandData.flash_text_color
                  ? this.brandData.flash_text_color
                  : "#ffffff",
                "Updating caller info based on member number."
              );
            }

            if (this.authResult.WarningCodes) {
              // Populate warning codes
              // Loop through WarningCodes and populate each one
              const warningCodesArray =
                this.callerInfo.result.WarningCodes.split(",");
              /* console.log("warningCodesArray : ", warningCodesArray); */
              // Inside the loop, update the code to assign the result directly to this.symitarWarningCodes
              for (const code of warningCodesArray) {
                await this.populateWarningCodes(code);
                /* console.log("symitarWarningCodes : ", code); */
              }
              this.isLoadingWarningCode = false;
            }
          } else if (this.authResult == "NO") {
            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1
                ? this.brandData.accent_color1
                : "#FF7F50",
              this.brandData.flash_text_color
                ? this.brandData.flash_text_color
                : "#ffffff",
              "Member number not found."
            );

            this.isLoadingWarningCode = false;
          } else {
            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1
                ? this.brandData.accent_color1
                : "#FF7F50",
              this.brandData.flash_text_color
                ? this.brandData.flash_text_color
                : "#ffffff",
              "Member number not found."
            );
            this.isLoadingWarningCode = false;
          }
        } else {
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "No response from Authenticate.php endpoint."
          );
        }
      } catch (error) {
        /* console.log(error); */
      }
    },
    // NEXT
    async handleAuth() {
      this.isLoadingAuth = true;
      this.isLoading = true;
      try {

        let FailureReason = "";
        let SuccessOrFail = "";
        let AttemptType = "2";

        if (this.AuthclickedButton === 1) {
          FailureReason = null;
          SuccessOrFail = "1";
          AttemptType = "1";
        } else if (this.AuthclickedButton === 2) {
          FailureReason = null;
          SuccessOrFail = "2";
          AttemptType = "1";
        } else if (this.AuthclickedButton === 3) {
          FailureReason = null;
          SuccessOrFail = this.AuthclickedButton.toString();
          AttemptType = "2";
        } else if (this.AuthclickedButton === 4) {
          FailureReason = "Manually Failed by Agent";
          SuccessOrFail = this.AuthclickedButton.toString();
          AttemptType = "2";
        } else if (this.AuthclickedButton === 5) {
          FailureReason = null;
          SuccessOrFail = this.AuthclickedButton.toString();
          AttemptType = "1";
        } else if (this.AuthclickedButton === 6) {
          FailureReason = "Failed Illuma Verification";
          SuccessOrFail = this.AuthclickedButton.toString();
          AttemptType = "1";
        }


        const resCallerInfo = await api.get(
          `GetCallerInfo/${this.authToken}/${this.company}`
        );

        if (resCallerInfo.status === 200) {
          this.callerID = resCallerInfo.data.CallerID;
          this.callerInfo.result = resCallerInfo.data;
          this.authCall = await this.AddAuthCall(
            FailureReason,
            SuccessOrFail,
            this.callerInfo.result
          );
          /* console.log("authcall", this.authCall); */

          if (this.authCall.affectedRows === 1) {

            this.updateCall = await this.UpdateCallsByAuthToken(
              FailureReason,
              SuccessOrFail,
              this.callerInfo.result,
              this.authToken
            );
            /* console.log(SuccessOrFail); */
            if (this.updateCall.affectedRows === 1) {
              this.updateCallerInfo = await this.UpdateCallerInfo(
                SuccessOrFail,
                this.authToken,
                AttemptType
              );
              if (this.updateCallerInfo.affectedRows === 1) {
                const resCallerInfoUpdated = await api.get(
                  `GetCallerInfo/${this.authToken}/${this.company}`
                );

                this.callerInfo.result = resCallerInfoUpdated.data;
                this.callerInfo.result.Accounts = resCallerInfoUpdated.data.Accounts;
                this.readCallerAuthData(
                  this.callerInfo.result.AuthStatus,
                  this.callerInfo.result.AttemptType,
                  this.callerInfo.result.PhoneNumbers,
                  this.callerInfo.result.CallerID
                );
                this.isLoadingAuth = false;
                this.isLoading = false;
                this.AuthclickedButton = 0;
                // this.prevAuthclickedButton = null;
                // this.authRevertTo = null;

                flashMessage(
                  this.$flashMessage,
                  this.brandData.accent_color1
                    ? this.brandData.accent_color1
                    : "#FF7F50",
                  this.brandData.flash_text_color
                    ? this.brandData.flash_text_color
                    : "#ffffff",
                  "Authentication status successfully updated."
                );

                await Promise.all([
                  this.loadCrmRecords(),
                  this.loadSnIncidents(),
                  this.loadDl4Applications(),
                ]);
              }
            }
          }
        }
      } catch (error) {
        console.error(error);
        this.isLoadingAuth = false;
        this.isLoading = false;
      }
    },
    async handleNote() {
      this.isLoading = true;
      try {
        // NODE START
        const resCallerInfo = await api.get(
          `GetCallerInfo/${this.authToken}/${this.company}`
        );

        this.callerInfo.result = resCallerInfo.data;

        const body = {
          Company: this.company,
          Name: this.callerInfo.result.MemberName,
          MemberNumber: this.callerInfo.result.MemberNumber,
          PhoneNumber: this.callerInfo.result.CallerID,
          InteractionId: this.callerInfo.result.InteractionId,
          NoteCategory: this.category,
          NoteText: this.notes,
          CreatedByAgent: this.callerInfo.result.AgentName,
          AgentID: this.callerInfo.result.AgentId,
          AgentName: this.callerInfo.result.AgentName,
        };
        const resAddFraudnotes = await api.post("addFraudNotes", body);

        if (resAddFraudnotes.status === 200) {
          this.isLoading = false;
          this.category = "";
          this.notes = "";

          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "Security note successfully added."
          );
          await this.GetCallerInfoUsingAuthToken();
        } else {
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "Security note not added."
          );
        }

      } catch (error) {
        /* console.log(error); */
      }
    },
    async GetCallerInfoUsingAuthToken() {
      this.isLoading = true;
      //  this.isLoadingWarningCode = true;
      try {
        const resCallerInfo = await api.get(`GetCallerInfo/${this.authToken}/${this.company}`);
  
        if (resCallerInfo.status === 200) {
          /* console.log("ResData", resCallerInfo.data, resCallerInfo); */
          this.currentAccount = resCallerInfo.data.Accounts?.[0]?.Account || "";

          if (resCallerInfo.data.Accounts !== null) {
            // Dealer accounts are a plain object {users, address, sms_number} — not an array.
            // Skip the filter/sort that expects an array; uniqueAccounts stays [] for dealers.
            const accountsRaw = resCallerInfo.data.Accounts;
            const isAccountArray = Array.isArray(accountsRaw) ||
              (typeof accountsRaw === 'undefined'); // legacy fallback also uses array
            if (isAccountArray) {
              let originalAccounts = [];
              let accountObject = {};
              if (typeof accountsRaw === 'undefined') {
                const accountsColumn = resCallerInfo.data.Accounts;
                accountObject = JSON.parse(accountsColumn);
                const accountValue = accountObject.Accounts;
                originalAccounts = accountValue;
              } else {
                originalAccounts = accountsRaw;
              }
              const uniqueNamesSet = new Set();
              let uniqueAccounts = originalAccounts.filter((account) => {
                const upperCaseOwner = account.Name.toUpperCase();
                const isRealName = upperCaseOwner.trim().length >= 0;
                if (!isRealName) {
                  return false;
                }
                if (!uniqueNamesSet.has(upperCaseOwner)) {
                  uniqueNamesSet.add(upperCaseOwner + account.Suffix);
                  return true;
                }
                return false;
              });
              uniqueAccounts = uniqueAccounts.sort((a, b) => {
                if (a.Name < b.Name) { return -1; }
                if (a.Name > b.Name) { return 1; }
                return 0;
              });
              if (typeof accountsRaw === 'undefined') {
                this.uniqueAccounts = uniqueAccounts;
              } else {
                resCallerInfo.data.Accounts = uniqueAccounts;
                this.uniqueAccounts = resCallerInfo.data.Accounts;
              }
            }
          } else {
            /* console.log("Accounts data is null."); */
          }

          this.callerID = resCallerInfo.data.CallerID;
          this.isLoading = false;
          if (resCallerInfo.status === 200) {
            if (resCallerInfo.data) {
              this.symitarWarningCodes.splice(0, this.symitarWarningCodes.length);
              this.callerInfo.status = resCallerInfo.status;
              this.callerInfo.result = resCallerInfo.data;

              /* console.log(`passing this.callerInfo.result.PhoneNumbers`, this.callerInfo.result.PhoneNumbers); */

              this.readCallerAuthData(
                this.callerInfo.result.AuthStatus,
                this.callerInfo.result.AttemptType,
                this.callerInfo.result.PhoneNumbers,
                this.callerInfo.result.CallerID
              );

              // this.userWarningCodes = resCallerInfo.data.WarningCodes;
              localStorage.setItem("authToken", this.authToken);
              localStorage.setItem("MemberNumber", this.callerInfo.result.MemberNumber);
              /* console.log('this.callerInfo.result', this.callerInfo.result); */
              const warningCodesArray = this.callerInfo.result.WarningCodes ? this.callerInfo.result.WarningCodes.split(',') : [];

              for (const code of warningCodesArray) {
                await this.populateWarningCodes(code);
              }
            }
          }
           this.isLoadingWarningCode = false;
        }
        this.modalOpen = false;
        this.manualInputOptInNumber = '';
        this.selectedCountryCode = '+1';
        this.phoneSendOTP = '';
        this.otpInput = '';
        this.IPAddress = "44.221.221.55";
        try {
          const raw = resCallerInfo.data.IntentHistory;
          this.navigationPath = raw ? JSON.parse(raw) : [];
        } catch (e) {
          this.navigationPath = [];
        }
        await Promise.all([
          this.getFlagFromIP(this.IPAddress),
          this.getOptInPhoneNumberByMemberNumber(),
          this.getFraudNotes(this.callerInfo.result.MemberNumber),
        ]);
        // await this.fetchWarningCodes();
        this.second_subheaderHeight = this.$refs.second_subheaderHeight.clientHeight;

        return this.callerInfo.result.InteractionId;
      } catch (error) {
        this.isLoadingWarningCode = false;
        console.log(error); 
      }
    },
    async populateWarningCodes(code) {
      // const headers = {
      //   Authorization: "Bearer 34eb00e1f8fc1c47b577c0b25bfaabc4",
      //   "Content-Type": "application/json",
      // }

      try {
        const body = {
          Company: this.company,
          WarningNumber: code,
          AuthToken: this.authToken,
        };
        // /GetWarningSelectFields
        // const resSymitarWarningCodes = await axios.post(
        //   `https://genesys-api.gcm3.com/apiNODE/GetWarningSelectFields.php`,
        //   body,
        //   { headers }
        // )
        const resSymitarWarningCodes = await api.post(
          "GetWarningSelectFields",
          body
        );

        if (resSymitarWarningCodes.status === 200) {
          if (resSymitarWarningCodes.data.Warnings) {
            this.symitarWarningCodes.push(...resSymitarWarningCodes.data.Warnings);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchNotesCategory() {
      this.isLoadingNotes = true;
      // const headers = {
      //   Authorization: "Bearer 34eb00e1f8fc1c47b577c0b25bfaabc4",
      //   "Content-Type": "application/json",
      // }
      try {
        //PHP
        // const resNotesCategory = await axios.get(
        //   "https://genesys-api.gcm3.com/apiNODE/api_notescategory.php?action=get_notes_category_by_id&Company=1285",
        //   { headers }
        // )
        // if (resNotesCategory.status === 200) {
        //   this.noteCategories = resNotesCategory.data.result.map((item) => item.NoteCategory)
        //   console.log("NotesCategory by Company API result = ", resNotesCategory.data.result)
        //   console.log(this.noteCategories)
        //   this.isLoadingNotes = false
        // }
        // NODE START
        const { status, data } = await api.post("getNoteCategory", {
          Company: this.company,
        });

        if (status === 200) {
          this.noteCategories = data.map((item) => item.NoteCategory);
          this.isLoadingNotes = false;
        }
        // console.log(data, status)
      } catch (error) {
        /* console.log(error); */
      }
    },
    passValueAuth(value, source, event) {
      if (source === 'status') {
        this.authRevertTo = parseInt(this.authStatus_num) || null;
        this.AuthclickedButton = value;
        this.handleAuth();
        return;
      }
      else if (source === 'checklist') {
        this.AuthClickedChecklistButton = value;
      }
      else if (source === 'illuma') {
        this.AuthclickedButton = value;
      }
      else if (source === 'otp') {
        this.AuthclickedButton = value;
      }
      else if (source)
        if (event) {
          event.preventDefault();
        }
    },

    // Need to Revise this Section to Remove +1 because it's
    // Already in the backend
    formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (cleaned.length <= 5) {
        return; // Return undefined if length is 5 or below
      }
      if (match) {
        // Always prepend '+1' to the phone number
        let intlCode = "+1 ";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
      }
      return str;
    },
    async readCallerAuthData(authStatusNum, attemptNum, PhoneNumbers, CallerID) {
      console.log('--authStatusNum:', authStatusNum)
      console.log('--attemptNum:', attemptNum)
      console.log('--PhoneNumbers:', PhoneNumbers)
      console.log('--CallerID:', CallerID)
      if (authStatusNum === "0") {
        this.authStatus = "Not Authenticated";
        this.authStatusColor = "red";
        this.authStatus_num = "0";
      } else if (authStatusNum === "1") {
        this.authStatus = "Authenticated"; // Authenticated
        this.authStatusColor = "green";
        this.authStatus_num = "1";
      } else if (authStatusNum === "2") {
        this.authStatus = "Not Authenticated"; // Not Authenticated
        this.authStatusColor = "red";
        this.authStatus_num = "2";
      } else if (authStatusNum === "3") {
        this.authStatus = "Manually Authenticated";
        this.authStatusColor = "black";
        this.authStatus_num = "3";
      } else if (authStatusNum === "4") {
        this.authStatus = "Manually Failed";
        this.authStatusColor = "red";
        this.authStatus_num = "4";
      } else if (authStatusNum === "5") {
        this.authStatus = "Illuma Authenticated";
        this.authStatusColor = "green";
        this.authStatus_num = "5";
      } else if (authStatusNum === "6") {
        this.authStatus = "Illuma Unauthenticated";
        this.authStatusColor = "red";
        this.authStatus_num = "6";
      } else {
        this.authStatus = "Not Authenticated";
        this.authStatusColor = "red";
        this.authStatus_num = "0";
      }
      /* console.log('attemptNum', attemptNum); */
      if (attemptNum === "0") {
        this.attemptType = "Not Attempted";
      } else if (attemptNum === "1") {
        this.attemptType = "Attempted";
      } else if (attemptNum === "2") {
        this.attemptType = "Manually Attempted";
      } else if (attemptNum === "3") {
        this.attemptType = "";
      }
      else {
        this.attemptType = "Invalid Attempt Value";
      }

      try {
        /* console.log('reached PhoneNumbers', PhoneNumbers); */
        const formattedCallerID = this.formatPhoneNumber(CallerID);

        await this.getFlagFromPhone(CallerID);
        
        let cellPhoneNumberHTML = '';
        PhoneNumbers = PhoneNumbers ? JSON.parse(PhoneNumbers) : { cellPhones: [], other: [] };

        /* console.log('reached PhoneNumbers again', PhoneNumbers); */
        for (let i = 0; i < PhoneNumbers.cellPhones.length; i++) {
          PhoneNumbers.cellPhones[i] = this.formatPhoneNumber(PhoneNumbers.cellPhones[i]);
        }

        for (let i = 0; i < PhoneNumbers.other.length; i++) {
          PhoneNumbers.other[i] = this.formatPhoneNumber(PhoneNumbers.other[i]);
        }

        
        const cellPhones = PhoneNumbers.cellPhones;
        this.cellPhones = [...this.cellPhones];
        // alert(this.cellPhones[0]);
        // this.phoneSendOTP = this.formatPhoneNumber(this.cellPhones[0]);
        //[...this.cellPhones, ...PhoneNumbers.cellPhones[0].split(',')]; this was breaking the demo, so I commented it out #20240905DM
        // console.log('this.cellPhones ', this.cellPhones)
        const enrolledNumbers = [...new Set(PhoneNumbers.other)].filter(number => number !== undefined);
        let phonesToCheck = [...enrolledNumbers];
        for (let i = 0; i < cellPhones.length; i++) {
          console.log("CELLS", cellPhones)
          let cellPhone = cellPhones[i];
          console.log("CPP",cellPhone, "i: ", i)
          phonesToCheck.push(this.formatPhoneNumber(cellPhone));
          cellPhoneNumberHTML += `<p style="line-height:1; color:green; margin:0; padding:0; display: inline-block;">${this.formatPhoneNumber(cellPhone)}${i < cellPhones.length - 1 ? '<p style=" display: inline-block; line-height:1; color:black; margin:0; padding:0;">,&nbsp</p>' : ''}</p>`;
          // Add a comma after each phone number (except the last one)
          // if (i < cellPhonesArray.length - 1) {
          //   cellPhoneNumberHTML += ', ';
          // }
          
        }

        let otherNumbersHTML = '';
        for (let i = 0; i < enrolledNumbers.length; i++) {
          const comma = i < enrolledNumbers.length - 1 ? ',&nbsp' : '';
          otherNumbersHTML += `<p style="line-height:1; color:black; margin:0; padding:0; display: inline-block;">${enrolledNumbers[i]}${comma}</p>`;
        }

        const flagHTML = this.callerIdCountryFlag
          ? `<img src="https://flagcdn.com/w40/${this.callerIdCountryFlag}.png" alt="${this.callerIdCountryFlag}" style="width: 20px; height: 15px; margin-right: 4px;" />`
          : '';

        if (formattedCallerID) {
          this.interactionSource = "Call";
          if (phonesToCheck.includes(formattedCallerID)) {
            this.callerIdFlag = true;
            this.phonenumList = `The CallerID, ${flagHTML}${formattedCallerID}, is found. <br><br><div style="gap:0px;display:flex;flex-wrap:wrap;justify-content:start; align-items:center;"><p style="line-height:1; display: inline-block; margin:0; padding:0; color:black">Enrolled numbers are:&nbsp;</p> ${cellPhoneNumberHTML}${cellPhoneNumberHTML && otherNumbersHTML? ",&nbsp" : ""}${otherNumbersHTML}</div>`;
            // console.log(enrolledNumbers.includes(formattedCallerID))
          } else {
            this.callerIdFlag = true;
            if (phonesToCheck.length > 0) {
              this.phonenumList = `The CallerID, ${flagHTML}${formattedCallerID}, is not found. <br><br><div style="gap:0px;display:flex;flex-wrap:wrap;justify-content:start; align-items:center;"><p style="line-height:1; display: inline-block; margin:0; padding:0; color:black">Enrolled numbers are:&nbsp;</p> ${cellPhoneNumberHTML}${cellPhoneNumberHTML && otherNumbersHTML? ",&nbsp" : ""} ${otherNumbersHTML}</div>`;
            } else {
              this.phonenumList = `The CallerID, ${flagHTML}${formattedCallerID}, is not found. <br><br>Phone List is empty`;
            }
          }
        } else {
          this.callerIdFlag = false;
          this.interactionSource = CallerID && CallerID.includes('@') ? 'Email' : CallerID;

          if (phonesToCheck.length > 0) {
            this.phonenumList = `<div style="gap:0px;display:flex;flex-wrap:wrap;justify-content:start; align-items:center;"><p style="line-height:1; display: inline-block; margin:0; padding:0; color:black">Enrolled numbers are:&nbsp;</p> ${cellPhoneNumberHTML},&nbsp<br>${otherNumbersHTML}</div>`;
          } else {
            this.phonenumList = `Phone List is empty`;
          }
        }
        this.enrolledNumbers = phonesToCheck;

      } catch (error) {
        if (!this.formatPhoneNumber(CallerID)) {
          this.phonenumList = `Phone List is empty`;
        }
        else {
          const formattedCallerID = this.formatPhoneNumber(CallerID);
          const flagHTML = this.callerIdCountryFlag
          ? `<img src="https://flagcdn.com/w40/${this.callerIdCountryFlag}.png" alt="${this.callerIdCountryFlag}" style="width: 20px; height: 15px; margin-right: 4px;" />`
          : '';
          this.phonenumList = `The CallerID, ${flagHTML}${formattedCallerID}, is not found. Phone List is empty`;
        }
        console.error("Error:", error);
      }
    },

    async authenticateMethod(
      charCount,
      inpputedNo,
      callerID,
      authToken,
      companyID
    ) {
      // const headers = {
      //   Authorization: "Bearer 34eb00e1f8fc1c47b577c0b25bfaabc4",
      //   "Content-Type": "application/json",
      // }
      // let authenticationMethod = 0
      // let creditCardNumber = null
      let memberNumber = null;
      if (charCount === 16) {
        /* console.log("credit card detected"); */
        // authenticationMethod = 2
        // creditCardNumber = inpputedNo
      } else if (charCount !== 9) {
        /* console.log("member number detected"); */
        // authenticationMethod = 0
        memberNumber = inpputedNo;
      } else {
        // creditCardNumber = inpputedNo
      }
      try {
        // const res = await axios.post(
        //   `https://genesys-api.gcm3.com/apiNODE/Authenticate.php`,
        //   {
        //     AuthenticationMethod: authenticationMethod,
        //     CreditCardNumber: creditCardNumber,
        //     MemberNumber: memberNumber,
        //     CallerID: callerID,
        //     AuthToken: authToken,
        //     Company: companyID,
        //   },
        //   { headers }
        // )
        const res = await api.post("MemberAppHandleSend", {
          MemberNumber: memberNumber,
          CallerID: callerID,
          AuthToken: authToken,
          Company: companyID,
        });

        if (res.status === 200) {
          if (res.data.Response == "YES" && res.data.WarningCodes) {
            /* console.log("Authenticate.php result = ", res.data); */
            this.userWarningCodes = res.data.WarningCodes.split(",");
            /* console.log("User warning codes: ", this.userWarningCodes); */
            return res.data;
          } else {
            return res.data;
          }
        }
      } catch (error) {
        /* console.log(error); */
      }
    },
    async AddAuthCall(FailureReason, SuccessOrFail, CallerInfo) {
      /* console.log("FailureReason", FailureReason); */
      /* console.log("SuccessOrFail", SuccessOrFail); */
      /* console.log("CallerInfo", CallerInfo); */
      /* console.log("AgentId", CallerInfo.AgentId); */
      /* console.log("AgentName", CallerInfo.AgentName); */

      try {
        const authMethod = (this.AuthclickedButton === 3 || this.AuthclickedButton === 4) ? "2" : "1";
        const res = await api.post("insertAuthCalls", {
          MemberNumber: CallerInfo.MemberNumber,
          MemberName: CallerInfo.MemberName,
          CallerID: CallerInfo.CallerID,
          AuthMethod: authMethod,
          SuccessOrFail: SuccessOrFail,
          Company: this.company,
          InteractionId: CallerInfo.InteractionId,
          FailureReason: FailureReason,
          CreditCardNumber: CallerInfo.CreditCardNumber,
          AgentID: CallerInfo.AgentId,
          AgentName: CallerInfo.AgentName,
          SourceIp : CallerInfo.SourceIp,
        });

        /* console.log(res); */

        if (res.status === 200) {
          /* console.log("AddAuthCalls", res.data); */
          return res.data;
        }
      } catch (error) {
        /* console.log(error); */
      }
    },
    async UpdateCallsByAuthToken(
      FailureReason,
      SuccessOrFail,
      CallerInfo,
      AuthToken
    ) {
      try {
        const res = await api.post("updateCallsAuthStatus", {
          MemberNumber: CallerInfo.MemberNumber,
          MemberName: CallerInfo.MemberName,
          AuthToken: AuthToken,
          AuthStatus: SuccessOrFail,
          FailureReason: FailureReason,
          AgentID: CallerInfo.AgentId,
          AgentName: CallerInfo.AgentName,
        });

        if (res.status === 200) {
          /* console.log("update_calls result = ", res.data); */
          return res.data;
        }
      } catch (error) {
        /* console.log(error); */
      }
    },
    async UpdateCallerInfo(SuccessOrFail, AuthToken, AttemptType) {

      try {
        const res = await api.post("updateCallerInfoSetAuthStatus", {
          AuthStatus: SuccessOrFail,
          AttemptType: AttemptType,
          IndexNum: AuthToken,
        });

        if (res.status === 200) {
          /* console.log("update_caller_info result = ", res.data); */
          return res.data;
        }
      } catch (error) {
        /* console.log(error); */
      }
    },
    handleCancel(value) {
      switch (value) {
        case "membernumber":
          this.inputNo = "";
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "Member number canceled successfully"
          );
          break;
        case "authstatus":
          if (this.authRevertTo !== null) {
            this.AuthclickedButton = this.authRevertTo;
            this.authRevertTo = null;
            this.handleAuth();
          }
          break;
        case "notecategory":
          this.notes = "";
          this.category = "";
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "Note Category canceled successfully"
          );
          break;
        case "accountnumber":
          this.accountNumberSelected = "";
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "Account Number canceled successfully"
          );
          break;
      }
      this.inputNo = '';
      this.selectedMemberType = null;
    },


    // Integrations Send SMS With OTP Function - #20240726JM
    async sendSMS() {
      try {
        // Format the phone number with the selected country code
        // if (this.selectedCountryCode && this.phoneSendOTP) {
        //   this.formatNumber = `${this.selectedCountryCode}${this.phoneSendOTP.replace(/[^+\d]/g, '')}`;
        /* console.log("phoneSendOTP", this.phoneSendOTP); */

        if (this.phoneSendOTP) {
          this.formatNumber = this.phoneSendOTP.replace(/[^+\d]/g, '');
        }

        //   this.formatNumber = this.phoneSendOTP.replace(/[^+\d]/g, '');
        // Save the formatted number to the formattedPhoneNumbers array
        // this.formattedPhoneNumbers.push(this.formatNumber);

        const response = await api.post("/v2/SendOTP", {
          Company: this.company,
          cellPhone: this.formatNumber,
          AuthToken: this.authToken,
          memberNumber: this.callerInfo.result.MemberNumber,
        },
        {
          headers: {
            "token": "2y10D08eZgJLx0C9rGvQKfwFBuCPvqDdmdowpnczUKwYWU3B0VoVt5BiC"
          }
        });

        console.log('--response:', response)
        const data = response.data;
        /* console.log(this.formatNumber); */
        /* console.log(data); */
        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1
            ? this.brandData.accent_color1
            : "#FF7F50",
          this.brandData.flash_text_color
            ? this.brandData.flash_text_color
            : "#ffffff",
          data.Response
        );

        /* console.log("SMS sent successfully", data); */
        // } else {
        //   console.error("Country code or phone number is missing");
        // }
      } catch (error) {
        console.error(
          "Failed to send SMS",
          error.response ? error.response.data : error.message
        );

        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1
            ? this.brandData.accent_color1
            : "#FF7F50",
          this.brandData.flash_text_color
            ? this.brandData.flash_text_color
            : "#ffffff",
          "Failed to send SMS"
        );
      }
    },
    // Integrations Verify OTP Function - #20240726JM
    async verifyOTP() {

      if (this.phoneSendOTP) {
        this.formatNumber = this.phoneSendOTP.replace(/[^+\d]/g, '');
      }

      try {
        const response = await api.post(
          "/v2/CheckOTP",
          {
            Company: this.company,
            cellPhone: this.formatNumber,
            OTP: this.otpInput,
            AuthToken: this.authToken,
          },
          {
          headers: {
            "token": "2y10D08eZgJLx0C9rGvQKfwFBuCPvqDdmdowpnczUKwYWU3B0VoVt5BiC"
          }
        });
        
        const data = response.data;
        this.verificationAttempted = true;
        this.isValid = data.Response === "OTP Validated";
        if (!this.isValid) {
          /* console.log("OTP verification failed", data); */

          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            data.Response
          );

        } else {
          /* console.log("OTP verified", data); */
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#FF7F50",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "OTP Verified Successfully"
          );
        }
      } catch (error) {
        this.verificationAttempted = true;
        this.isValid = false;
        console.error(
          "Failed to verify OTP",
          console.log(error),
          error.response ? error.response.data : error.message
        );
      }
    },
    // End of 2FA Function for 2FA
    async fetchWarningCodes() {
      this.isLoadingWarningCode = true;

      try {
        const result = await api.get(`/get-warning-codes?company=${this.company}&authToken=${this.authToken}`);

        if (result.data.length > 0) {
          this.symitarWarningCodes = result.data;
        }
        else {
          this.symitarWarningCodes = [];
        }
      } catch (error) {
        /* console.log(error); */
        this.isLoadingWarningCode = false;
        this.symitarWarningCodes = [];
      }
      this.isLoadingWarningCode = false;
    },

    async getOptInPhoneNumberByMemberNumber() {
      try {
        const result = await api.get(`/get-phone-numbers?company=${this.company}&authToken=${this.authToken}`);
        if (result.data) {
          this.optInCellPhones = result.data.PhoneNumbers.cellPhones;
          this.phoneSendOTP = this.optInCellPhones[0];
          /* console.log('optInCellPhones:', this.optInCellPhones); */
        }
        else {
          /* console.log('getOptInPhoneNumberByMemberNumber result is blank', result); */
        }
      } catch (error) {
        /* console.log('getOptInPhoneNumberByMemberNumber', error); */
      }
    },

    async optIn() {
      let checkIfExist = false;
      for (const v of Object.values(this.optInCellPhones)) {
        if (v === this.selectedCountryCode + this.manualInputOptInNumber.replace(/\D/g, '')) {
          checkIfExist = true;
          break;
        }
      }

      if (checkIfExist) {
        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1
            ? this.brandData.accent_color1
            : "#FF7F50",
          this.brandData.flash_text_color
            ? this.brandData.flash_text_color
            : "#ffffff",
          "Phone Number Already Opt In"
        );

        return;
      }

      try {
        const result = await api.post(`/integrations/sms/opt-ins`, {
          memberNumber: this.callerInfo.result.MemberNumber,
          cellPhone: this.selectedCountryCode + this.manualInputOptInNumber.replace(/\D/g, ''),
          company: this.company,
        });
        await this.getOptInPhoneNumberByMemberNumber();
        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1
            ? this.brandData.accent_color1
            : "#FF7F50",
          this.brandData.flash_text_color
            ? this.brandData.flash_text_color
            : "#ffffff",
          result.data.Response
        );

        this.manualInputOptInNumber = '';
        this.selectedCountryCode = '+1'
      } catch (error) {
        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1
            ? this.brandData.accent_color1
            : "#FF7F50",
          this.brandData.flash_text_color
            ? this.brandData.flash_text_color
            : "#ffffff",
          "Something went wrong"
        );

        console.log(error);
        this.manualInputOptInNumber = '';
        this.selectedCountryCode = '+1';
      }
    },

    async optOut() {
      console.log('phoneSendOTP', this.phoneSendOTP);
      if (this.phoneSendOTP) {
        this.formatNumber = this.phoneSendOTP.replace(/[^+\d]/g, '');
      }
      let idToDelete = '0';

      for (const [k, v] of Object.entries(this.optInCellPhones)) {
        if (v === this.phoneSendOTP) {
          idToDelete = k;
          break;
        }
      }

      if (idToDelete === '0') {
        /* console.log('Phone number not found in opt-in list.'); */
        return;
      }

      Swal.fire({
        title: 'Opt-Out Confirmation',
        html: `<p>Are you sure you want to opt-out phone number <br><b>${this.formatPhoneNumber(this.phoneSendOTP)}</b>?</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await api.post('/integrations/sms/opt-outs', {
              memberNumber: this.callerInfo.result.MemberNumber,
              cellPhone: this.formatNumber,
              company: this.company,
            });
            // Directly delete the property from the reactive object
            delete this.optInCellPhones[idToDelete];

            await this.getOptInPhoneNumberByMemberNumber();

            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              response.data.Response
            );
          } catch (error) {
            flashMessage(
              this.$flashMessage,
              this.brandData.accent_color1 ? this.brandData.accent_color1 : "#FF7F50",
              this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
              "Something went wrong"
            );
            console.log(error);
          }
        }
      });
    },
    async getCountryCode() {
      try {
        const result = await api.get(`/country-codes`);
        /* console.log('result countryCodes', result.data); */
        this.countryCodes = result.data.map(item => item.code);
        /* console.log('result this.countryCodes', this.countryCodes); */
      } catch (error) {
        console.error('Error fetching country codes:', error);
        this.countryCodes = [];
      }
    },
    handleNumericInput(event) {
      // Remove non-numeric characters from input
      this.manualInputOptInNumber = event.target.value.replace(/\D/g, '');
    },
    async getFraudNotes(MemberNumber) {
      try {
        const { data } = await api.get(`getFraudNotes?company=${this.company}&memberNumber=${MemberNumber}`)
        this.fraudNotes = data
        this.isLoading = false
      } catch (error) {
        console.log(error)
      }
    },
    async getCoreSystemType(){
      const { data } = await api.post("getIVRConfigOptions", { Company: this.company });
      console.log("Retrieved data IVR:", data);
      this.coreSystemType = data?.CoreConfig?.Core;
    },
    async getFlagFromIP(ip) {
      try {
        ip = ip ? ip: null;
        // const response = await fetch(`https://ipapi.co/${ip}/json/`);
        this.flag = "us";

        // if (!response.ok) {
        //   console.error('API Error:', response.status);
        //   this.flag = "un";
        // }

        // const data = await response.json();

        // if (!data.country_code){
        //   this.flag = "un";
        // }
      } catch (error) {
        console.error('Fetch error:', error);
        this.flag = "us";
      }
    },
    async getFlagFromPhone(phoneNumber) {
      if (!phoneNumber) {
        this.callerIdCountryFlag = "";
        return;
      }

      try {
        const cleanPhone = phoneNumber.replace(/[^\d+]/g, '');

        let foundCountry = '';
        if (cleanPhone.startsWith('+')) {
          const phoneDigits = cleanPhone.substring(1);

          if (phoneDigits.startsWith('1') && phoneDigits.length >= 4) {
            const areaCode = parseInt(phoneDigits.substring(1, 4));

            if (nanpAreaCodes[areaCode]) {
              foundCountry = nanpAreaCodes[areaCode];
            } else {
              foundCountry = 'us';
            }
          } else {
            const sortedCodes = countryCodesData.sort((a, b) => {
              const aLen = a.code.replace('+', '').length;
              const bLen = b.code.replace('+', '').length;
              return bLen - aLen;
            });

            for (const item of sortedCodes) {
              const code = item.code.replace('+', '');
              if (phoneDigits.startsWith(code)) {
                foundCountry = item.country.toLowerCase();
                break;
              }
            }
          }
        }

        this.callerIdCountryFlag = foundCountry || "";

      } catch (error) {

        console.error('Error fetching country flag from phone:', error);
        this.callerIdCountryFlag = "";
      }
    },
  },
};
</script>

<style scoped>
/* ── CRM Activity Modal ─────────────────────────────────────────────────── */
.crm-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.crm-modal {
  background: #fff;
  border-radius: 10px;
  width: 640px;
  max-width: 95vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0,0,0,0.25);
}
.crm-modal-header {
  background: #1a2233;
  color: #fff;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}
.crm-modal-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.crm-modal-close {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.crm-modal-close:hover { background: rgba(255,255,255,0.3); }
.crm-modal-body {
  overflow-y: auto;
  flex: 1;
  padding: 0;
}
/* List view */
.crm-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  gap: 12px;
}
.crm-list-item:hover { background: #f7f9fc; }
.crm-list-item-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #444;
}
.crm-list-item-left > .fa {
  margin-top: 3px;
  color: #0e5071;
  font-size: 15px;
  flex-shrink: 0;
}
.crm-list-title { font-weight: 600; font-size: 14px; color: #111; }
.crm-list-meta  { font-size: 12px; color: #888; margin-top: 3px; }
/* Detail view */
.crm-back-btn {
  border: none;
  background: none;
  color: #0e5071;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 12px 20px 0;
  display: block;
}
.crm-back-btn:hover { text-decoration: underline; }
.crm-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}
.crm-detail-label {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}
.crm-detail-value { font-size: 14px; font-weight: 600; color: #111; }
.crm-detail-section { padding: 12px 20px; border-bottom: 1px solid #f0f0f0; }
.crm-detail-box {
  background: #f7f9fc;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #333;
  margin-top: 6px;
  line-height: 1.6;
}
.crm-list-intents {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.crm-tag {
  display: inline-block;
  background: #e8f0fe;
  color: #1a5276;
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 12px;
  font-weight: 600;
  margin: 4px 4px 0 0;
}
.crm-badge-inbound {
  background: #d4edda;
  color: #155724;
  border-radius: 4px;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 700;
  margin-left: 4px;
}
.crm-badge-outbound {
  background: #fff3cd;
  color: #856404;
  border-radius: 4px;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 700;
  margin-left: 4px;
}
.crm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
}
.crm-btn-close {
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 14px;
  cursor: pointer;
  color: #333;
}
.crm-btn-close:hover { background: #f5f5f5; }
.crm-btn-open {
  border: none;
  background: #0e5071;
  color: #fff;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.crm-btn-open:hover { background: #0c4160; }
.at-clickable { cursor: pointer; }
.at-clickable:hover { background: #f0f4f8 !important; }

/* ── ServiceNow Incidents ────────────────────────────────────────────────── */
.sn-incidents-wrap { margin-top: 10px; }

/* ── Activity Timeline ───────────────────────────────────────────────────── */
.activity-timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 6px;
}
.activity-timeline-title {
  font-size: 16px;
  font-weight: 600;
  color: #555;
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.activity-timeline-source {
  font-size: 14px;
  color: #666;
}
.activity-timeline-source-name {
  font-weight: 600;
  color: #555;
}
.activity-timeline-updated {
  font-size: 13px;
  color: #aaa;
}
.activity-timeline-list {
  display: flex;
  flex-direction: column;
}
.activity-timeline-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 6px 8px;
  border-bottom: 1px solid #dee2e6;
  gap: 8px;
}
.activity-timeline-item:nth-child(odd)  { background: #ffffff; }
.activity-timeline-item:nth-child(even) { background: #f5f7f9; }
.activity-timeline-item:last-child { border-bottom: none; }
.activity-timeline-item-left {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #444;
}
.activity-timeline-item-left > .fa {
  margin-top: 3px;
  color: #555;
  font-size: 14px;
  flex-shrink: 0;
}
.activity-timeline-item-title {
  font-weight: 600;
  color: #222;
  font-size: 14px;
}
.activity-timeline-item-meta {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}
.activity-timeline-item-time {
  font-size: 12px;
  color: #aaa;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── Synapsys Notes & Wrap ──────────────────────────────────────────────── */
.synapsys-notes-wrap h4 {
  font-size: 16px;
  font-weight: 600;
  color: #111;
}

#chat-bot-history {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 60%;
  margin: 20px auto;
  padding: 20px;
}

#chat-bot-history h2 {
  text-align: center;
  color: #333;
}

.message {
  display: flex;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 30px;
}

.message .user {
  width: 100px;
  font-weight: bold;
  text-transform: capitalize;
  margin-right: 10px;
}

.message .text {
  flex: 1;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
}

.message .timestamp {
  color: #888;
  font-size: 12px;
  text-align: right;
}

.message.caller .text {
  background-color: #a2a7ab;
  border: 1px solid #a2a7ab;
}

.message.bot .text {
  background-color: #0e5071;
  border: 1px solid #666;
  text-align: right;
}

.message.agent .text {
  background-color: #0e5071;
  border: 1px solid #666;
  text-align: right;
}

.bot .text {
  color: #fff;
}

.agent .text {
  color: #fff;
}

.caller .text {
  color: #fff;
}

.agent {
  color: #c45233;
  background-color: #0e5071;
}

.timestamp {
  display: flex;
  align-items: end;
}

.flex-child {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 88vh;
  padding: 0;
  overflow-x: hidden !important;
}

#subheader {

  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  padding: 0px;
  margin-top: 0px;
  width: 100%;
  justify-content: space-around;
}

#subheader3 {
  padding: 0px;
  height: 0px;
}

#subheader2 {
  display: flex;
  flex-flow: column;
  align-self: flex-start;
}

#subheader span {
  width: 30%;
  padding: 8px;

}

#centerdiv {
  padding: 0 8px;
  margin-top: -25px;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  width: 100%;
  justify-content: space-around;
}

.containerdiv {
  display: flex;
  flex-flow: column;
  height: 98%;
  width: 30%;
  padding: 8px;
}

.containerdiv>* {
  padding: 8px;
}

.scrollablediv {

  max-height: 300px;
  margin-top: 18px;
  overflow-y: auto;
}

/* #containerdiv1 {
  margin-top: 34px !important;
}

#containerdiv2 {
  margin-top: -70px !important;
} */

#containerdiv3 {
  display: flex;

  visibility: visible;
  padding: 10px !important;
  margin-right: 18px;
  height: auto;
}


.sidebar {
  padding: 0;
  z-index: 999;
  visibility: hidden;
  width: 350px;
  height: auto;
  background: #ffffff;
  position: fixed;
  top: -30px;
  right: -350px;
  transition: right 0.3s ease;
}

.sidebar.active {
  right: -20px;
}

.tooltip {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);
}

.open-btn {
  border-right: none;
  background-color: white;
  position: relative;
  top: 15vh;
  right: 28px;
  /*42px */
  font-size: 24px;
}

.open-btn:hover {
  cursor: pointer;

}


h4 {
  margin: 10px 0;
}

caption {
  text-align: left;
  font-weight: 600;
  margin: 10px 0;
}

.member-number-label {
  margin: 10px 0;
}

header {
  display: flex;
  justify-content: space-between;
}

label {
  font-size: 1rem;
  margin: 0;
}

span {
  font-size: 1rem;
}




table {
  margin: 14px 0;
}

caption {
  text-align: left;
  font-weight: 600;
  margin: 10px 0;
}

select {
  display: block;
  width: 100%;
}

textarea {
  display: block;
  width: 100%;
}




.solid-border {
  border: 1px solid black;
}

.member-info {
  display: flex;
}

/* .member-info span:first-of-type {
  width: 420px;
} */

.member-info-container {
  display: grid;
  grid-template-columns: 750px 1fr;
}

.member-info-table {
  width: 100% !important;
  display: flex;
  flex-direction: column;
}

.member-info-table tr {
  display: flex;
}

.member-info-table th,
.member-info-table td {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 5px;
}

.member-number-label {
  display: block;
}

.numberbadge {

  display: block;
  align-content: center;
  margin-left: 10px;
  text-align: center;
  width: 2em;
  height: 2em;
  border-radius: 24px;
  color: white;
  background-color: #0e5071;
  text-decoration: none;
}

.numberbadge:hover {
  cursor: pointer;
}



.btn-auth-group {


  display: flex;
  flex-flow: row;
  justify-content: space-evenly
}

.btn-manually-auth,
.btn-manually-failed {
  width: 50%;
  height: 50px;
  background-color: #a2a7ab;
  box-shadow: 2px 4px #ccc;
  border-radius: 20px;
  border: 0;
  margin: 0 12px 0 0;

}

.btn-save {
  margin-top: 7px;
}

.warning-code-col {
  align-self: center;

}

#warning-code-container {
  height: auto;
  margin-top: 0px;
  width: 100%;
}

.border-black {
  border: 1px solid black;
}

.description {
  font: -webkit-control;
}

.body-container {
  align-self: unset;
  height: auto;
  width: auto;
  min-height: calc(100vh - 16vh);
  /* height: 100%; */
  /* min-width: 1800px; */
}

.row {
  margin-bottom: 1rem;
}

.col {
  display: grid;
}

.col>div:nth-of-type(2) {
  justify-self: flex-end;
  height: 44px;
}

.col-left {
  display: inline-block;
  width: 400px;
  float: left;
}

.col-right {
  display: inline-block;
}

.select-categories {

  font-size: medium;
  padding: 5px;
}

#note-category {
  width: 98%;
}

.btn-clicked-green {
  background-color: #33cc66;
}

.btn-clicked-red {
  background-color: red;
}

.container {
  display: flex;
  justify-content: flex-end;
}

.form {
  display: flex;
  align-items: center;
}

.button-disabled {
  /* Apply your disabled button styles here */
  box-shadow: 2px 4px #ccc;
  background-color: gray;
  color: white;
  cursor: not-allowed;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Adjust the opacity/darkness as needed */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  /* Adjust the z-index as needed */
}

.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-text-large {
  font-size: 15px;
  color: white;
}

.btn {
  box-shadow: 2px 4px #ccc;
  margin: 0 5px;
  padding: 7px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 5px;
  border: 0;
  width: 70px;
}

.btn-cancel {
  margin-left: 10px;
}



.warning-code-table {
  /* width: fit-content !important; */
  /* width: 330px !important; */
  width: 100%;
}

.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  position: relative;
  z-index: 2;
  /* Higher than the overlay */
  text-align: center;
}

.modal-image {
  max-width: 100%;
  height: auto;
  cursor: pointer;
  /* Add this to show a pointer cursor on the image */
}

.membernumber-icon {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-bottom: 4px;
  /* margin-left: -8px; */
  padding-right: 4px;
  /* Add this to show a pointer cursor on the image */
}

#copymemberbtn {
  border: none;
  background: white;
  vertical-align: middle;
  margin-bottom: 4px;
}

#copyidbtn {
  border: none;
  background: white;
  vertical-align: middle;
  margin-bottom: 4px;
}

.arrow {
  transform: translateX(1px);
  transform: translateY(1px);
}

.ttcopyidbtn {
  visibility: hidden;
  max-width: 300px;
  background-color: #3b3b3b;
  color: #ffffff;
  margin-top: 80px;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  opacity: 0;
  font-size: 14px;

}

@keyframes fade {
  0% {
    opacity: 0;
  }

  90% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.ttcopymembtn {
  visibility: hidden;
  max-width: 300px;
  background-color: #3b3b3b;
  color: #ffffff;
  margin-top: 35px;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  opacity: 0;
  font-size: 14px;
}

#copymemberbtn:hover .ttcopymembtn {
  animation: fade 1s ease-in forwards;
  visibility: visible;
  opacity: 1;
}

#copyidbtn:hover .ttcopyidbtn {
  animation: fade 1s ease-in forwards;
  visibility: visible;
  opacity: 1;
}

.copyidbtn_class {
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  border-radius: 4px;
  padding: 0 6px 0 6px;
  background-color: #646464;
  color: white;
  border: none;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}



.box {
  position: relative;
  padding: 0px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 0px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}



#logocontainer {}

#subheader2 .close {
  position: absolute;
  top: 100px;
  /* Adjust the top position as needed */
  right: 190px;
  /* Adjust the right position as needed */
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
}

/* Adding Styling for 2FA */

/* Whole 2FA Container */
.flex-container {
  display: flex;
  justify-content: flex-end;
  width: 97% !important;
}

/* 2FA Border and Label */
.two-fa-container {
  border: 2px solid #767676;
  padding: 20px;
  border-radius: 5px;
  height: fit-content;
  width: 100%;
  box-shadow: 2px 4px #ccc;
}

.two-fa-container>.flex {
  width: 100%;
  margin-top: -35px;
}

.two-fa-container:hover {
  border: 2px solid rgba(0, 0, 0, 0.87);
}


.opt-in-group {
  width: 100%;
}

.opt-in-group select {
  width: 30%;
  margin-right: 10px
}

.opt-in-group button {
  width: 100px;
}

.opt-in-input-group {
  display: flex;
  align-items: center;
}

.send-message-group {
  width: 100%;
  margin-bottom: 10px;
}

.send-message-group select {
  margin-bottom: 12px;
  margin-top: 10px;
}

.two-fa-label {
  position: relative;
  top: -40px;
  /* Adjust this value to place the label correctly */
  left: -10px;
  /* Adjust this value to center the label */
  background: white;
  /* Same color as the container background */
  padding: 0 5px;
  /* Small padding to create space around the text */
  font-size: 14px;
  width: 25px;
  /* Adjust font size as needed */
}

/* End of 2FA Border and Label */

.flex-container,
#warning-code-container {
  width: 94%;
}

.flex {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.otp-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.verification-status {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.status-icon {

  width: 27px;
  height: 27px;
}

/* Radio Buttons Style */
.radiolist {
  display: flex;
}

.radiolist div {
  padding-right: 1rem;
  padding-bottom: .5rem;
}

.radiolist div input[type="radio"] {
  margin: 0 !important;
  margin-right: 6px !important;
  padding: 0 !important;
  width: auto;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: fixed;
  z-index: 1051;
  left: 50%;
  top: 50px;
  transform: translateX(-50%);
  width: auto;
  margin: 0;
  pointer-events: none;
}

.modal-lg {
  max-width: 800px;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  background-color: #ffffff;
  /* Updated color */
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #fff;
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  background-color: #fff;
  /* Updated color */
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  /* Updated color */
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  pointer-events: auto;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
  overflow-y: auto;
}

.modal-open {
  overflow: hidden;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.modal-backdrop.show {
  opacity: 1;
  pointer-events: auto;
}

dialog {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0;
  position: fixed;
  /* left: -10px; */
  margin-left: 25px;
  top: 25%;
  background-color: #fff;
  z-index: 100;
  box-shadow: 2px 4px #ccc;
  border: 2px solid #767676;
}

.dialog-header {
  margin: 0;
  margin-bottom: 16px;
  font-size: 16px;
}

.dialog-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: -10;
}

.dialog-body {
  z-index: 10;
  background-color: #fff;
  padding: 2rem;
  /* border-radius: 6.4px; */
  overflow-y: auto;
  /* Add a vertical scroll bar when content exceeds the height */
  max-height: 80vh;
  /* Limit the maximum height of the dialog body */
}

.screen-pop-sm {
  display: none;
}

.account-link {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}


.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable-row:hover {
  background-color: #f0f0f0;
}

.clickable-row.selected {
  background-color: #e0e0e0;
}

@media only screen and (min-width: 800px) and (max-width: 1200px) {

  .sidebar {
    visibility: visible;
  }

  /* #security-notes{
    margin-top: 182px !important;
  } */
 .navigation-path-container{
    margin-top: 182px !important;
 }
  #centerdiv {
    width: 100%;
    padding: 12px;
    justify-content: start;
  }

  #containerdiv1 {
    flex: 0 0 40%;
    max-width: 40%;
  }

  #containerdiv2 {
    flex: 0 0 55%;
    max-width: 55%;
  }

  #containerdiv3 {
    /* margin-top: -300px; */
    flex: 0 0 40%;
    max-width: 40%;
    margin-left: 0;
    margin-top: -200px !important;
    flex-direction: column;
  }

  #warning-code-container {
    margin-top: 0;
  }

  #subheader1 {
    flex-basis: 45%;
  }

  #subheader2 {
    flex-basis: 45%;
  }

  #subheader3 {
    display: none;
  }
}

header>div {

  padding-top: 10px;

}

@media only screen and (max-width: 800px) {

  .sidebar {
    visibility: visible;
  }

  .sidebar.active {
    right: -10px;
  }

  #security-notes{
    margin-top: 20px !important;
  }

  #centerdiv {
    margin-top: 0px;
  }

  #containerdiv1 {
    flex-basis: 100%;
    margin: -20px 0px 0px !important;
    padding: 0px;
  }

  #containerdiv2 {
    flex-basis: 100%;
    margin: 0px !important;
    padding: 0px;
  }

  #containerdiv3 {
    visibility: visible;
    flex-basis: 100%;
    margin: 20px 0px 0px !important;
    padding: 0px;
  }

  #subheader1 {
    flex-basis: 100%;
    padding: 0px;
  }

  #subheader2 {
    flex-basis: 100%;
    padding: 0px;
  }

  #subheader3 {
    display: none;
    /* flex-basis: 100%;
    padding: 0px; */
  }

  .membernumber-icon {
    width: 15px;
    height: 15px;
    vertical-align: middle;
    /* Add this to show a pointer cursor on the image */
  }

  

  .body-container {
    padding-left: 0px;
    padding-right: 12px;
  }

  .flex-container,
  #warning-code-container {
    width: 95%;
  }

  #phonenum_list {
    display: block;
    font-size: 14px;
    line-height: 1;
  }




  header {
    padding-left: 15px;
  }

  .screen-pop-lg {
    display: none;
  }

  .screen-pop-sm {
    font-size: 1rem;
    display: block;
  }

  #authstatus_value {
    font-size: 0.9em;
  }
}
</style>
